(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire04be"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire04be"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kOSvo", function(module, exports) {
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if (module.exports) {
    const Flickity = (parcelRequire("jjyi3"));
    (parcelRequire("4rQin"));
    (parcelRequire("efu2y"));
    (parcelRequire("8g8T3"));
    (parcelRequire("klPoO"));
    (parcelRequire("1zLnv"));
    (parcelRequire("lDN2j"));
    (parcelRequire("uiIaT"));
    module.exports = Flickity;
}

});
parcelRegister("jjyi3", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("9XKhI")), (parcelRequire("h1C3a")), (parcelRequire("4JL6u")), (parcelRequire("1dCt0")), (parcelRequire("hiZ9L")), (parcelRequire("bx2zr")));
    else {
        // browser global
        let _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    const { getComputedStyle: getComputedStyle, console: console } = window1;
    let { jQuery: jQuery } = window1;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    let GUID = 0;
    // internal store of all Flickity intances
    let instances = {};
    function Flickity(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = {
            ...this.constructor.defaults
        };
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    let proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        let { resize: resize, watchCSS: watchCSS, rightToLeft: rightToLeft } = this.options;
        // add id for Flickity.data
        let id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
        this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(let eventName in this.options.on){
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(let method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        this.slider.append(...cellElems);
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        let slider = document.createElement('div');
        slider.className = 'flickity-slider';
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        let cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map((cellElem)=>new Cell(cellElem));
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach((cell)=>{
            cell.x = cellX;
            this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        let sideOffset = this.options.rightToLeft ? -1 : 1;
        let renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        let positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = `translateX( ${positionValue} )`;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach((cell)=>cell.getSize());
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        let { beginMargin: beginMargin, endMargin: endMargin } = this;
        let slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        let canCellFit = this._getCanCellFit();
        this.cells.forEach((cell, i)=>{
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        let { groupCells: groupCells } = this.options;
        if (!groupCells) return ()=>false;
        if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return (i)=>i % number !== 0;
        }
        // default, group by width of slide
        let percent = 1;
        // parse '75%
        let percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        let groupWidth = (this.size.innerWidth + 1) * percent;
        return (i, slideWidth)=>slideWidth <= groupWidth;
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    let cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        let { cellAlign: cellAlign, rightToLeft: rightToLeft } = this.options;
        let shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${height}px`;
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let beforeGapX = this.cursorPosition;
        let lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        let afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        let { wrapAround: wrapAround } = this.options;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== 'fill') return true;
        // check that slides can fit
        let gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        // check that content width - shifting cell is bigger than viewport width
        for (let cell of this.cells){
            if (cell.size.outerWidth > gapWidth) return false;
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while(gapX > 0){
            let cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach((slide)=>{
            slide.target = contentWidth * this.cellAlign;
        });
        else {
            // contain to bounds
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide)=>{
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        let emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    const unidraggerEvents = [
        'dragStart',
        'dragMove',
        'dragEnd',
        'pointerDown',
        'pointerMove',
        'pointerEnd',
        'staticClick'
    ];
    let _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === 'staticClick') {
            // add cellElem and cellIndex args to staticClick
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        let isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
        let event = args.shift(0);
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        const { selectedIndex: selectedIndex, slideableWidth: slideableWidth, slides: { length: length } } = this;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            let wrapIndex = utils.modulo(index, length);
            // go to shortest
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) return;
        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        let cellSlide = this.slides.find((slide)=>slide.cells.includes(cell));
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for (let cell of this.cells){
            if (cell.element === elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        return elems.map((elem)=>this.getCell(elem)).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        let closest = elem.closest('.flickity-slider > *');
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        let len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        let cellElems = [];
        for(let i = index - adjCount; i <= index + adjCount; i++){
            let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        let isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        let afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes('flickity')) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        let { activeElement: activeElement } = document;
        let handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        let isFocused = this.focusableElems.some((elem)=>activeElement === elem);
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this[leftMethod]();
        },
        ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach((cell)=>cell.destroy());
        this.viewport.remove();
        // move child elements back into element
        this.element.append(...this.slider.children);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, 'flickity');
    let { jQueryBridget: jQueryBridget } = window1;
    if (jQuery && jQueryBridget) jQueryBridget('flickity', Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("9XKhI", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("h1C3a", function(module, exports) {
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    let measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    let measurementsLength = measurements.length;
    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach((measurement)=>{
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        let isElement = elem && typeof elem == 'object' && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        measurements.forEach((measurement)=>{
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("4JL6u", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener('DOMContentLoaded', onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = 'data-' + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("1dCt0", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("h1C3a")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(getSize) {
    const cellClassName = 'flickity-cell';
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    let proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("hiZ9L", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != 'undefined' ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    let proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach((cell)=>cell.select());
    };
    proto.unselect = function() {
        this.cells.forEach((cell)=>cell.unselect());
    };
    proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    return Slide;
});

});

parcelRegister("bx2zr", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("4JL6u")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    let proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(()=>this.animate());
    };
    proto.positionSlider = function() {
        let x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
    };
    proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell)=>{
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell)=>this._wrapShiftCell(cell, 0));
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("4rQin", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("jjyi3")), (parcelRequire("gjy6R")), (parcelRequire("4JL6u")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    let proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = '';
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        this.on('pointerDown', this.handlePointerDown);
        this.on('pointerUp', this.handlePointerUp);
        this.on('pointerDown', this.handlePointerDone);
        this.on('dragStart', this.handleDragStart);
        this.on('dragMove', this.handleDragMove);
        this.on('dragEnd', this.handleDragEnd);
        this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle('is-draggable', this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        let isTouchStart = event.type === 'touchstart';
        let isTouchPointer = event.pointerType === 'touch';
        let isFocusNode = event.target.matches('input, textarea, select');
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        let dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let { freeScroll: freeScroll } = this.options;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        (dist, minDist)=>dist <= minDist : (dist, minDist)=>dist < minDist;
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("gjy6R", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("9XKhI")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    let startEvent, activeEvents;
    if ('ontouchstart' in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        activeEvents = [
            'touchmove',
            'touchend',
            'touchcancel'
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = 'pointerdown';
        activeEvents = [
            'pointermove',
            'pointerup',
            'pointercancel'
        ];
    } else {
        // mouse events
        startEvent = 'mousedown';
        activeEvents = [
            'mousemove',
            'mouseup'
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = 'none';
    proto.bindHandles = function() {
        this._bindHandles('addEventListener', this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles('removeEventListener', '');
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle)=>{
            handle[bindMethod](startEvent, this);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.addEventListener(eventName, this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.removeEventListener(eventName, this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches)if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    const cursorNodes = [
        'TEXTAREA',
        'INPUT',
        'SELECT',
        'OPTION'
    ];
    // input types that do not have text fields
    const clickTypes = [
        'radio',
        'checkbox',
        'button',
        'submit',
        'image',
        'file'
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer('pointerMove', event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch('pointerMove', event);
    };
    proto.pointerMove = function(event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer('pointerUp', event);
    };
    proto.ontouchend = function(event) {
        this.withTouch('pointerUp', event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(()=>delete this.isPreventingClicks);
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent('pointerDone');
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer('pointerCancel', event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch('pointerCancel', event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        let isMouseup = event.type === 'mouseup';
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(()=>{
                delete this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});


parcelRegister("efu2y", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("jjyi3")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    const svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === 'previous';
        this.isLeft = direction === 'left';
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        let element = this.element = document.createElement('button');
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? 'Previous' : 'Next';
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        element.setAttribute('aria-label', label);
        // init as disabled
        this.disable();
        // create arrow
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        // add title #1189
        let title = document.createElementNS(svgURI, 'title');
        title.append(label);
        // add path
        let path = document.createElementNS(svgURI, 'path');
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180)');
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        let { x0: x0, x1: x1, x2: x2, x3: x3, y1: y1, y2: y2 } = shape;
        // create movement string
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute('disabled');
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute('disabled', true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft: rightToLeft, arrowShape: arrowShape } = this.options;
        let prevDirection = rightToLeft ? 'right' : 'left';
        let nextDirection = rightToLeft ? 'left' : 'right';
        this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
        this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = ()=>{
            this.uiChange();
            this.previous();
        };
        this.handleNextButtonClick = ()=>{
            this.uiChange();
            this.next();
        };
        this.on('activate', this.activatePrevNextButtons);
        this.on('select', this.updatePrevNextButtons);
    };
    let proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? 'enable' : 'disable']();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("8g8T3", function(module, exports) {


// page dots
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("jjyi3")), (parcelRequire("4JL6u")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement('div');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        let delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i)=>{
            let dot = document.createElement('button');
            dot.setAttribute('type', 'button');
            let num = i + 1 + this.dots.length;
            dot.className = 'flickity-page-dot';
            dot.textContent = `View slide ${num}`;
            return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach((dot)=>dot.remove());
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove('is-selected');
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add('is-selected');
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    let proto = Flickity.prototype;
    proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot)=>{
            utils.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("klPoO", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("jjyi3")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state !== 'playing') return;
        // default to 3 seconds
        let time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(()=>{
            this.onTick();
            this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        this.player = new Player(this.options.autoPlay, ()=>{
            this.next(true);
        });
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    let proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("1zLnv", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("jjyi3")), (parcelRequire("4JL6u")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell)=>fragment.appendChild(cell.element));
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    let proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach((cell)=>{
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        let cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("lDN2j", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("jjyi3")), (parcelRequire("4JL6u")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    const lazyAttr = 'data-flickity-lazyload';
    const lazySrcAttr = `${lazyAttr}-src`;
    const lazySrcsetAttr = `${lazyAttr}-srcset`;
    const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
    Flickity.create.lazyLoad = function() {
        this.on('select', this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    let proto = Flickity.prototype;
    proto.lazyLoad = function() {
        let { lazyLoad: lazyLoad } = this.options;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img)=>new LazyLoader(img, this.handleLazyLoadComplete));
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches('img')) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return [
            ...cellElem.querySelectorAll(imgSelector)
        ];
    }
    proto.onLazyLoadComplete = function(img, event) {
        let cell = this.getParentCell(img);
        let cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        let mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("uiIaT", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("jjyi3")), (parcelRequire("k2Jbt")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        let onImagesLoadedProgress = (instance, image)=>{
            let cell = this.getParentCell(image.img);
            this.cellSizeChange(cell && cell.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("k2Jbt", function(module, exports) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("9XKhI")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});



parcelRegister("g0Kki", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !!timeScale; // as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, reverseEase = vars.easeReverse || yoyoEase, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._rEase = reverseEase && (_parseEase(reverseEase) || tween._ease);
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (tween._from) tween.ratio = 1;
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) // from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset. Try splitting into individual properties") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            var easeReverse = vars.easeReverse || vars.yoyoEase;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    easeReverse && (copy.easeReverse = easeReverse);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) time = dur - time;
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) //repeatRefresh functionality
                {
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            if (this._rEase) {
                var inv = time < prevTime;
                if (inv !== this._inv) {
                    var segDur = inv ? prevTime : dur - prevTime;
                    this._inv = inv;
                    if (this._from) this.ratio = 1 - this.ratio;
                    this._invRatio = this.ratio;
                    this._invTime = prevTime;
                    this._invRecip = segDur ? (inv ? -1 : 1) / segDur : 0;
                    this._invScale = inv ? -this.ratio : 1 - this.ratio;
                    this._invEase = inv ? this._rEase : this._ease;
                }
                this.ratio = ratio = this._invRatio + this._invScale * this._invEase((time - this._invTime) * this._invRecip);
            } else this.ratio = ratio = this._ease(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.15.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

var $d71cc70720d4b653$exports = {};
!function(n, t) {
    $d71cc70720d4b653$exports = t();
}($d71cc70720d4b653$exports, function() {
    "use strict";
    function n() {
        return n = Object.assign || function(n) {
            for(var t = 1; t < arguments.length; t++){
                var e = arguments[t];
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
            }
            return n;
        }, n.apply(this, arguments);
    }
    var t = "undefined" != typeof window, e = t && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), i = t && "IntersectionObserver" in window, o = t && "classList" in document.createElement("p"), a = t && window.devicePixelRatio > 1, r = {
        elements_selector: ".lazy",
        container: e || t ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, c = function(t) {
        return n({}, r, t);
    }, l = function(n, t) {
        var e, i = "LazyLoad::Initialized", o = new n(t);
        try {
            e = new CustomEvent(i, {
                detail: {
                    instance: o
                }
            });
        } catch (n) {
            (e = document.createEvent("CustomEvent")).initCustomEvent(i, !1, !1, {
                instance: o
            });
        }
        window.dispatchEvent(e);
    }, u = "src", s = "srcset", d = "sizes", f = "poster", _ = "llOriginalAttrs", g = "data", v = "loading", b = "loaded", p = "applied", m = "error", h = "native", E = "data-", I = "ll-status", y = function(n, t) {
        return n.getAttribute(E + t);
    }, k = function(n) {
        return y(n, I);
    }, w = function(n, t) {
        return function(n, t, e) {
            var i = "data-ll-status";
            null !== e ? n.setAttribute(i, e) : n.removeAttribute(i);
        }(n, 0, t);
    }, A = function(n) {
        return w(n, null);
    }, L = function(n) {
        return null === k(n);
    }, O = function(n) {
        return k(n) === h;
    }, x = [
        v,
        b,
        p,
        m
    ], C = function(n, t, e, i) {
        n && "function" == typeof n && (void 0 === i ? void 0 === e ? n(t) : n(t, e) : n(t, e, i));
    }, N = function(n, t) {
        o ? n.classList.add(t) : n.className += (n.className ? " " : "") + t;
    }, M = function(n, t) {
        o ? n.classList.remove(t) : n.className = n.className.replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
    }, z = function(n) {
        return n.llTempImage;
    }, T = function(n, t) {
        if (t) {
            var e = t._observer;
            e && e.unobserve(n);
        }
    }, R = function(n, t) {
        n && (n.loadingCount += t);
    }, G = function(n, t) {
        n && (n.toLoadCount = t);
    }, j = function(n) {
        for(var t, e = [], i = 0; t = n.children[i]; i += 1)"SOURCE" === t.tagName && e.push(t);
        return e;
    }, D = function(n, t) {
        var e = n.parentNode;
        e && "PICTURE" === e.tagName && j(e).forEach(t);
    }, H = function(n, t) {
        j(n).forEach(t);
    }, V = [
        u
    ], F = [
        u,
        f
    ], B = [
        u,
        s,
        d
    ], J = [
        g
    ], P = function(n) {
        return !!n[_];
    }, S = function(n) {
        return n[_];
    }, U = function(n) {
        return delete n[_];
    }, $ = function(n, t) {
        if (!P(n)) {
            var e = {};
            t.forEach(function(t) {
                e[t] = n.getAttribute(t);
            }), n[_] = e;
        }
    }, q = function(n, t) {
        if (P(n)) {
            var e = S(n);
            t.forEach(function(t) {
                !function(n, t, e) {
                    e ? n.setAttribute(t, e) : n.removeAttribute(t);
                }(n, t, e[t]);
            });
        }
    }, K = function(n, t, e) {
        N(n, t.class_applied), w(n, p), e && (t.unobserve_completed && T(n, t), C(t.callback_applied, n, e));
    }, Q = function(n, t, e) {
        N(n, t.class_loading), w(n, v), e && (R(e, 1), C(t.callback_loading, n, e));
    }, W = function(n, t, e) {
        e && n.setAttribute(t, e);
    }, X = function(n, t) {
        W(n, d, y(n, t.data_sizes)), W(n, s, y(n, t.data_srcset)), W(n, u, y(n, t.data_src));
    }, Y = {
        IMG: function(n, t) {
            D(n, function(n) {
                $(n, B), X(n, t);
            }), $(n, B), X(n, t);
        },
        IFRAME: function(n, t) {
            $(n, V), W(n, u, y(n, t.data_src));
        },
        VIDEO: function(n, t) {
            H(n, function(n) {
                $(n, V), W(n, u, y(n, t.data_src));
            }), $(n, F), W(n, f, y(n, t.data_poster)), W(n, u, y(n, t.data_src)), n.load();
        },
        OBJECT: function(n, t) {
            $(n, J), W(n, g, y(n, t.data_src));
        }
    }, Z = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], nn = function(n, t) {
        !t || function(n) {
            return n.loadingCount > 0;
        }(t) || function(n) {
            return n.toLoadCount > 0;
        }(t) || C(n.callback_finish, t);
    }, tn = function(n, t, e) {
        n.addEventListener(t, e), n.llEvLisnrs[t] = e;
    }, en = function(n, t, e) {
        n.removeEventListener(t, e);
    }, on = function(n) {
        return !!n.llEvLisnrs;
    }, an = function(n) {
        if (on(n)) {
            var t = n.llEvLisnrs;
            for(var e in t){
                var i = t[e];
                en(n, e, i);
            }
            delete n.llEvLisnrs;
        }
    }, rn = function(n, t, e) {
        !function(n) {
            delete n.llTempImage;
        }(n), R(e, -1), function(n) {
            n && (n.toLoadCount -= 1);
        }(e), M(n, t.class_loading), t.unobserve_completed && T(n, e);
    }, cn = function(n, t, e) {
        var i = z(n) || n;
        on(i) || function(n, t, e) {
            on(n) || (n.llEvLisnrs = {});
            var i = "VIDEO" === n.tagName ? "loadeddata" : "load";
            tn(n, i, t), tn(n, "error", e);
        }(i, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_loaded), w(t, b), C(e.callback_loaded, t, i), o || nn(e, i);
            }(0, n, t, e), an(i);
        }, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_error), w(t, m), C(e.callback_error, t, i), e.restore_on_error && q(t, B), o || nn(e, i);
            }(0, n, t, e), an(i);
        });
    }, ln = function(n, t, e) {
        !function(n) {
            return Z.indexOf(n.tagName) > -1;
        }(n) ? function(n, t, e) {
            !function(n) {
                n.llTempImage = document.createElement("IMG");
            }(n), cn(n, t, e), function(n) {
                P(n) || (n[_] = {
                    backgroundImage: n.style.backgroundImage
                });
            }(n), function(n, t, e) {
                var i = y(n, t.data_bg), o = y(n, t.data_bg_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = 'url("'.concat(r, '")'), z(n).setAttribute(u, r), Q(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_multi), o = y(n, t.data_bg_multi_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = r, K(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_set);
                if (i) {
                    var o = i.split("|"), a = o.map(function(n) {
                        return "image-set(".concat(n, ")");
                    });
                    n.style.backgroundImage = a.join(), "" === n.style.backgroundImage && (a = o.map(function(n) {
                        return "-webkit-image-set(".concat(n, ")");
                    }), n.style.backgroundImage = a.join()), K(n, t, e);
                }
            }(n, t, e);
        }(n, t, e) : function(n, t, e) {
            cn(n, t, e), function(n, t, e) {
                var i = Y[n.tagName];
                i && (i(n, t), Q(n, t, e));
            }(n, t, e);
        }(n, t, e);
    }, un = function(n) {
        n.removeAttribute(u), n.removeAttribute(s), n.removeAttribute(d);
    }, sn = function(n) {
        D(n, function(n) {
            q(n, B);
        }), q(n, B);
    }, dn = {
        IMG: sn,
        IFRAME: function(n) {
            q(n, V);
        },
        VIDEO: function(n) {
            H(n, function(n) {
                q(n, V);
            }), q(n, F), n.load();
        },
        OBJECT: function(n) {
            q(n, J);
        }
    }, fn = function(n, t) {
        (function(n) {
            var t = dn[n.tagName];
            t ? t(n) : function(n) {
                if (P(n)) {
                    var t = S(n);
                    n.style.backgroundImage = t.backgroundImage;
                }
            }(n);
        })(n), function(n, t) {
            L(n) || O(n) || (M(n, t.class_entered), M(n, t.class_exited), M(n, t.class_applied), M(n, t.class_loading), M(n, t.class_loaded), M(n, t.class_error));
        }(n, t), A(n), U(n);
    }, _n = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], gn = function(n) {
        return n.use_native && "loading" in HTMLImageElement.prototype;
    }, vn = function(n, t, e) {
        n.forEach(function(n) {
            return function(n) {
                return n.isIntersecting || n.intersectionRatio > 0;
            }(n) ? function(n, t, e, i) {
                var o = function(n) {
                    return x.indexOf(k(n)) >= 0;
                }(n);
                w(n, "entered"), N(n, e.class_entered), M(n, e.class_exited), function(n, t, e) {
                    t.unobserve_entered && T(n, e);
                }(n, e, i), C(e.callback_enter, n, t, i), o || ln(n, e, i);
            }(n.target, n, t, e) : function(n, t, e, i) {
                L(n) || (N(n, e.class_exited), function(n, t, e, i) {
                    e.cancel_on_exit && function(n) {
                        return k(n) === v;
                    }(n) && "IMG" === n.tagName && (an(n), function(n) {
                        D(n, function(n) {
                            un(n);
                        }), un(n);
                    }(n), sn(n), M(n, e.class_loading), R(i, -1), A(n), C(e.callback_cancel, n, t, i));
                }(n, t, e, i), C(e.callback_exit, n, t, i));
            }(n.target, n, t, e);
        });
    }, bn = function(n) {
        return Array.prototype.slice.call(n);
    }, pn = function(n) {
        return n.container.querySelectorAll(n.elements_selector);
    }, mn = function(n) {
        return function(n) {
            return k(n) === m;
        }(n);
    }, hn = function(n, t) {
        return function(n) {
            return bn(n).filter(L);
        }(n || pn(t));
    }, En = function(n, e) {
        var o = c(n);
        this._settings = o, this.loadingCount = 0, function(n, t) {
            i && !gn(n) && (t._observer = new IntersectionObserver(function(e) {
                vn(e, n, t);
            }, function(n) {
                return {
                    root: n.container === document ? null : n.container,
                    rootMargin: n.thresholds || n.threshold + "px"
                };
            }(n)));
        }(o, this), function(n, e) {
            t && (e._onlineHandler = function() {
                !function(n, t) {
                    var e;
                    (e = pn(n), bn(e).filter(mn)).forEach(function(t) {
                        M(t, n.class_error), A(t);
                    }), t.update();
                }(n, e);
            }, window.addEventListener("online", e._onlineHandler));
        }(o, this), this.update(e);
    };
    return En.prototype = {
        update: function(n) {
            var t, o, a = this._settings, r = hn(n, a);
            G(this, r.length), !e && i ? gn(a) ? function(n, t, e) {
                n.forEach(function(n) {
                    -1 !== _n.indexOf(n.tagName) && function(n, t, e) {
                        n.setAttribute("loading", "lazy"), cn(n, t, e), function(n, t) {
                            var e = Y[n.tagName];
                            e && e(n, t);
                        }(n, t), w(n, h);
                    }(n, t, e);
                }), G(e, 0);
            }(r, a, this) : (o = r, function(n) {
                n.disconnect();
            }(t = this._observer), function(n, t) {
                t.forEach(function(t) {
                    n.observe(t);
                });
            }(t, o)) : this.loadAll(r);
        },
        destroy: function() {
            this._observer && this._observer.disconnect(), t && window.removeEventListener("online", this._onlineHandler), pn(this._settings).forEach(function(n) {
                U(n);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function(n) {
            var t = this, e = this._settings;
            hn(n, e).forEach(function(n) {
                T(n, t), ln(n, e, t);
            });
        },
        restoreAll: function() {
            var n = this._settings;
            pn(n).forEach(function(t) {
                fn(t, n);
            });
        }
    }, En.load = function(n, t) {
        var e = c(t);
        ln(n, e);
    }, En.resetStatus = function(n) {
        A(n);
    }, t && function(n, t) {
        if (t) {
            if (t.length) for(var e, i = 0; e = t[i]; i += 1)l(n, e);
            else l(n, t);
        }
    }(En, window.lazyLoadOptions), En;
});


function $53b8a3695c15066f$export$2e2bcd8739ae039(el) {
    for(let x = 0; x < el.length; ++x){
        let element = el[x];
        let links = element.querySelectorAll("a");
        for(let i = 0; i < links.length; ++i){
            let link = links[i];
            let linkParent = link.parentNode;
            let theString = link.innerHTML.toLowerCase();
            if (theString.indexOf("svg") >= 0) return true;
            else {
                switch(theString){
                    case "facebook":
                        if (element.classList.contains("circle")) theString = '<svg class="social-facebook" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15C6.7,30,0,23.3,0,15C0,6.7,6.7,0,15,0C23.3,0,30,6.7,30,15z M16.3,9.8c0-1,0.2-1.7,1.5-1.7h2L20,4.6c0,0-1-0.2-2.8-0.2c-3.7,0-5.3,2.2-5.3,4.7c0,1.6,0,3.4,0,3.4H9.4v3.7h2.5v9.4h4.4v-9.4h3.5l0.2-3.7h-3.8V9.8z"/></svg>';
                        else theString = '<svg class="social-facebook" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-484 486 30 30" xml:space="preserve"><path d="M-472.7,502.3h-3.8v-5h3.8v-4.4c0-3.5,2.2-6.9,7.5-6.9c2.1,0,3.8,0.3,3.8,0.3l-0.2,4.7h-3.2c-1.9,0-2.2,1-2.2,2.5v3.8h5.6l-0.4,5h-5.2V516h-5.6V502.3z"/></svg>';
                        break;
                    case "houzz":
                        if (element.classList.contains("circle")) theString = '<svg class="social-houzz" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96.03 166.33"><clipPath id="clip-path" transform="translate(0 -0.67)"><rect class="cls-1" width="516" height="167"/></clipPath><clipPath id="clip-path-2" transform="translate(0 -0.67)"><rect class="cls-1" y="0.67" width="515.73" height="166.27"/></clipPath><g class="cls-2"><polyline class="cls-3" points="48.02 0 0 27.72 0 83.17 48.02 55.44 48.02 0"/></g><g class="cls-4"><g class="cls-2"><polyline class="cls-3" points="0 83.17 0 138.61 48.02 110.88 0.01 83.17 0 83.17"/><polyline class="cls-3" points="48.02 110.88 48.02 166.33 96.03 138.6 96.03 83.17 48.02 110.88"/></g></g><g class="cls-2"><polyline class="cls-3" points="48.02 55.45 96.03 83.17 96.03 27.72 48.02 55.45"/><polyline class="cls-5" points="0.01 83.17 48.02 110.88 48.02 55.45 0.01 83.17"/><polyline class="cls-6" points="48.02 110.88 96.03 83.17 48.02 55.45 48.02 110.88"/></g></svg>';
                        else theString = '<svg class="social-houzz" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96.03 166.33"><clipPath id="clip-path" transform="translate(0 -0.67)"><rect class="cls-1" width="516" height="167"/></clipPath><clipPath id="clip-path-2" transform="translate(0 -0.67)"><rect class="cls-1" y="0.67" width="515.73" height="166.27"/></clipPath><g class="cls-2"><polyline class="cls-3" points="48.02 0 0 27.72 0 83.17 48.02 55.44 48.02 0"/></g><g class="cls-4"><g class="cls-2"><polyline class="cls-3" points="0 83.17 0 138.61 48.02 110.88 0.01 83.17 0 83.17"/><polyline class="cls-3" points="48.02 110.88 48.02 166.33 96.03 138.6 96.03 83.17 48.02 110.88"/></g></g><g class="cls-2"><polyline class="cls-3" points="48.02 55.45 96.03 83.17 96.03 27.72 48.02 55.45"/><polyline class="cls-5" points="0.01 83.17 48.02 110.88 48.02 55.45 0.01 83.17"/><polyline class="cls-6" points="48.02 110.88 96.03 83.17 48.02 55.45 48.02 110.88"/></g></svg>';
                        break;
                    case "twitter":
                        if (element.classList.contains("circle")) theString = '<svg id="twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.22 173.22"><defs><style>.cls-1{fill:#181b20;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}</style></defs><g id="OBJECTS"><circle class="cls-2" cx="86.61" cy="86.61" r="86.61" transform="translate(-35.87 86.61) rotate(-45)"/><path class="cls-1" d="M112.32,126.28h9.35L61.34,46.51h-10.03l61.01,79.77ZM118.24,36.94h16.87l-36.85,42.12,43.35,57.31h-33.94l-26.59-34.76-30.42,34.76h-16.88l39.42-45.05L31.61,36.94h34.81l24.03,31.77,27.79-31.77Z"/></g></svg>';
                        else theString = '<svg width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/></svg>';
                        break;
                    /*
            case "twitter":
              if (element.classList.contains("circle")) {
                theString =
                  '<svg class="social-twitter" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15C6.7,30,0,23.3,0,15S6.7,0,15,0C23.3,0,30,6.7,30,15z M26.3,9.5c-0.8,0.3-1.6,0.6-2.5,0.7c0.9-0.5,1.5-1.4,1.8-2.4c-0.8,0.5-1.7,0.8-2.7,1c-0.8-0.8-1.9-1.4-3.1-1.4c-2.4,0-4.2,1.9-4.2,4.3c0,0.3,0,0.7,0.1,1c-3.5-0.2-6.7-1.9-8.8-4.5c-0.3,0.7-0.6,1.4-0.6,2.2c0,1.5,0.7,2.8,1.9,3.5c-0.7,0-1.4-0.2-1.9-0.5v0c0,2.1,1.5,3.8,3.4,4.2c-0.3,0.1-0.7,0.1-1.1,0.1c-0.3,0-0.6,0-0.8-0.1c0.5,1.7,2.1,2.8,4,2.9c-1.5,1.1-3.3,1.9-5.3,1.9c-0.3,0-0.7,0-1-0.1c1.9,1.2,4.1,1.9,6.5,1.9c7.8,0,12.1-6.5,12.1-12.1c0-0.2,0-0.4,0-0.6C25,11.1,25.7,10.3,26.3,9.5z"/></svg>';
              } else {
                theString =
                  '<svg class="social-twitter" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.06 30"><path d="M28.74 8.42v.88c0 8.73-6.63 18.68-18.68 18.68-3.65 0-7.19-.77-10.06-2.65.55 0 .99.11 1.55.11 3.1 0 5.97-1.33 8.18-3.1-2.87 0-5.31-1.99-6.19-4.53.44 0 .77.11 1.22.11.55 0 1.22 0 1.77-.22-2.98-.55-5.31-3.32-5.31-6.52.88.44 1.88.77 2.98.77-1.77-1.22-2.98-3.21-2.98-5.42 0-1.22.33-2.21.88-3.21 3.32 3.98 8.18 6.41 13.6 6.74-.11-.44-.11-.99-.11-1.55 0-3.65 2.98-6.52 6.52-6.52 1.88 0 3.54.77 4.86 2.1 1.55-.33 2.87-.88 4.2-1.66-.44 1.57-1.54 2.9-2.87 3.67 1.33-.11 2.65-.55 3.76-.99-.88 1.21-1.99 2.43-3.32 3.31z"/></svg>';
              }
              break;
              */ case "instagram":
                        if (element.classList.contains("circle")) theString = '<svg fill="none" height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><clipPath id="a"><path d="m0 0h60v60h-60z"/></clipPath><g clip-path="url(#a)" fill="#fff3db"><path d="m47.0407 10.3093c-.821-.2662-1.6937-.2637-2.5467-.2313-.3846.0149-.7791.0572-1.0823.3209-.2836.2463-.4068.6045-.5178.9528-.2687.8458-.4955 1.7265-.6015 2.6122-.0962.8035.037 1.5772.5867 2.1917.5301.5921 1.3116.8831 2.0734 1.005.784.1269 1.6962.2712 2.4334-.102.6607-.3358 1.2055-1.005 1.5482-1.6543.3427-.6468.5449-1.3907.4931-2.1296-.111-1.5871-1.4497-3.0624-3.1015-2.948-.5867.0423-.5917.9678 0 .928 1.0256-.0722 1.9132.7239 2.1351 1.7091.249 1.107-.3205 2.2763-1.1267 3.0052-.503.4553-1.0799.4105-1.7135.3483-.6114-.0597-1.2474-.1692-1.7652-.5249-1.1193-.7687-.5941-2.3236-.3081-3.4058.0961-.3557.1799-.7364.3254-1.0772.138-.3234.4216-.2985.7297-.3085.7421-.0224 1.4793-.0298 2.1918.2015.5645.1816.8061-.7115.244-.8931z"/><path d="m45.2413 9.91876c-.9023-.09702-1.8293-.07463-2.4875.64684-.5991.6543-1.1193 1.5698-1.2648 2.4529-.143.8608.074 1.7887.7618 2.3609.6854.5697 1.6666.8857 2.4925 1.1792 1.4842.5299 3.7598.8558 4.6202-.8757.6977-1.4031.5966-3.4207-.5079-4.5849-.6928-.729-1.6863-.9877-2.6355-1.17675-.9615-.19156-1.9994-.36073-2.882.18655-.503.3135-.0419 1.1146.4635.8011.5892-.3657 1.2992-.2587 1.9476-.1368.6558.1244 1.351.2438 1.9378.5796 1.1119.6369 1.3535 2.045 1.0872 3.2167-.1503.6593-.4339 1.1941-1.1094 1.3956-.6336.1891-1.3066.0971-1.9328-.0671-.7273-.1916-1.4324-.4827-2.1203-.7887-.641-.286-1.1809-.6468-1.245-1.4105-.069-.811.3846-1.5798.8333-2.2166.212-.2986.4462-.5448.8111-.6369.397-.0995.8284-.0423 1.2302 0 .5868.0622.5819-.86573 0-.92793z"/><path d="m33.0654 20.1012c-3.9076-.9926-8.1604.8583-10.2782 4.2939-2.1868 3.5451-2.0956 8.7594.4191 12.1304 1.356 1.816 3.7647 2.3161 5.88 2.6196 2.0881.301 4.2823.2289 6.2152-.704 3.7917-1.8261 5.0022-6.4956 4.5289-10.4039-.5794-4.7815-4.1961-9.4734-9.4227-8.6699-.5818.0896-.3353.9827.2441.8931 4.2207-.6493 7.3197 3.0625 8.1062 6.8737.7026 3.4083.0813 7.7967-2.9437 9.9337-1.5877 1.122-3.5526 1.4031-5.4485 1.2862-1.7406-.1095-3.9841-.4304-5.4608-1.4355-1.6198-1.102-2.3668-3.4306-2.638-5.2939-.281-1.933-.0419-3.9829.7741-5.7617 1.679-3.657 5.8578-5.8612 9.7753-4.8661.5744.1468.8185-.7488.2441-.8931z"/><path d="m32.4293 19.845c-3.6808-1.0175-9.4695.102-10.7589 4.3063-.7347 2.3908-.8382 5.2417-.7002 7.7245.1184 2.1619.6682 4.3188 2.172 5.9309 3.1385 3.3659 8.158 3.1271 12.0188 1.326 1.918-.8956 4.1591-2.1719 5.1058-4.182.9171-1.9529.6928-4.4158.3057-6.4781-.8851-4.7168-4.4352-9.2147-9.5682-9.0406-.5892.0199-.5916.9479 0 .928 4.0507-.1369 7.1521 3.05 8.2887 6.7542.5547 1.8111.8283 3.8461.604 5.7393-.2687 2.2614-1.8022 3.56-3.6389 4.6497-3.4047 2.0225-7.8227 3.0102-11.3211.6319-3.5698-2.4281-3.3036-7.3365-2.8499-11.1577.1429-1.214.2687-2.6619.9836-3.6918.6238-.8981 1.642-1.5424 2.6109-2.0077 2.0315-.9752 4.344-1.1394 6.5037-.5423.5719.1592.8135-.7364.244-.8931z"/><path d="m18.5298 21.1983c3.2567-4.9134 9.5706-7.12 15.2656-6.2145 3.1557.5026 5.6679 2.6545 7.7832 4.9606 2.0709 2.2589 2.6108 5.5104 3.0324 8.4584.8604 5.9906-1.8194 12.0334-7.2556 14.852-2.6651 1.3832-5.7641 1.8808-8.72 1.3658-2.7761-.4851-6.2695-1.3757-8.338-3.3883-2.4999-2.4281-3.3307-5.9906-3.5181-9.369-.1898-3.4256-.3846-7.4757 1.1045-10.6451.2515-.5374-.5399-1.0076-.7938-.4677-1.4423 3.0724-1.3486 6.6547-1.2722 9.9834.0765 3.3585.6016 6.8289 2.5542 9.6401 1.9205 2.7614 4.8272 3.764 7.9237 4.6422 3.1286.8881 6.336.9976 9.44-.0697 5.8602-2.0126 9.9601-7.6996 9.9872-13.9663.0074-1.6917-.2958-3.371-.6237-5.0253-.3402-1.7066-.7174-3.458-1.6001-4.9756-.7815-1.3458-1.9501-2.3957-3.0866-3.4281-1.1982-1.0872-2.4358-2.142-3.9372-2.7788-6.4224-2.7217-14.9649.2512-18.7468 5.9582-.3304.4975.466.9627.7939.4677z"/><path d="m18.3698 20.6883c2.0093-2.234 4.7903-3.3186 7.5984-4.1446 3.1581-.9304 6.5776-1.5076 9.8171-.6518 2.9634.7812 5.4312 2.6445 6.6368 5.5254 1.1292 2.6967 1.5877 5.8562 1.7282 8.7619.143 3.0002-.207 6.0826-1.4792 8.8266-.6114 1.3185-1.4102 2.6843-2.6873 3.4406-1.4225.8408-3.2345 1.219-4.8124 1.6668-2.9856.8458-6.1363 1.4553-9.2353.9254-3.3184-.5672-6.124-2.5972-8.0618-5.3462-1.0379-1.4752-1.4102-3.1097-1.6789-4.8661-.2786-1.821-.5498-3.6595-.5597-5.5054-.0222-3.5799 1.0897-6.9682 3.136-9.8814.3427-.4876-.4536-.9503-.7939-.4677-1.9082 2.7191-3.0546 5.8836-3.237 9.2197-.0961 1.7389.0888 3.4779.3254 5.1994.249 1.821.4191 3.759 1.2229 5.4358 1.351 2.8161 4.1369 5.3462 7.0189 6.4582 3.173 1.2215 6.6689 1.0051 9.9281.2811 2.9017-.6443 6.8488-1.3036 8.8335-3.759 2.0142-2.4927 2.8302-5.9433 3.0003-9.0878.323-6.0005-.7988-13.9912-6.7477-16.877-3.3258-1.6146-7.1053-1.5076-10.6332-.7066-3.5822.8135-7.4282 2.0848-9.9626 4.901-.3969.4403.2514 1.0995.6508.6567z"/><path d="m7.38485 14.8844c-.38213-2.7664 1.3387-5.27903 3.62165-6.65974 2.3594-1.42798 5.2661-1.64939 7.9509-1.66681 5.6013-.03732 11.1903.5896 16.7793.85331 2.7539.12936 5.5052.16668 8.2615.05224 2.8673-.11941 5.737.02736 7.2754 2.8759 1.3288 2.4629 1.1489 5.3711 1.1612 8.0852.0148 2.9356.0789 5.8711.1726 8.8042.1775 5.5229.6779 11.0756.6557 16.6009-.0123 2.8186-.636 5.5303-2.9954 7.2917-2.1276 1.5871-4.7952 2.0424-7.3813 2.122-5.557.1717-11.1806-.2736-16.7375-.4403-2.8845-.0871-5.7764-.1194-8.6584-.2811-2.6725-.1493-5.4559-.5797-7.60822-2.3087-2.6774-2.1494-2.42347-4.9283-2.3569-8.0554.0641-3.045-.58676-6.0428-.92205-9.0555-.71743-6.4383-.44624-12.9438.74454-19.3075.10848-.5822-.77659-.8334-.88507-.2463-1.18832 6.3463-1.49649 12.8344-.80865 19.2603.33283 3.1122 1.02314 6.207.95411 9.349-.05671 2.5873-.392 5.0751 1.24008 7.2767 3.33076 4.493 9.72346 4.0327 14.65666 4.182 6.59.199 13.2268.6468 19.8217.5622 4.8001-.0622 10.2659-1.6444 11.5183-6.9657.6459-2.7366.2712-5.6771.1479-8.4535-.1479-3.3386-.2983-6.6747-.4142-10.0132-.1183-3.3386-.2046-6.6772-.2243-10.0183-.0173-2.744.175-5.6721-.9788-8.237-2.49-5.53527-9.1219-3.78388-13.9738-3.90578-7.1619-.17912-14.4348-1.41554-21.5967-.8757-5.0393.38063-11.14602 3.37342-10.30779 9.42368.08136.5896.96643.3383.88508-.2463z"/><path d="m1.08884 13.133c1.02066-2.5848 2.11036-5.20939 3.77696-7.45087 2.11283-2.83855 4.94556-4.18692 8.4267-4.4755 6.9819-.57716 14.1439-.318433 21.1406-.15175 3.4787.08209 6.9721.15424 10.4409.46521 3.4811.31097 8.1309.50502 10.15 3.84112 3.6389 6.01049 4.238 13.18769 3.9298 20.03149-.318 7.0578-.5005 14.143-.9763 21.1908-.2293 3.4033-1.1291 6.4434-3.7523 8.7421-2.4284 2.1295-5.6112 3.2067-8.7669 3.5699-3.4564.398-6.945.0423-10.3965-.2264-3.4392-.2687-6.8858-.4154-10.3373-.4154-6.166-.0025-14.1563 1.7041-18.85529-3.4307-4.938159-5.391-5.132924-14.1877-4.891317-21.0764.263797-7.5056 1.328837-15.0087.355017-22.5068-.07643-.5821-.996016-.5896-.919589 0 .973829 7.4981-.09122 15.0012-.3550155 22.5068-.2342115 6.6374.0542385 14.2575 3.8139445 19.9893 3.80409 5.794 10.21165 5.7268 16.41695 5.5203 3.9372-.1318 7.8794-.087 11.8141.1393 3.9521.2264 7.9139.7762 11.8758.5498 5.5742-.3184 11.824-2.6793 13.9861-8.3514 1.2795-3.356 1.0429-7.2842 1.2031-10.8168.1824-4.0252.3673-8.048.5498-12.0732.1775-3.9058.5153-7.8613.0197-11.7572-.424-3.346-1.42-6.5851-2.7637-9.66742-1.3461-3.0923-2.8894-5.0054-6.23-5.80646-3.6562-.878179-7.4676-1.04486-11.2076-1.186663-4.4032-.169168-8.8113-.2537519-13.2219-.2587275-4.4919-.0049755-9.0972-.1542415-13.5694.3010205-3.22229.325897-5.9638 1.59466-8.0643 4.11228-2.06106 2.4604-3.30855 5.48304-4.479602 8.44597-.2194193.5548.668118.7961.885072.2463z"/></g></svg>';
                        else theString = '<svg fill="none" height="60" viewBox="0 0 60 60" width="60" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><clipPath id="a"><path d="m0 0h60v60h-60z"/></clipPath><g clip-path="url(#a)" fill="#fff3db"><path d="m47.0407 10.3093c-.821-.2662-1.6937-.2637-2.5467-.2313-.3846.0149-.7791.0572-1.0823.3209-.2836.2463-.4068.6045-.5178.9528-.2687.8458-.4955 1.7265-.6015 2.6122-.0962.8035.037 1.5772.5867 2.1917.5301.5921 1.3116.8831 2.0734 1.005.784.1269 1.6962.2712 2.4334-.102.6607-.3358 1.2055-1.005 1.5482-1.6543.3427-.6468.5449-1.3907.4931-2.1296-.111-1.5871-1.4497-3.0624-3.1015-2.948-.5867.0423-.5917.9678 0 .928 1.0256-.0722 1.9132.7239 2.1351 1.7091.249 1.107-.3205 2.2763-1.1267 3.0052-.503.4553-1.0799.4105-1.7135.3483-.6114-.0597-1.2474-.1692-1.7652-.5249-1.1193-.7687-.5941-2.3236-.3081-3.4058.0961-.3557.1799-.7364.3254-1.0772.138-.3234.4216-.2985.7297-.3085.7421-.0224 1.4793-.0298 2.1918.2015.5645.1816.8061-.7115.244-.8931z"/><path d="m45.2413 9.91876c-.9023-.09702-1.8293-.07463-2.4875.64684-.5991.6543-1.1193 1.5698-1.2648 2.4529-.143.8608.074 1.7887.7618 2.3609.6854.5697 1.6666.8857 2.4925 1.1792 1.4842.5299 3.7598.8558 4.6202-.8757.6977-1.4031.5966-3.4207-.5079-4.5849-.6928-.729-1.6863-.9877-2.6355-1.17675-.9615-.19156-1.9994-.36073-2.882.18655-.503.3135-.0419 1.1146.4635.8011.5892-.3657 1.2992-.2587 1.9476-.1368.6558.1244 1.351.2438 1.9378.5796 1.1119.6369 1.3535 2.045 1.0872 3.2167-.1503.6593-.4339 1.1941-1.1094 1.3956-.6336.1891-1.3066.0971-1.9328-.0671-.7273-.1916-1.4324-.4827-2.1203-.7887-.641-.286-1.1809-.6468-1.245-1.4105-.069-.811.3846-1.5798.8333-2.2166.212-.2986.4462-.5448.8111-.6369.397-.0995.8284-.0423 1.2302 0 .5868.0622.5819-.86573 0-.92793z"/><path d="m33.0654 20.1012c-3.9076-.9926-8.1604.8583-10.2782 4.2939-2.1868 3.5451-2.0956 8.7594.4191 12.1304 1.356 1.816 3.7647 2.3161 5.88 2.6196 2.0881.301 4.2823.2289 6.2152-.704 3.7917-1.8261 5.0022-6.4956 4.5289-10.4039-.5794-4.7815-4.1961-9.4734-9.4227-8.6699-.5818.0896-.3353.9827.2441.8931 4.2207-.6493 7.3197 3.0625 8.1062 6.8737.7026 3.4083.0813 7.7967-2.9437 9.9337-1.5877 1.122-3.5526 1.4031-5.4485 1.2862-1.7406-.1095-3.9841-.4304-5.4608-1.4355-1.6198-1.102-2.3668-3.4306-2.638-5.2939-.281-1.933-.0419-3.9829.7741-5.7617 1.679-3.657 5.8578-5.8612 9.7753-4.8661.5744.1468.8185-.7488.2441-.8931z"/><path d="m32.4293 19.845c-3.6808-1.0175-9.4695.102-10.7589 4.3063-.7347 2.3908-.8382 5.2417-.7002 7.7245.1184 2.1619.6682 4.3188 2.172 5.9309 3.1385 3.3659 8.158 3.1271 12.0188 1.326 1.918-.8956 4.1591-2.1719 5.1058-4.182.9171-1.9529.6928-4.4158.3057-6.4781-.8851-4.7168-4.4352-9.2147-9.5682-9.0406-.5892.0199-.5916.9479 0 .928 4.0507-.1369 7.1521 3.05 8.2887 6.7542.5547 1.8111.8283 3.8461.604 5.7393-.2687 2.2614-1.8022 3.56-3.6389 4.6497-3.4047 2.0225-7.8227 3.0102-11.3211.6319-3.5698-2.4281-3.3036-7.3365-2.8499-11.1577.1429-1.214.2687-2.6619.9836-3.6918.6238-.8981 1.642-1.5424 2.6109-2.0077 2.0315-.9752 4.344-1.1394 6.5037-.5423.5719.1592.8135-.7364.244-.8931z"/><path d="m18.5298 21.1983c3.2567-4.9134 9.5706-7.12 15.2656-6.2145 3.1557.5026 5.6679 2.6545 7.7832 4.9606 2.0709 2.2589 2.6108 5.5104 3.0324 8.4584.8604 5.9906-1.8194 12.0334-7.2556 14.852-2.6651 1.3832-5.7641 1.8808-8.72 1.3658-2.7761-.4851-6.2695-1.3757-8.338-3.3883-2.4999-2.4281-3.3307-5.9906-3.5181-9.369-.1898-3.4256-.3846-7.4757 1.1045-10.6451.2515-.5374-.5399-1.0076-.7938-.4677-1.4423 3.0724-1.3486 6.6547-1.2722 9.9834.0765 3.3585.6016 6.8289 2.5542 9.6401 1.9205 2.7614 4.8272 3.764 7.9237 4.6422 3.1286.8881 6.336.9976 9.44-.0697 5.8602-2.0126 9.9601-7.6996 9.9872-13.9663.0074-1.6917-.2958-3.371-.6237-5.0253-.3402-1.7066-.7174-3.458-1.6001-4.9756-.7815-1.3458-1.9501-2.3957-3.0866-3.4281-1.1982-1.0872-2.4358-2.142-3.9372-2.7788-6.4224-2.7217-14.9649.2512-18.7468 5.9582-.3304.4975.466.9627.7939.4677z"/><path d="m18.3698 20.6883c2.0093-2.234 4.7903-3.3186 7.5984-4.1446 3.1581-.9304 6.5776-1.5076 9.8171-.6518 2.9634.7812 5.4312 2.6445 6.6368 5.5254 1.1292 2.6967 1.5877 5.8562 1.7282 8.7619.143 3.0002-.207 6.0826-1.4792 8.8266-.6114 1.3185-1.4102 2.6843-2.6873 3.4406-1.4225.8408-3.2345 1.219-4.8124 1.6668-2.9856.8458-6.1363 1.4553-9.2353.9254-3.3184-.5672-6.124-2.5972-8.0618-5.3462-1.0379-1.4752-1.4102-3.1097-1.6789-4.8661-.2786-1.821-.5498-3.6595-.5597-5.5054-.0222-3.5799 1.0897-6.9682 3.136-9.8814.3427-.4876-.4536-.9503-.7939-.4677-1.9082 2.7191-3.0546 5.8836-3.237 9.2197-.0961 1.7389.0888 3.4779.3254 5.1994.249 1.821.4191 3.759 1.2229 5.4358 1.351 2.8161 4.1369 5.3462 7.0189 6.4582 3.173 1.2215 6.6689 1.0051 9.9281.2811 2.9017-.6443 6.8488-1.3036 8.8335-3.759 2.0142-2.4927 2.8302-5.9433 3.0003-9.0878.323-6.0005-.7988-13.9912-6.7477-16.877-3.3258-1.6146-7.1053-1.5076-10.6332-.7066-3.5822.8135-7.4282 2.0848-9.9626 4.901-.3969.4403.2514 1.0995.6508.6567z"/><path d="m7.38485 14.8844c-.38213-2.7664 1.3387-5.27903 3.62165-6.65974 2.3594-1.42798 5.2661-1.64939 7.9509-1.66681 5.6013-.03732 11.1903.5896 16.7793.85331 2.7539.12936 5.5052.16668 8.2615.05224 2.8673-.11941 5.737.02736 7.2754 2.8759 1.3288 2.4629 1.1489 5.3711 1.1612 8.0852.0148 2.9356.0789 5.8711.1726 8.8042.1775 5.5229.6779 11.0756.6557 16.6009-.0123 2.8186-.636 5.5303-2.9954 7.2917-2.1276 1.5871-4.7952 2.0424-7.3813 2.122-5.557.1717-11.1806-.2736-16.7375-.4403-2.8845-.0871-5.7764-.1194-8.6584-.2811-2.6725-.1493-5.4559-.5797-7.60822-2.3087-2.6774-2.1494-2.42347-4.9283-2.3569-8.0554.0641-3.045-.58676-6.0428-.92205-9.0555-.71743-6.4383-.44624-12.9438.74454-19.3075.10848-.5822-.77659-.8334-.88507-.2463-1.18832 6.3463-1.49649 12.8344-.80865 19.2603.33283 3.1122 1.02314 6.207.95411 9.349-.05671 2.5873-.392 5.0751 1.24008 7.2767 3.33076 4.493 9.72346 4.0327 14.65666 4.182 6.59.199 13.2268.6468 19.8217.5622 4.8001-.0622 10.2659-1.6444 11.5183-6.9657.6459-2.7366.2712-5.6771.1479-8.4535-.1479-3.3386-.2983-6.6747-.4142-10.0132-.1183-3.3386-.2046-6.6772-.2243-10.0183-.0173-2.744.175-5.6721-.9788-8.237-2.49-5.53527-9.1219-3.78388-13.9738-3.90578-7.1619-.17912-14.4348-1.41554-21.5967-.8757-5.0393.38063-11.14602 3.37342-10.30779 9.42368.08136.5896.96643.3383.88508-.2463z"/><path d="m1.08884 13.133c1.02066-2.5848 2.11036-5.20939 3.77696-7.45087 2.11283-2.83855 4.94556-4.18692 8.4267-4.4755 6.9819-.57716 14.1439-.318433 21.1406-.15175 3.4787.08209 6.9721.15424 10.4409.46521 3.4811.31097 8.1309.50502 10.15 3.84112 3.6389 6.01049 4.238 13.18769 3.9298 20.03149-.318 7.0578-.5005 14.143-.9763 21.1908-.2293 3.4033-1.1291 6.4434-3.7523 8.7421-2.4284 2.1295-5.6112 3.2067-8.7669 3.5699-3.4564.398-6.945.0423-10.3965-.2264-3.4392-.2687-6.8858-.4154-10.3373-.4154-6.166-.0025-14.1563 1.7041-18.85529-3.4307-4.938159-5.391-5.132924-14.1877-4.891317-21.0764.263797-7.5056 1.328837-15.0087.355017-22.5068-.07643-.5821-.996016-.5896-.919589 0 .973829 7.4981-.09122 15.0012-.3550155 22.5068-.2342115 6.6374.0542385 14.2575 3.8139445 19.9893 3.80409 5.794 10.21165 5.7268 16.41695 5.5203 3.9372-.1318 7.8794-.087 11.8141.1393 3.9521.2264 7.9139.7762 11.8758.5498 5.5742-.3184 11.824-2.6793 13.9861-8.3514 1.2795-3.356 1.0429-7.2842 1.2031-10.8168.1824-4.0252.3673-8.048.5498-12.0732.1775-3.9058.5153-7.8613.0197-11.7572-.424-3.346-1.42-6.5851-2.7637-9.66742-1.3461-3.0923-2.8894-5.0054-6.23-5.80646-3.6562-.878179-7.4676-1.04486-11.2076-1.186663-4.4032-.169168-8.8113-.2537519-13.2219-.2587275-4.4919-.0049755-9.0972-.1542415-13.5694.3010205-3.22229.325897-5.9638 1.59466-8.0643 4.11228-2.06106 2.4604-3.30855 5.48304-4.479602 8.44597-.2194193.5548.668118.7961.885072.2463z"/></g></svg>';
                        break;
                    case "vimeo":
                        if (element.classList.contains("circle")) theString = '<svg class="social-vimeo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15S0,23.3,0,15S6.7,0,15,0S30,6.7,30,15z M24.4,10.9c0-2.1-1.3-3.4-3-3.4c-1.7,0-4.7,1-5.5,4.4c1.7-0.8,2.8,0.2,2.8,1.5c0,1.7-2.7,5.4-3.5,5.4c-0.8,0-1.5-3.3-1.8-5.4c-0.3-2.1-0.4-5.8-3-5.8s-6.2,4.8-6.2,4.8L5,13.1c1.7-1.2,2.2-1,2.5,0l2.5,8.1c0.4,1.3,1.4,3.7,3.7,3.7C16.5,25,24.4,16.3,24.4,10.9z"/></svg>';
                        else theString = '<svg class="social-vimeo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="-162.3 486.2 34.3 30" xml:space="preserve"><path d="M-133.1,486.2c2.9,0,5,2.3,5,5.8c0,9.2-13.6,24.2-18.2,24.2c-4,0-5.4-4.3-6.1-6.4l-4.3-13.6c-0.6-1.7-1.4-2.1-4.3,0 l-1.4-1.7c0,0,6.4-8.3,10.7-8.3c4.3,0,4.4,6.4,5,10c0.6,3.6,1.7,9.3,3.1,9.3c1.4,0,5.5-6.4,5.5-9.3c0-2.1-1.4-3.6-4.3-2.1 C-140.9,488.3-135.9,486.2-133.1,486.2z"/></svg>';
                        break;
                    case "linkedin":
                        if (element.classList.contains("circle")) theString = '<svg class="social-linkedin" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15C6.7,30,0,23.3,0,15S6.7,0,15,0C23.3,0,30,6.7,30,15zM11.3,7.8c0-1.2-1-2.2-2.5-2.2c-1.5,0-2.5,0.9-2.5,2.2c0,1.2,1,2.2,2.5,2.2h0C10.3,10,11.3,9,11.3,7.8z M10.6,11.9H6.9v10.6h3.7V11.9zM24.4,16.9c0-3.4-1.7-5.6-4.4-5.6c-1.5,0-2.6,0.9-3.1,2.3l-0.1-1.6H13c0,0.4,0.1,2.5,0.1,2.5v8.1h3.8v-5.6c0-1.5,0.7-2.5,1.8-2.5c1.1,0,1.9,0.6,1.9,2.5v5.6h3.8V16.9z"/></svg>';
                        else theString = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1242_1980)"><path d="M8.95978 0.0523477C5.96027 -0.349048 3.06657 1.62801 2.10446 4.49513C1.09561 7.50934 2.20781 10.8751 4.58724 12.8796C7.05033 14.9564 10.6232 15.6569 13.6325 14.4478C16.4967 13.2959 18.4873 10.2393 17.6089 7.09797C16.5287 3.24357 12.6114 1.60059 9.20338 0.456237C8.64236 0.266758 8.40122 1.16429 8.95978 1.35128C11.5927 2.23385 14.4765 3.30091 16.0292 5.79904C17.6089 8.34205 16.8584 11.4909 14.324 13.0666C9.39777 16.1306 1.97159 12.1117 2.69994 6.02841C3.07149 2.90949 5.84708 0.565935 8.95978 0.979797C9.54295 1.05708 9.53803 0.127142 8.95978 0.0498545V0.0523477Z" fill="#FFF3DB"/><path d="M8.55347 0.271689C5.4703 1.46092 2.59629 3.90919 1.85318 7.29986C1.20603 10.2517 2.40682 13.792 5.17011 15.2056C6.89255 16.0857 8.90042 16.0483 10.7582 15.7491C12.5717 15.4574 14.3679 14.7992 15.8394 13.6674C18.4944 11.628 19.9044 7.69877 18.0023 4.66212C15.8123 1.16423 11.1888 -0.276803 7.31331 0.393853C6.73261 0.493579 6.97867 1.38862 7.55692 1.28889C10.6991 0.745386 14.1022 1.75012 16.3586 4.06625C18.7036 6.47463 18.2803 10.1146 15.9354 12.3734C13.6913 14.535 9.74934 15.5646 6.74245 14.8067C3.92011 14.0962 2.39698 11.1767 2.61843 8.36443C2.8891 4.92888 5.79265 2.32355 8.79708 1.16423C9.34334 0.95481 9.10711 0.0547854 8.55347 0.269196V0.271689Z" fill="#FFF3DB"/><path d="M3.87341 19.8529C6.94181 19.606 10.0102 19.3592 13.0811 19.1124C13.8513 19.0501 14.9487 18.7284 15.5466 19.267C16.152 19.813 15.8985 20.6083 15.8714 21.4161C15.8173 23.0416 15.7632 24.6696 15.709 26.2951C15.495 32.7 15.2833 39.1024 15.0693 45.5073C14.9635 48.6586 14.8601 51.81 14.7543 54.9613C14.7445 55.2256 14.8134 56.0059 14.7125 56.1805C14.5476 56.4746 13.7873 56.6666 13.4895 56.7439C12.776 56.9284 11.9295 56.9284 11.1987 56.9982C9.66819 57.1453 8.13276 57.245 6.59732 57.2999C5.92557 57.3248 5.25382 57.3398 4.57961 57.3447C4.53778 57.3447 3.5363 57.4295 3.42557 57.3447C3.0048 57.0231 3.21888 56.8511 3.15244 56.4198C2.90884 54.8641 3.15244 53.0491 3.1549 51.4684C3.1549 48.2697 3.15736 45.071 3.15982 41.8748C3.16475 34.5499 3.16721 27.2251 3.17213 19.9002C3.17213 19.3019 2.25431 19.3019 2.25431 19.9002C2.24939 27.5342 2.24693 35.1682 2.24201 42.8047C2.24201 46.6217 2.23709 50.4387 2.23709 54.2557C2.23709 55.2231 1.81632 57.0855 2.46839 57.8982C3.10077 58.6861 4.90441 58.2747 5.73364 58.2547C7.3675 58.2149 8.9989 58.1226 10.6254 57.978C11.4866 57.9007 12.3478 57.811 13.2066 57.7063C13.6839 57.6464 14.4959 57.6664 14.9389 57.4195C15.8345 56.9209 15.6426 55.8663 15.6746 54.9588C15.7386 53.0266 15.8025 51.0969 15.8665 49.1647C16.1126 41.7452 16.3611 34.3231 16.6072 26.9035C16.6785 24.7693 16.7499 22.6352 16.8212 20.4986C16.8606 19.3218 16.9836 18.2822 15.6672 18.0179C14.9659 17.8783 14.0875 18.1002 13.3813 18.1575C12.3921 18.2373 11.4005 18.3171 10.4113 18.3969C8.23364 18.5714 6.05599 18.7459 3.87833 18.9229C3.2927 18.9703 3.28778 19.9002 3.87833 19.8529H3.87341Z" fill="#FFF3DB"/><path d="M1.78952 18.3645C5.11384 18.549 8.44061 18.736 11.7649 18.9205C12.3087 18.9504 13.6448 18.7734 14.1124 19.0526C15.0991 19.641 15.072 21.1194 15.1557 22.1117C15.2959 23.7646 15.4362 25.4176 15.5715 27.073C16.1202 33.7422 15.8028 40.4064 15.6256 47.0855C15.5838 48.6936 15.5395 50.3042 15.4977 51.9122C15.4509 53.6898 15.5863 55.5821 15.355 57.3423C15.1926 58.5864 14.698 58.5914 13.5464 58.7235C12.7762 58.8133 12.0011 58.8706 11.226 58.9105C9.57988 58.9977 7.9288 58.9828 6.2851 58.8706C5.3033 58.8033 4.26 58.9005 3.5661 58.1526C2.8722 57.4046 2.8722 56.3625 2.73933 55.3603C2.50557 53.6076 2.37269 51.8424 2.29395 50.0748C2.14386 46.6816 2.19553 43.286 2.12663 39.8928C2.05035 36.1381 1.65419 32.4433 1.25803 28.716C0.854486 24.9215 0.645332 21.1144 1.58037 17.3772C1.72555 16.7963 0.842182 16.5495 0.697005 17.1304C-0.233113 20.8502 -0.0830145 24.6397 0.313147 28.4243C0.721611 32.3535 1.14484 36.2378 1.21866 40.192C1.29248 44.2807 1.20882 48.377 1.52378 52.4582C1.64927 54.0813 1.82151 55.7143 2.11925 57.3149C2.37762 58.7036 2.73195 59.3742 4.14189 59.5936C7.51295 60.1197 11.4746 60.1845 14.8284 59.4914C15.8004 59.2919 16.1424 58.923 16.2605 57.9432C16.5016 55.981 16.3663 53.8893 16.4204 51.9097C16.6296 43.9591 17.1832 35.9312 16.5681 27.9905C16.386 25.6445 16.1768 23.3009 15.98 20.9549C15.8791 19.7457 15.9701 18.5315 14.6217 18.1725C12.8722 17.7063 10.6404 17.9257 8.83677 17.826C6.48933 17.6938 4.14189 17.5642 1.79445 17.4321C1.20389 17.3996 1.20636 18.3296 1.79445 18.362L1.78952 18.3645Z" fill="#FFF3DB"/><path d="M22.0552 19.1847C24.5159 19.1573 26.974 19.1573 29.4347 19.1822C30.0203 19.1872 30.6059 19.1972 31.1916 19.2047C31.5041 19.2096 31.8166 19.2146 32.1291 19.2196C32.3505 19.2246 32.7885 19.1448 32.9903 19.2396C33.3938 19.429 33.3077 20.6108 33.3471 21.0122C33.4037 21.613 33.4627 22.2139 33.5193 22.8147C33.5759 23.4056 34.4937 23.4106 34.4371 22.8147C34.3682 22.1017 34.2993 21.3887 34.2329 20.6756C34.1812 20.1396 34.2181 19.4714 34.0237 18.9628C33.8515 18.5141 33.4381 18.3495 32.9927 18.3121C32.2841 18.2523 31.5557 18.2797 30.8446 18.2697C27.9165 18.2273 24.9883 18.2224 22.0602 18.2548C21.4696 18.2623 21.4696 19.1897 22.0602 19.1847H22.0552Z" fill="#FFF3DB"/><path d="M21.3584 19.065C22.0942 22.5754 21.821 26.1456 21.6808 29.7008C21.543 33.1787 21.4544 36.6592 21.415 40.1396C21.3757 43.8244 21.3904 47.5118 21.4618 51.1967C21.4938 52.8347 21.5184 54.4727 21.5922 56.1107C21.6266 56.8711 21.5627 57.5567 22.3894 57.8085C23.6936 58.2024 25.539 57.8908 26.8899 57.8683C28.6739 57.8409 30.4628 57.7711 32.2418 57.634C32.9554 57.5791 33.5484 57.609 33.9003 56.9159C34.0922 56.537 33.9987 55.9511 34.0036 55.5522C34.011 54.6372 33.9987 53.7222 33.9741 52.8072C33.8092 46.3799 33.0169 39.6759 35.1207 33.4654C35.6055 32.0394 36.2305 30.4612 37.3894 29.444C39.1316 27.9132 41.5922 28.7285 43.0784 30.2069C45.4948 32.6103 45.8515 36.1904 45.731 39.439C45.6006 42.9693 45.3151 46.4672 45.3447 50.005C45.3594 51.7477 45.3594 53.5003 45.448 55.243C45.4874 56.001 45.5563 56.5195 46.3609 56.719C47.6626 57.0431 49.5573 56.6193 50.8885 56.5669C52.6773 56.4946 54.4638 56.4223 56.2526 56.35C56.9834 56.3201 58.8584 56.6243 59.4022 55.9137C59.5622 55.7043 59.5327 55.4824 59.5646 55.2406C59.6877 54.2907 59.4515 53.1762 59.3998 52.2114C59.0258 45.3976 58.8363 38.5415 58.2482 31.7427C57.7684 26.1954 56.0016 20.8102 50.2954 18.9429C47.3599 17.983 43.8978 17.7512 40.8392 18.0304C38.2039 18.2697 35.6768 19.3069 34.2694 21.6828C33.9642 22.1964 34.7566 22.6651 35.0617 22.1516C36.7152 19.3617 39.978 18.8556 42.9382 18.8955C45.7236 18.9354 48.6936 19.1224 51.2625 20.3091C56.5356 22.7474 57.1926 28.8531 57.4854 34.0414C57.857 40.6033 58.2039 47.1653 58.5656 53.7272C58.6075 54.4976 58.9642 55.243 58.039 55.3503C57.2566 55.4425 56.4421 55.4151 55.6547 55.4475C53.9667 55.5148 52.2787 55.5846 50.5883 55.6519C49.7836 55.6843 46.8579 56.2428 46.3707 55.5547C46.1321 55.2156 46.3191 53.5228 46.3092 53.0915C46.2895 52.1665 46.2699 51.244 46.2625 50.3191C46.2305 47.0705 46.3904 43.8544 46.5848 40.6133C46.7448 37.9631 46.7571 35.2231 45.7556 32.7225C44.3038 29.0999 39.5843 25.5198 36.2846 29.257C34.7344 31.0122 34.0085 33.5577 33.5213 35.8065C32.9406 38.4891 32.7807 41.249 32.7831 43.989C32.7856 46.9309 32.9775 49.8678 33.0514 52.8072C33.071 53.5402 33.0833 54.2732 33.0833 55.0037C33.0833 56.1605 33.2703 56.5021 31.9416 56.724C30.4086 56.9808 28.7354 56.9035 27.1827 56.9334C26.2895 56.9509 25.3963 56.9558 24.5031 56.9459C23.669 56.9384 22.8225 57.2002 22.5149 56.4173C22.2443 55.7317 22.451 54.3979 22.4313 53.6549C22.4067 52.7349 22.387 51.8125 22.3698 50.89C22.3009 47.2052 22.2886 43.5178 22.3304 39.8329C22.3747 36.1481 22.4731 32.4632 22.6306 28.7808C22.7708 25.44 22.9283 22.1092 22.2369 18.8182C22.1139 18.2348 21.2305 18.4816 21.3535 19.065H21.3584Z" fill="#FFF3DB"/><path d="M21.5465 18.4592C24.327 18.0853 27.1198 17.8584 29.9249 17.816C31.1429 17.7986 32.981 17.5044 34.1277 17.8833C35.0873 18.2 34.7404 19.2645 35.2399 20C35.4047 20.2418 35.7394 20.3191 35.9608 20.0947C37.9785 18.018 40.8993 17.7562 43.6306 17.7537C46.4234 17.7487 49.482 17.7238 52.1887 18.4867C55.4638 19.4116 56.2069 22.194 56.9722 25.1982C57.7497 28.2473 58.2615 31.3613 58.5814 34.4926C59.2064 40.5984 59.1326 46.7489 58.9628 52.8771C58.9431 53.5577 58.9234 54.2383 58.9037 54.919C58.8964 55.1733 58.948 55.5497 58.8767 55.7941C58.6085 56.7091 58.4953 56.3924 57.8973 56.5096C56.421 56.8013 54.5632 56.4548 53.0548 56.4273C51.4407 56.3999 49.8265 56.3725 48.2123 56.3451C47.5061 56.3326 46.7999 56.3226 46.0937 56.3102C45.7369 56.3052 45.2054 56.4248 44.8831 56.2902C44.5878 56.3825 44.4525 56.2628 44.4795 55.9312C44.3663 55.622 44.3196 55.3004 44.3417 54.9688C43.7536 49.0651 44.6985 43.1339 43.4977 37.2625C43.0548 35.0935 42.3954 32.1291 40.8034 30.4912C39.5189 29.1698 37.6808 29.5712 36.5465 30.8776C34.9618 32.7026 34.3417 35.7118 33.9087 38.0254C33.419 40.6432 33.2689 43.3159 33.2295 45.9736C33.1852 48.8207 33.2714 51.6679 33.2221 54.5126C33.1975 55.9187 33.6257 58.2748 31.8516 58.5515C30.3604 58.7834 28.4904 58.3645 26.982 58.2822L24.2433 58.1301C22.8088 58.0504 21.5858 58.2822 21.2832 56.2752C21.042 54.6622 21.2856 52.8098 21.2979 51.1743C21.325 47.6116 21.3841 44.0489 21.4726 40.4862C21.6523 33.261 21.9623 26.0384 22.388 18.8232C22.4224 18.2249 21.5071 18.2274 21.4702 18.8232C21.0494 25.9362 20.7443 33.0566 20.5622 40.1795C20.4712 43.7422 20.4121 47.3049 20.3826 50.8676C20.3678 52.5954 20.3137 54.3331 20.3604 56.0583C20.3826 56.9085 20.4293 57.8434 21.1306 58.4318C21.9549 59.1199 23.2468 59.0028 24.2409 59.0576C26.0666 59.1598 27.8924 59.2595 29.7182 59.3618C30.7615 59.4191 32.3093 59.8554 33.2714 59.3019C34.0711 58.8407 34.0096 57.7911 34.0514 56.9783C34.3934 50.4936 33.574 43.8818 34.9471 37.4844C35.2915 35.8813 35.7492 34.2383 36.4628 32.7574C36.8344 31.987 37.5012 30.7704 38.451 30.6482C39.9741 30.4513 40.6434 31.6978 41.1798 32.8945C42.575 36.0209 43.0721 39.4964 43.2418 42.8945C43.419 46.4099 43.2468 49.9302 43.355 53.4455C43.3821 54.2932 43.1262 56.1032 43.7118 56.8512C44.2482 57.5368 45.6705 57.2301 46.3914 57.2426C49.9224 57.3024 53.451 57.3598 56.982 57.4196C57.7645 57.4321 58.921 57.6116 59.4845 56.8811C60.1291 56.0459 59.8265 54.4378 59.856 53.4555C60.0479 46.7489 60.1488 40.0075 59.3639 33.3333C58.9431 29.7432 58.2861 26.1631 57.2256 22.7051C56.4284 20.1097 55.0824 18.3346 52.4224 17.5841C49.3639 16.719 45.855 16.7365 42.7054 16.8287C40.0061 16.9085 37.265 17.4096 35.3014 19.4316C35.5425 19.464 35.7812 19.4939 36.0223 19.5263C35.5474 18.8257 35.8895 17.7936 35.1464 17.2326C34.3245 16.6143 32.6562 16.8911 31.7187 16.8811C28.3132 16.8437 24.9151 17.0731 21.5391 17.5268C20.9633 17.6041 20.9559 18.534 21.5391 18.4567L21.5465 18.4592Z" fill="#FFF3DB"/></g><defs><clipPath id="clip0_1242_1980"><rect width="60" height="60" fill="white"/></clipPath></defs></svg>';
                        break;
                    case "youtube":
                        if (element.classList.contains("circle")) theString = '<svg class="social-youtube" class="social-email" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15S0,23.3,0,15S6.7,0,15,0S30,6.7,30,15z M24.4,15c0-6.9,0-6.9-9.4-6.9s-9.4,0-9.4,6.9s0,6.9,9.4,6.9S24.4,21.9,24.4,15z M12.5,11.3l6.3,3.7l-6.3,3.7V11.3z"/></svg>';
                        else theString = '<svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>YouTube icon</title><path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg>';
                        break;
                    case "tumblr":
                        if (element.classList.contains("circle")) theString = '<svg class="social-tumblr" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15S0,23.3,0,15S6.7,0,15,0S30,6.7,30,15zM21.3,21.1c0,0-1.8,0.5-3.1,0.5c-2.3,0-2.5-0.7-2.5-2.9v-5h5V9.4h-5v-5h-3.1c-0.5,4.1-2.3,5.1-5,6v3.2h3.2V20c0,3.6,1.5,5.6,5.6,5.6c3.2,0,5-1.3,5-1.3V21.1z"/></svg>';
                        else theString = '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Tumblr icon</title><path d="M14.563 24c-5.093 0-7.031-3.756-7.031-6.411V9.747H5.116V6.648c3.63-1.313 4.512-4.596 4.71-6.469C9.84.051 9.941 0 9.999 0h3.517v6.114h4.801v3.633h-4.82v7.47c.016 1.001.375 2.371 2.207 2.371h.09c.631-.02 1.486-.205 1.936-.419l1.156 3.425c-.436.636-2.4 1.374-4.156 1.404h-.178l.011.002z"/></svg>';
                        break;
                    case "pinterest":
                        if (element.classList.contains("circle")) theString = '<svg class="social-pinterest" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M15,30c-1.5,0-2.9-0.2-4.3-0.6c0.6-0.9,1.2-2,1.5-3.2c0.2-0.7,1-4.1,1-4.1c0.5,1,2,1.9,3.7,1.9c4.8,0,8.1-4.4,8.1-10.3c0-4.4-3.8-8.6-9.5-8.6C8.4,5,4.9,10.1,4.9,14.4c0,2.6,1,4.9,3.1,5.7c0.3,0.1,0.7,0,0.8-0.4c0.1-0.2,0.2-0.9,0.3-1.2c0.1-0.4,0-0.5-0.2-0.8c-0.6-0.7-1-1.6-1-3c0-3.8,2.8-7.2,7.4-7.2c4,0,6.2,2.5,6.2,5.8c0,4.3-1.9,8-4.8,8c-1.6,0-2.7-1.3-2.4-2.9c0.5-1.9,1.3-4,1.3-5.3c0-1.2-0.7-2.3-2-2.3c-1.6,0-2.9,1.7-2.9,3.9c0,1.4,0.5,2.4,0.5,2.4s-1.7,6.9-1.9,8.2C9,26.4,8.9,27.7,9,28.8C3.7,26.4,0,21.1,0,15C0,6.7,6.7,0,15,0c8.3,0,15,6.7,15,15S23.3,30,15,30z"/></svg>';
                        else theString = '<svg class="social-pinterest" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-484 486 30 30" xml:space="preserve"><path d="M-457.4,495.9c0,6.8-3.8,11.8-9.3,11.8c-1.9,0-3.6-1-4.2-2.1c0,0-1,4-1.2,4.7c-0.7,2.7-2.9,5.4-3.1,5.6c-0.1,0.2-0.4,0.1-0.4-0.1c0-0.3-0.6-3.8,0.1-6.6c0.3-1.4,2.2-9.4,2.2-9.4s-0.5-1.1-0.5-2.7c0-2.6,1.5-4.4,3.3-4.4c1.6,0,2.3,1.1,2.3,2.6c0,1.6-1,3.9-1.5,6.1c-0.4,1.8,0.9,3.3,2.7,3.3c3.3,0,5.5-4.2,5.5-9.2c0-3.8-2.5-6.6-7.2-6.6c-5.2,0-8.5,3.9-8.5,8.2c0,1.5,0.5,2.6,1.1,3.4c0.3,0.4,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1.1-0.3,1.4c-0.1,0.5-0.5,0.6-0.9,0.5c-2.4-1-3.5-3.6-3.5-6.6c0-4.9,4.1-10.8,12.3-10.8C-461.7,486-457.4,490.8-457.4,495.9z"/></svg>';
                        break;
                    case "yelp":
                        if (element.classList.contains("circle")) theString = '<svg class="social-yelp" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15S0,23.3,0,15S6.7,0,15,0S30,6.7,30,15z M16.7,14.8c-0.2,0.3-0.3,0.8,0,1.1c0.3,0.3,0.6,0.6,1.4,0.3c0.8-0.2,3.7-1,4.2-1.1c0.6-0.2,0.8-0.4,0.7-1.1c-0.1-0.3-0.5-1.2-1-1.9c-0.4-0.5-0.9-1.1-1.1-1.3c-0.5-0.5-0.9-0.4-1.4,0.3c-0.4,0.5-2,2.6-2,2.6C17.3,14,16.9,14.5,16.7,14.8z M18,18.2c-0.3-0.1-0.8,0-1,0.3c-0.2,0.3-0.4,0.7,0.1,1.4s2.1,3.2,2.3,3.7c0.3,0.5,0.7,0.7,1.2,0.3c0.3-0.2,1-0.8,1.5-1.5c0.4-0.5,0.8-1.2,0.9-1.5c0.3-0.7,0.1-1-0.7-1.3c-0.5-0.2-3.1-1.1-3.1-1.1C19,18.6,18.4,18.3,18,18.2z M15,20.1c0-0.3-0.2-0.8-0.6-0.9c-0.4-0.1-0.8-0.1-1.3,0.6s-2.4,3-2.8,3.3c-0.4,0.5-0.4,0.8,0.1,1.3c0.3,0.2,1.1,0.7,1.9,0.9c0.6,0.2,1.4,0.4,1.7,0.4c0.7,0.1,0.9-0.2,1-1.1c0-0.6,0-3.3,0-3.3C15,21.1,15,20.4,15,20.1z M12.6,17.9c0.3-0.1,0.6-0.5,0.6-0.9c0-0.4-0.1-0.8-0.9-1.1s-3.6-1.4-4-1.6c-0.6-0.2-0.9-0.1-1.2,0.5c-0.1,0.3-0.3,1.2-0.3,2.1c0,0.6,0.1,1.5,0.1,1.7c0.2,0.7,0.5,0.8,1.3,0.6c0.6-0.2,3.1-1,3.1-1C11.7,18.2,12.3,18,12.6,17.9z M13.4,14c0.2,0.3,0.6,0.6,1.1,0.4c0.4-0.2,0.6-0.5,0.6-1.3c0-0.8-0.5-7.2-0.5-7.7c0-0.8-0.3-1.2-0.9-1.2c-0.4,0-1.8,0.2-2.6,0.5c-0.9,0.3-1.8,0.7-2,0.8C8.5,6,8.5,6.4,9,7.1c0.3,0.5,3.8,6,3.8,6C13.1,13.6,13.2,13.8,13.4,14z"/></svg>';
                        else theString = '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Yelp icon</title><path d="M21.111 18.226c-.141.969-2.119 3.483-3.029 3.847-.311.124-.611.094-.85-.09-.154-.12-.314-.365-2.447-3.827l-.633-1.032c-.244-.37-.199-.857.104-1.229.297-.359.732-.494 1.111-.35.02.012 1.596.531 1.596.531 3.588 1.179 3.705 1.224 3.857 1.338.227.186.332.475.285.813h.006zm-7.191-5.267c-.254-.386-.25-.841.012-1.155l.998-1.359c2.189-2.984 2.311-3.141 2.459-3.245.256-.171.57-.179.871-.032.869.422 2.623 3.029 2.729 4.029v.034c.029.341-.105.618-.346.784-.164.105-.314.166-4.393 1.156-.645.164-1.004.254-1.215.329l.029-.03c-.404.12-.854-.074-1.109-.479l-.035-.032zm-2.504-1.546c-.195.061-.789.245-1.519-.938 0 0-4.931-7.759-5.047-7.998-.07-.27.015-.574.255-.82.734-.761 4.717-1.875 5.76-1.621.34.088.574.301.656.604.06.335.545 7.536.615 9.149.066 1.38-.525 1.565-.72 1.624zm.651 7.893c-.011 3.774-.019 3.9-.081 4.079-.105.281-.346.469-.681.53-.96.164-3.967-.946-4.594-1.69-.12-.164-.195-.328-.21-.493-.016-.12 0-.24.045-.346.075-.195.18-.345 2.88-3.51l.794-.944c.271-.345.75-.45 1.199-.271.436.165.706.54.676.945v1.68l-.028.02zm-8.183-2.414c-.295-.01-.56-.187-.715-.48-.111-.215-.189-.57-.238-1.002-.137-1.301.029-3.264.419-3.887.183-.285.45-.436.745-.426.195 0 .369.061 4.229 1.65l1.13.449c.404.15.654.57.63 1.051-.03.465-.298.824-.694.93l-1.605.51c-3.59 1.155-3.709 1.185-3.898 1.17l-.003.035zm14.977 7.105h-.004l-.005.003.009-.003z"/></svg>';
                        break;
                    case "email":
                        if (element.classList.contains("circle")) theString = '<svg class="social-email" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" xml:space="preserve"><path d="M30,15c0,8.3-6.7,15-15,15C6.7,30,0,23.3,0,15C0,6.7,6.7,0,15,0C23.3,0,30,6.7,30,15z M24.4,9.3c0-0.7-0.5-1.2-1.2-1.2H6.8c-0.7,0-1.2,0.5-1.2,1.2l9.4,7L24.4,9.3z M24.4,11.7l-9.4,7l-9.4-7v9c0,0.7,0.5,1.2,1.2,1.2h16.4c0.7,0,1.2-0.5,1.2-1.2V11.7z"/></svg>';
                        else theString = '<svg class="social-email" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-484 486 30 30" xml:space="preserve"><path d="M-469,502.9l-15-11.3c0-1,0.8-1.9,1.9-1.9h26.3c1,0,1.9,0.8,1.9,1.9L-469,502.9z M-469,506.2l15-11.3v15.4c0,1-0.8,1.9-1.9,1.9h-26.3c-1,0-1.9-0.8-1.9-1.9V495L-469,506.2z"/></svg>';
                        break;
                    case "behance":
                        if (element.classList.contains("circle")) theString = '<svg class="social-behance" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve"> <path d="M30,15c0,8.3-6.7,15-15,15C6.7,30,0,23.3,0,15S6.7,0,15,0C23.3,0,30,6.7,30,15z M15.5,17.4c0-2.5-2-3-2-3 c0.3-0.2,1.6-0.7,1.6-2.6c0-2.1-1.6-3.3-3.9-3.3H5v12.7h5.7C14.3,21.3,15.5,19.3,15.5,17.4z M10.6,13.5H7.9v-2.8h2.4 c1.4,0,2.2,0.2,2.2,1.4C12.5,13.2,11.7,13.5,10.6,13.5z M12.7,17.2c0,1-0.5,1.8-2.1,1.8H7.9v-3.4h2.7C12,15.7,12.7,16.2,12.7,17.2z M25.6,17.2v-0.6c0-3.1-1.6-4.9-4.5-4.9c-2.6,0-4.5,1.6-4.5,4.9c0,3.1,1.9,4.8,4.6,4.8c2.2,0,3.9-1.2,4.3-3h-2.4c0,0-0.4,1-1.8,1 c-1.2,0-2.3-0.8-2.3-2.3H25.6z M18.4,10h5.5V8.7h-5.5V10z M23.2,15.6H19c0.1-1,0.8-1.9,2.1-1.9C22.3,13.7,23.2,14.5,23.2,15.6z M23.2,15.6H19c0.1-1,0.8-1.9,2.1-1.9C22.3,13.7,23.2,14.5,23.2,15.6z M23.2,15.6H19c0.1-1,0.8-1.9,2.1-1.9 C22.3,13.7,23.2,14.5,23.2,15.6z"/> </svg>';
                        else theString = '<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Behance icon</title><path d="M6.938 4.503c.702 0 1.34.06 1.92.188.577.13 1.07.33 1.485.61.41.28.733.65.96 1.12.225.47.34 1.05.34 1.73 0 .74-.17 1.36-.507 1.86-.338.5-.837.9-1.502 1.22.906.26 1.576.72 2.022 1.37.448.66.665 1.45.665 2.36 0 .75-.13 1.39-.41 1.93-.28.55-.67 1-1.16 1.35-.48.348-1.05.6-1.67.767-.61.165-1.252.254-1.91.254H0V4.51h6.938v-.007zM16.94 16.665c.44.428 1.073.643 1.894.643.59 0 1.1-.148 1.53-.447.424-.29.68-.61.78-.94h2.588c-.403 1.28-1.048 2.2-1.9 2.75-.85.56-1.884.83-3.08.83-.837 0-1.584-.13-2.272-.4-.673-.27-1.24-.65-1.72-1.14-.464-.49-.823-1.08-1.077-1.77-.253-.69-.373-1.45-.373-2.27 0-.803.135-1.54.403-2.23.27-.7.644-1.28 1.12-1.79.495-.51 1.063-.895 1.736-1.194s1.4-.433 2.22-.433c.91 0 1.69.164 2.38.523.67.34 1.22.82 1.66 1.4.44.586.75 1.26.94 2.02.19.75.25 1.54.21 2.38h-7.69c0 .84.28 1.632.71 2.065l-.08.03zm-10.24.05c.317 0 .62-.03.906-.093.29-.06.548-.165.763-.3.21-.135.39-.328.52-.583.13-.24.19-.57.19-.96 0-.75-.22-1.29-.64-1.62-.43-.32-.99-.48-1.69-.48H3.24v4.05H6.7v-.03zm13.607-5.65c-.352-.385-.94-.592-1.657-.592-.468 0-.855.074-1.166.238-.302.15-.55.35-.74.59-.19.24-.317.48-.392.75-.075.26-.12.5-.135.71h4.762c-.07-.75-.33-1.3-.68-1.69v.01zM6.52 10.45c.574 0 1.05-.134 1.425-.412.374-.27.554-.72.554-1.338 0-.344-.07-.625-.18-.846-.13-.22-.3-.39-.5-.512-.21-.124-.45-.21-.72-.257-.27-.053-.56-.074-.84-.074H3.23v3.44h3.29zm9.098-4.958h5.968v1.454h-5.968V5.48v.01z"/></svg>';
                        break;
                }
                link.innerHTML = theString;
                linkParent.classList.add("loaded");
            }
        }
    }
}


function $b788d8893749da9b$export$2e2bcd8739ae039(el) {
    for(let x = 0; x < el.length; ++x){
        let element = el[x];
        let row = element.querySelectorAll(".row");
        for(let r = 0; r < row.length; ++r)$b788d8893749da9b$var$justifyRows(row[r], element);
        if (element.classList.contains("last-row")) $b788d8893749da9b$var$lastRowCheck(element);
    }
}
function $b788d8893749da9b$var$lastRowCheck(el) {
    let rows = el.querySelectorAll(".row");
    let lastIndex = rows.length - 1;
    let lastRow = rows[lastIndex].querySelectorAll(".cell");
    let cellCount = lastRow.length;
    // if only 1 cell found we need to restrict width
    if (cellCount == 1) {
        let cell = lastRow[0];
        let img = cell.querySelector("img.photo");
        let cellRatio = cell.getAttribute("data-ratio");
        let newW = innerWidth * 0.3;
        cell.style.width = newW + "px";
        img.style.height = newW * cellRatio + "px";
    }
}
// Justified, row-based grid:
// ====================================
function $b788d8893749da9b$var$justifyRows(row, container) {
    let rowsMargin = container.getAttribute("data-margin"), img = row.querySelectorAll("img"), cell = row.querySelectorAll(".cell"), fh = 0, total = 0, imgCount = 0, num = img.length;
    if (innerWidth <= 896) rowsMargin = container.getAttribute("data-mobile-margin");
    let deductMargin = rowsMargin * (num - 1);
    let containerWidth = container.offsetWidth - deductMargin;
    if (img.length) fh = row.querySelector("img").getAttribute("data-height");
    // step 1: collect aspect ratios, set new aspect ratios based on a uniform height (we'll use the first image as our baseline)
    for(let i = 0; i < num; ++i){
        var _this = img[i], ow = _this.getAttribute("data-width"), oh = _this.getAttribute("data-height"), r = oh / ow, wh = fh, ww = wh / r; // new "working" width
        // set new width, height, and ratio attributes, based on our "working" height
        _this.setAttribute("data-width", ww);
        _this.setAttribute("data-height", wh);
        _this.setAttribute("data-ratio", r);
        // add new width to our "total width" number.
        total += ww;
        imgCount++;
        if (imgCount == num) setImageDimensions(total);
    }
    function setImageDimensions(total) {
        for(let i = 0; i < num; ++i){
            let _this = img[i], ww = _this.getAttribute("data-width"), r = _this.getAttribute("data-ratio"), wh = _this.getAttribute("data-height");
            // image's width percentage (of "total"), in decimal format:
            let percentage = ww / total;
            // image's width percentage, relative to the container's width:
            let relativeWidth = percentage * containerWidth, // set image's height, based on its aspect ratio:
            // newHeight = adjustedPercentage * r,
            newHeight = relativeWidth * r, // set a consistent height ratio value, relative to the container's width:
            heightRatio = newHeight / containerWidth;
            // set some things on the CELL level, so we can access them on resize
            let imgCell = _this.closest(".cell");
            imgCell.style.marginBottom = rowsMargin + "px";
            imgCell.style.width = containerWidth * percentage + "px";
            imgCell.setAttribute("data-ratio", r);
            imgCell.setAttribute("data-percW", percentage);
            imgCell.setAttribute("data-percH", heightRatio);
            imgCell.setAttribute("data-numImages", num);
            // set height of the image:
            _this.style.height = newHeight + "px";
        }
    }
    /* HANDLE WINDOW RESIZE */ function reportWindowSize() {
        // handle resizing of AR Rows
        let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
        for(let i = 0; i < arRowsCell.length; ++i){
            var _this = arRowsCell[i], container = _this.closest(".ar-rows"), rowsMargin = container.getAttribute("data-margin"), percW = _this.getAttribute("data-percW"), percH = _this.getAttribute("data-percH"), ratio = _this.getAttribute("data-ratio"), num = _this.getAttribute("data-numImages");
            if (innerWidth <= 896) rowsMargin = container.getAttribute("data-mobile-margin");
            let containerWidth = container.offsetWidth - rowsMargin * (num - 1);
            _this.style.width = containerWidth * percW + "px";
            let cellImg = _this.querySelector("img");
            cellImg.style.height = ratio * (containerWidth * percW) + "px";
        }
        let arRowsLastRows = document.querySelectorAll(".ar-rows.last-row");
        arRowsLastRows.forEach((arRowsLastRow)=>{
            $b788d8893749da9b$var$lastRowCheck(arRowsLastRow);
        });
    }
    window.addEventListener("resize", reportWindowSize);
} // end justifyRows()



var $g0Kki = parcelRequire("g0Kki");
/*!
 * CSSPlugin 3.15.0
 * https://gsap.com
 *
 * Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $g0Kki = parcelRequire("g0Kki");
var $46da03bca3b171b9$var$_win, $46da03bca3b171b9$var$_doc, $46da03bca3b171b9$var$_docElement, $46da03bca3b171b9$var$_pluginInitted, $46da03bca3b171b9$var$_tempDiv, $46da03bca3b171b9$var$_tempDivStyler, $46da03bca3b171b9$var$_recentSetterPlugin, $46da03bca3b171b9$var$_reverting, $46da03bca3b171b9$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $46da03bca3b171b9$var$_transformProps = {}, $46da03bca3b171b9$var$_RAD2DEG = 180 / Math.PI, $46da03bca3b171b9$var$_DEG2RAD = Math.PI / 180, $46da03bca3b171b9$var$_atan2 = Math.atan2, $46da03bca3b171b9$var$_bigNum = 1e8, $46da03bca3b171b9$var$_capsExp = /([A-Z])/g, $46da03bca3b171b9$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $46da03bca3b171b9$var$_complexExp = /[\s,\(]\S/, $46da03bca3b171b9$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $46da03bca3b171b9$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $46da03bca3b171b9$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $46da03bca3b171b9$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$46da03bca3b171b9$var$_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$46da03bca3b171b9$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $46da03bca3b171b9$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $46da03bca3b171b9$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $46da03bca3b171b9$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $46da03bca3b171b9$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $46da03bca3b171b9$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $46da03bca3b171b9$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $46da03bca3b171b9$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $46da03bca3b171b9$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $46da03bca3b171b9$var$_transformProp = "transform", $46da03bca3b171b9$var$_transformOriginProp = $46da03bca3b171b9$var$_transformProp + "Origin", $46da03bca3b171b9$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $46da03bca3b171b9$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $46da03bca3b171b9$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $46da03bca3b171b9$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $46da03bca3b171b9$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $46da03bca3b171b9$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $46da03bca3b171b9$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($46da03bca3b171b9$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($46da03bca3b171b9$var$_transformOriginProp, isNotCSS, "");
        }
        property = $46da03bca3b171b9$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $46da03bca3b171b9$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $46da03bca3b171b9$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($46da03bca3b171b9$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $46da03bca3b171b9$var$_reverting();
        if ((!i || !i.isStart) && !style[$46da03bca3b171b9$var$_transformProp]) {
            $46da03bca3b171b9$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$46da03bca3b171b9$var$_transformOriginProp]) {
                style[$46da03bca3b171b9$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $46da03bca3b171b9$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $46da03bca3b171b9$var$_revertStyle,
        save: $46da03bca3b171b9$var$_saveStyle
    };
    target._gsap || (0, $g0Kki.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $46da03bca3b171b9$var$_supports3D, $46da03bca3b171b9$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $46da03bca3b171b9$var$_doc.createElementNS ? $46da03bca3b171b9$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $46da03bca3b171b9$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $46da03bca3b171b9$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $46da03bca3b171b9$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($46da03bca3b171b9$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $46da03bca3b171b9$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $46da03bca3b171b9$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $46da03bca3b171b9$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $46da03bca3b171b9$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($46da03bca3b171b9$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $46da03bca3b171b9$var$_prefixes[i] : "") + property;
}, $46da03bca3b171b9$var$_initCore = function _initCore() {
    if ($46da03bca3b171b9$var$_windowExists() && window.document) {
        $46da03bca3b171b9$var$_win = window;
        $46da03bca3b171b9$var$_doc = $46da03bca3b171b9$var$_win.document;
        $46da03bca3b171b9$var$_docElement = $46da03bca3b171b9$var$_doc.documentElement;
        $46da03bca3b171b9$var$_tempDiv = $46da03bca3b171b9$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $46da03bca3b171b9$var$_tempDivStyler = $46da03bca3b171b9$export$a232bb0480ae674a("div");
        $46da03bca3b171b9$var$_transformProp = $46da03bca3b171b9$export$8cbef5dd49a09c8b($46da03bca3b171b9$var$_transformProp);
        $46da03bca3b171b9$var$_transformOriginProp = $46da03bca3b171b9$var$_transformProp + "Origin";
        $46da03bca3b171b9$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $46da03bca3b171b9$var$_supports3D = !!$46da03bca3b171b9$export$8cbef5dd49a09c8b("perspective");
        $46da03bca3b171b9$var$_reverting = (0, $g0Kki.gsap).core.reverting;
        $46da03bca3b171b9$var$_pluginInitted = 1;
    }
}, $46da03bca3b171b9$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $46da03bca3b171b9$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $46da03bca3b171b9$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $46da03bca3b171b9$var$_docElement.removeChild(svg);
    return bbox;
}, $46da03bca3b171b9$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $46da03bca3b171b9$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $46da03bca3b171b9$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $46da03bca3b171b9$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$46da03bca3b171b9$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$46da03bca3b171b9$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $46da03bca3b171b9$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $46da03bca3b171b9$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$46da03bca3b171b9$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $46da03bca3b171b9$var$_transformProps && property !== $46da03bca3b171b9$var$_transformOriginProp) property = $46da03bca3b171b9$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($46da03bca3b171b9$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $46da03bca3b171b9$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $g0Kki.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $46da03bca3b171b9$var$_renderNonTweeningValueOnlyAtEnd : $46da03bca3b171b9$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $46da03bca3b171b9$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $46da03bca3b171b9$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$46da03bca3b171b9$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $46da03bca3b171b9$var$_tempDiv.style, horizontal = $46da03bca3b171b9$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $46da03bca3b171b9$var$_nonConvertibleUnits[unit] || $46da03bca3b171b9$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $46da03bca3b171b9$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($46da03bca3b171b9$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $g0Kki._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $46da03bca3b171b9$var$_doc || !parent.appendChild) parent = $46da03bca3b171b9$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $g0Kki._ticker).time && !cache.uncache) return (0, $g0Kki._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $46da03bca3b171b9$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$46da03bca3b171b9$var$_nonStandardLayouts[$46da03bca3b171b9$var$_getComputedProperty(parent, "display")] && (style.position = $46da03bca3b171b9$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($46da03bca3b171b9$var$_tempDiv);
            px = $46da03bca3b171b9$var$_tempDiv[measureProperty];
            parent.removeChild($46da03bca3b171b9$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $g0Kki._getCache)(parent);
            cache.time = (0, $g0Kki._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $g0Kki._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $46da03bca3b171b9$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $46da03bca3b171b9$var$_pluginInitted || $46da03bca3b171b9$var$_initCore();
    if (property in $46da03bca3b171b9$var$_propertyAliases && property !== "transform") {
        property = $46da03bca3b171b9$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($46da03bca3b171b9$var$_transformProps[property] && property !== "transform") {
        value = $46da03bca3b171b9$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $46da03bca3b171b9$var$_firstTwoOnly($46da03bca3b171b9$var$_getComputedProperty(target, $46da03bca3b171b9$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $46da03bca3b171b9$var$_specialProps[property] && $46da03bca3b171b9$var$_specialProps[property](target, property, unit) || $46da03bca3b171b9$var$_getComputedProperty(target, property) || (0, $g0Kki._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $46da03bca3b171b9$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $46da03bca3b171b9$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $46da03bca3b171b9$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $46da03bca3b171b9$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $46da03bca3b171b9$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $g0Kki.PropTween)(this._pt, target.style, prop, 0, 1, (0, $g0Kki._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $46da03bca3b171b9$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $46da03bca3b171b9$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $46da03bca3b171b9$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $g0Kki._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $g0Kki._numWithUnitExp)) || [];
    endValues = end.match((0, $g0Kki._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $g0Kki._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $g0Kki._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $g0Kki._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $g0Kki._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $46da03bca3b171b9$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $46da03bca3b171b9$var$_renderNonTweeningValueOnlyAtEnd : $46da03bca3b171b9$var$_renderNonTweeningValue;
    (0, $g0Kki._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $46da03bca3b171b9$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $46da03bca3b171b9$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $46da03bca3b171b9$var$_keywordToPercent[x] || x;
    split[1] = $46da03bca3b171b9$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $46da03bca3b171b9$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($46da03bca3b171b9$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $46da03bca3b171b9$var$_transformOriginProp : $46da03bca3b171b9$var$_transformProp;
                }
                $46da03bca3b171b9$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $46da03bca3b171b9$var$_removeProperty(target, $46da03bca3b171b9$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $46da03bca3b171b9$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $46da03bca3b171b9$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$46da03bca3b171b9$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $g0Kki.PropTween)(plugin._pt, target, property, 0, 0, $46da03bca3b171b9$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $46da03bca3b171b9$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $46da03bca3b171b9$var$_rotationalProperties = {}, $46da03bca3b171b9$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $46da03bca3b171b9$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $46da03bca3b171b9$var$_getComputedProperty(target, $46da03bca3b171b9$var$_transformProp);
    return $46da03bca3b171b9$var$_isNullTransform(matrixString) ? $46da03bca3b171b9$var$_identity2DMatrix : matrixString.substr(7).match((0, $g0Kki._numExp)).map((0, $g0Kki._round));
}, $46da03bca3b171b9$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $g0Kki._getCache)(target), style = target.style, matrix = $46da03bca3b171b9$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $46da03bca3b171b9$var$_identity2DMatrix : matrix;
    } else if (matrix === $46da03bca3b171b9$var$_identity2DMatrix && !target.offsetParent && target !== $46da03bca3b171b9$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $46da03bca3b171b9$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $46da03bca3b171b9$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $46da03bca3b171b9$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $46da03bca3b171b9$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $46da03bca3b171b9$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $46da03bca3b171b9$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $46da03bca3b171b9$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $46da03bca3b171b9$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$46da03bca3b171b9$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $46da03bca3b171b9$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $46da03bca3b171b9$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $46da03bca3b171b9$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $46da03bca3b171b9$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $46da03bca3b171b9$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $g0Kki.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $46da03bca3b171b9$var$_getComputedProperty(target, $46da03bca3b171b9$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $46da03bca3b171b9$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$46da03bca3b171b9$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$46da03bca3b171b9$var$_transformProp] !== "none" ? cs[$46da03bca3b171b9$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $46da03bca3b171b9$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $46da03bca3b171b9$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $46da03bca3b171b9$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $46da03bca3b171b9$var$_atan2(b, a) * $46da03bca3b171b9$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $46da03bca3b171b9$var$_atan2(c, d) * $46da03bca3b171b9$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $46da03bca3b171b9$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $46da03bca3b171b9$var$_atan2(a32, a33);
            rotationX = angle * $46da03bca3b171b9$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $46da03bca3b171b9$var$_atan2(-c, a33);
            rotationY = angle * $46da03bca3b171b9$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $46da03bca3b171b9$var$_atan2(b, a);
            rotation = angle * $46da03bca3b171b9$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $g0Kki._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $g0Kki._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $46da03bca3b171b9$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $46da03bca3b171b9$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$46da03bca3b171b9$var$_isNullTransform($46da03bca3b171b9$var$_getComputedProperty(target, $46da03bca3b171b9$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $g0Kki._round)(scaleX);
    cache.scaleY = (0, $g0Kki._round)(scaleY);
    cache.rotation = (0, $g0Kki._round)(rotation) + deg;
    cache.rotationX = (0, $g0Kki._round)(rotationX) + deg;
    cache.rotationY = (0, $g0Kki._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$46da03bca3b171b9$var$_transformOriginProp] = $46da03bca3b171b9$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $g0Kki._config).force3D;
    cache.renderTransform = cache.svg ? $46da03bca3b171b9$var$_renderSVGTransforms : $46da03bca3b171b9$var$_supports3D ? $46da03bca3b171b9$var$_renderCSSTransforms : $46da03bca3b171b9$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $46da03bca3b171b9$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$46da03bca3b171b9$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $g0Kki.getUnit)(start);
    return (0, $g0Kki._round)(parseFloat(start) + parseFloat($46da03bca3b171b9$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $46da03bca3b171b9$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $46da03bca3b171b9$var$_renderCSSTransforms(ratio, cache);
}, $46da03bca3b171b9$var$_zeroDeg = "0deg", $46da03bca3b171b9$var$_zeroPx = "0px", $46da03bca3b171b9$var$_endParenthesis = ") ", $46da03bca3b171b9$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $46da03bca3b171b9$var$_zeroDeg || rotationY !== $46da03bca3b171b9$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $46da03bca3b171b9$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $46da03bca3b171b9$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $46da03bca3b171b9$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $46da03bca3b171b9$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $46da03bca3b171b9$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $46da03bca3b171b9$var$_zeroPx) transforms += "perspective(" + transformPerspective + $46da03bca3b171b9$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $46da03bca3b171b9$var$_zeroPx || y !== $46da03bca3b171b9$var$_zeroPx || z !== $46da03bca3b171b9$var$_zeroPx) transforms += z !== $46da03bca3b171b9$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $46da03bca3b171b9$var$_endParenthesis;
    if (rotation !== $46da03bca3b171b9$var$_zeroDeg) transforms += "rotate(" + rotation + $46da03bca3b171b9$var$_endParenthesis;
    if (rotationY !== $46da03bca3b171b9$var$_zeroDeg) transforms += "rotateY(" + rotationY + $46da03bca3b171b9$var$_endParenthesis;
    if (rotationX !== $46da03bca3b171b9$var$_zeroDeg) transforms += "rotateX(" + rotationX + $46da03bca3b171b9$var$_endParenthesis;
    if (skewX !== $46da03bca3b171b9$var$_zeroDeg || skewY !== $46da03bca3b171b9$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $46da03bca3b171b9$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $46da03bca3b171b9$var$_endParenthesis;
    target.style[$46da03bca3b171b9$var$_transformProp] = transforms || "translate(0, 0)";
}, $46da03bca3b171b9$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $46da03bca3b171b9$var$_DEG2RAD;
        skewX *= $46da03bca3b171b9$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $46da03bca3b171b9$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $g0Kki._round)(a11);
        a21 = (0, $g0Kki._round)(a21);
        a12 = (0, $g0Kki._round)(a12);
        a22 = (0, $g0Kki._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $46da03bca3b171b9$var$_convertToUnit(target, "x", x, "px");
        ty = $46da03bca3b171b9$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $g0Kki._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $g0Kki._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $g0Kki._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $g0Kki._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$46da03bca3b171b9$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $46da03bca3b171b9$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $g0Kki._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $46da03bca3b171b9$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $46da03bca3b171b9$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $46da03bca3b171b9$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $g0Kki.PropTween)(plugin._pt, target, property, startNum, change, $46da03bca3b171b9$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $46da03bca3b171b9$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $46da03bca3b171b9$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $46da03bca3b171b9$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$46da03bca3b171b9$var$_transformProp] = transforms;
        endCache = $46da03bca3b171b9$var$_parseTransform(target, 1);
        $46da03bca3b171b9$var$_removeProperty(target, $46da03bca3b171b9$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$46da03bca3b171b9$var$_transformProp];
        style[$46da03bca3b171b9$var$_transformProp] = transforms;
        endCache = $46da03bca3b171b9$var$_parseTransform(target, 1);
        style[$46da03bca3b171b9$var$_transformProp] = startValue;
    }
    for(p in $46da03bca3b171b9$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $g0Kki.getUnit)(startValue);
            endUnit = (0, $g0Kki.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $46da03bca3b171b9$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $g0Kki.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $46da03bca3b171b9$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $46da03bca3b171b9$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $g0Kki._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $46da03bca3b171b9$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $46da03bca3b171b9$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $46da03bca3b171b9$export$855822f522f18eef = {
    name: "css",
    register: $46da03bca3b171b9$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        $46da03bca3b171b9$var$_pluginInitted || $46da03bca3b171b9$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $46da03bca3b171b9$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $g0Kki._plugins)[p] && (0, $g0Kki._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $46da03bca3b171b9$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $g0Kki._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $g0Kki._colorExp).lastIndex = 0;
                if (!(0, $g0Kki._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $g0Kki.getUnit)(startValue);
                    endUnit = (0, $g0Kki.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = $46da03bca3b171b9$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $g0Kki._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $g0Kki._replaceRandom)(startValue));
                    (0, $g0Kki.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $g0Kki._config).units[p] || (0, $g0Kki.getUnit)($46da03bca3b171b9$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $46da03bca3b171b9$var$_get(target, p)); // can't work with relative values
                } else startValue = $46da03bca3b171b9$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $46da03bca3b171b9$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $46da03bca3b171b9$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $46da03bca3b171b9$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $46da03bca3b171b9$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $46da03bca3b171b9$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $46da03bca3b171b9$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = $46da03bca3b171b9$var$_getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : $46da03bca3b171b9$var$_removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $46da03bca3b171b9$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $g0Kki.PropTween)(this._pt, style, $46da03bca3b171b9$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $g0Kki.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $g0Kki._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $46da03bca3b171b9$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($46da03bca3b171b9$var$_transformOriginProp, 0, style[$46da03bca3b171b9$var$_transformOriginProp]);
                        endValue = $46da03bca3b171b9$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $46da03bca3b171b9$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $46da03bca3b171b9$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $46da03bca3b171b9$var$_addNonTweeningPT(this, style, p, $46da03bca3b171b9$var$_firstTwoOnly(startValue), $46da03bca3b171b9$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $46da03bca3b171b9$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $46da03bca3b171b9$var$_rotationalProperties) {
                        $46da03bca3b171b9$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $g0Kki._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $46da03bca3b171b9$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $46da03bca3b171b9$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $46da03bca3b171b9$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$46da03bca3b171b9$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $g0Kki.getUnit)(endValue) || (p in (0, $g0Kki._config).units ? (0, $g0Kki._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $46da03bca3b171b9$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $g0Kki.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $g0Kki._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $46da03bca3b171b9$var$_renderRoundedCSSProp : $46da03bca3b171b9$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = $46da03bca3b171b9$var$_renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $46da03bca3b171b9$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $g0Kki._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $46da03bca3b171b9$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $g0Kki._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$46da03bca3b171b9$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $46da03bca3b171b9$var$_get,
    aliases: $46da03bca3b171b9$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $46da03bca3b171b9$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $46da03bca3b171b9$var$_transformProps && property !== $46da03bca3b171b9$var$_transformOriginProp && (target._gsap.x || $46da03bca3b171b9$var$_get(target, "x")) ? plugin && $46da03bca3b171b9$var$_recentSetterPlugin === plugin ? property === "scale" ? $46da03bca3b171b9$var$_setterScale : $46da03bca3b171b9$var$_setterTransform : ($46da03bca3b171b9$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $46da03bca3b171b9$var$_setterScaleWithRender : $46da03bca3b171b9$var$_setterTransformWithRender) : target.style && !(0, $g0Kki._isUndefined)(target.style[property]) ? $46da03bca3b171b9$var$_setterCSSStyle : ~property.indexOf("-") ? $46da03bca3b171b9$var$_setterCSSProp : (0, $g0Kki._getSetter)(target, property);
    },
    core: {
        _removeProperty: $46da03bca3b171b9$var$_removeProperty,
        _getMatrix: $46da03bca3b171b9$var$_getMatrix
    }
};
(0, $g0Kki.gsap).utils.checkPrefix = $46da03bca3b171b9$export$8cbef5dd49a09c8b;
(0, $g0Kki.gsap).core.getStyleSaver = $46da03bca3b171b9$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $g0Kki._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $46da03bca3b171b9$var$_transformProps[name] = 1;
    });
    (0, $g0Kki._forEachName)(rotation, function(name) {
        (0, $g0Kki._config).units[name] = "deg";
        $46da03bca3b171b9$var$_rotationalProperties[name] = 1;
    });
    $46da03bca3b171b9$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $g0Kki._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $46da03bca3b171b9$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $g0Kki._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $g0Kki._config).units[name] = "px";
});
(0, $g0Kki.gsap).registerPlugin($46da03bca3b171b9$export$855822f522f18eef);


var $bccfb5b824bd0d33$export$99ee26438460406a = (0, $g0Kki.gsap).registerPlugin((0, $46da03bca3b171b9$export$855822f522f18eef)) || (0, $g0Kki.gsap), // to protect from tree shaking
$bccfb5b824bd0d33$export$7b23975ad686bf91 = $bccfb5b824bd0d33$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $9b6b11f247395bd5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9b6b11f247395bd5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9b6b11f247395bd5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9b6b11f247395bd5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $9b6b11f247395bd5$var$gsap, $9b6b11f247395bd5$var$_coreInitted, $9b6b11f247395bd5$var$_clamp, $9b6b11f247395bd5$var$_win, $9b6b11f247395bd5$var$_doc, $9b6b11f247395bd5$var$_docEl, $9b6b11f247395bd5$var$_body, $9b6b11f247395bd5$var$_isTouch, $9b6b11f247395bd5$var$_pointerType, $9b6b11f247395bd5$var$ScrollTrigger, $9b6b11f247395bd5$var$_root, $9b6b11f247395bd5$var$_normalizer, $9b6b11f247395bd5$var$_eventTypes, $9b6b11f247395bd5$var$_context, $9b6b11f247395bd5$var$_getGSAP = function _getGSAP() {
    return $9b6b11f247395bd5$var$gsap || typeof window !== "undefined" && ($9b6b11f247395bd5$var$gsap = window.gsap) && $9b6b11f247395bd5$var$gsap.registerPlugin && $9b6b11f247395bd5$var$gsap;
}, $9b6b11f247395bd5$var$_startup = 1, $9b6b11f247395bd5$var$_observers = [], $9b6b11f247395bd5$export$3cd1cee43d19b683 = [], $9b6b11f247395bd5$export$d8e56d510a804d0a = [], $9b6b11f247395bd5$var$_getTime = Date.now, $9b6b11f247395bd5$var$_bridge = function _bridge(name, value) {
    return value;
}, $9b6b11f247395bd5$var$_integrate = function _integrate() {
    var core = $9b6b11f247395bd5$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $9b6b11f247395bd5$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $9b6b11f247395bd5$export$d8e56d510a804d0a);
    $9b6b11f247395bd5$export$3cd1cee43d19b683 = scrollers;
    $9b6b11f247395bd5$export$d8e56d510a804d0a = proxies;
    $9b6b11f247395bd5$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $9b6b11f247395bd5$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$9b6b11f247395bd5$export$d8e56d510a804d0a.indexOf(element) && $9b6b11f247395bd5$export$d8e56d510a804d0a[$9b6b11f247395bd5$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $9b6b11f247395bd5$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$9b6b11f247395bd5$var$_root.indexOf(el);
}, $9b6b11f247395bd5$var$_addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, $9b6b11f247395bd5$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $9b6b11f247395bd5$var$_scrollLeft = "scrollLeft", $9b6b11f247395bd5$var$_scrollTop = "scrollTop", $9b6b11f247395bd5$var$_onScroll = function _onScroll() {
    return $9b6b11f247395bd5$var$_normalizer && $9b6b11f247395bd5$var$_normalizer.isPressed || $9b6b11f247395bd5$export$3cd1cee43d19b683.cache++;
}, $9b6b11f247395bd5$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $9b6b11f247395bd5$var$_startup && ($9b6b11f247395bd5$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $9b6b11f247395bd5$var$_normalizer && $9b6b11f247395bd5$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($9b6b11f247395bd5$var$_normalizer && $9b6b11f247395bd5$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $9b6b11f247395bd5$export$3cd1cee43d19b683.cache;
            isNormalizing && $9b6b11f247395bd5$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $9b6b11f247395bd5$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $9b6b11f247395bd5$var$_bridge("ref")) {
            cachingFunc.cacheID = $9b6b11f247395bd5$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $9b6b11f247395bd5$export$b2cabb342cb0ebe1 = {
    s: $9b6b11f247395bd5$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $9b6b11f247395bd5$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $9b6b11f247395bd5$var$_win.scrollTo(value, $9b6b11f247395bd5$export$8e40fc98ff518e9d.sc()) : $9b6b11f247395bd5$var$_win.pageXOffset || $9b6b11f247395bd5$var$_doc[$9b6b11f247395bd5$var$_scrollLeft] || $9b6b11f247395bd5$var$_docEl[$9b6b11f247395bd5$var$_scrollLeft] || $9b6b11f247395bd5$var$_body[$9b6b11f247395bd5$var$_scrollLeft] || 0;
    })
}, $9b6b11f247395bd5$export$8e40fc98ff518e9d = {
    s: $9b6b11f247395bd5$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $9b6b11f247395bd5$export$b2cabb342cb0ebe1,
    sc: $9b6b11f247395bd5$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $9b6b11f247395bd5$var$_win.scrollTo($9b6b11f247395bd5$export$b2cabb342cb0ebe1.sc(), value) : $9b6b11f247395bd5$var$_win.pageYOffset || $9b6b11f247395bd5$var$_doc[$9b6b11f247395bd5$var$_scrollTop] || $9b6b11f247395bd5$var$_docEl[$9b6b11f247395bd5$var$_scrollTop] || $9b6b11f247395bd5$var$_body[$9b6b11f247395bd5$var$_scrollTop] || 0;
    })
}, $9b6b11f247395bd5$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $9b6b11f247395bd5$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $9b6b11f247395bd5$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $9b6b11f247395bd5$var$_isWithin = function _isWithin(element, list) {
    // check if the element is in the list or is a descendant of an element in the list.
    var i = list.length;
    while(i--){
        if (list[i] === element || list[i].contains(element)) return true;
    }
    return false;
}, $9b6b11f247395bd5$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $9b6b11f247395bd5$export$4330f3a92e5d2e94(element) && (element = $9b6b11f247395bd5$var$_doc.scrollingElement || $9b6b11f247395bd5$var$_docEl);
    var i = $9b6b11f247395bd5$export$3cd1cee43d19b683.indexOf(element), offset = sc === $9b6b11f247395bd5$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $9b6b11f247395bd5$export$3cd1cee43d19b683.push(element) - 1);
    $9b6b11f247395bd5$export$3cd1cee43d19b683[i + offset] || $9b6b11f247395bd5$var$_addListener(element, "scroll", $9b6b11f247395bd5$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $9b6b11f247395bd5$export$3cd1cee43d19b683[i + offset], func = prev || ($9b6b11f247395bd5$export$3cd1cee43d19b683[i + offset] = $9b6b11f247395bd5$var$_scrollCacheFunc($9b6b11f247395bd5$export$6078f1ef08b38af9(element, s), true) || ($9b6b11f247395bd5$export$4330f3a92e5d2e94(element) ? sc : $9b6b11f247395bd5$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $9b6b11f247395bd5$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $9b6b11f247395bd5$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $9b6b11f247395bd5$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $9b6b11f247395bd5$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $9b6b11f247395bd5$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $9b6b11f247395bd5$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.cancelable !== false && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $9b6b11f247395bd5$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $9b6b11f247395bd5$var$_setScrollTrigger = function _setScrollTrigger() {
    $9b6b11f247395bd5$var$ScrollTrigger = $9b6b11f247395bd5$var$gsap.core.globals().ScrollTrigger;
    $9b6b11f247395bd5$var$ScrollTrigger && $9b6b11f247395bd5$var$ScrollTrigger.core && $9b6b11f247395bd5$var$_integrate();
}, $9b6b11f247395bd5$var$_initCore = function _initCore(core) {
    $9b6b11f247395bd5$var$gsap = core || $9b6b11f247395bd5$var$_getGSAP();
    if (!$9b6b11f247395bd5$var$_coreInitted && $9b6b11f247395bd5$var$gsap && typeof document !== "undefined" && document.body) {
        $9b6b11f247395bd5$var$_win = window;
        $9b6b11f247395bd5$var$_doc = document;
        $9b6b11f247395bd5$var$_docEl = $9b6b11f247395bd5$var$_doc.documentElement;
        $9b6b11f247395bd5$var$_body = $9b6b11f247395bd5$var$_doc.body;
        $9b6b11f247395bd5$var$_root = [
            $9b6b11f247395bd5$var$_win,
            $9b6b11f247395bd5$var$_doc,
            $9b6b11f247395bd5$var$_docEl,
            $9b6b11f247395bd5$var$_body
        ];
        $9b6b11f247395bd5$var$_clamp = $9b6b11f247395bd5$var$gsap.utils.clamp;
        $9b6b11f247395bd5$var$_context = $9b6b11f247395bd5$var$gsap.core.context || function() {};
        $9b6b11f247395bd5$var$_pointerType = "onpointerenter" in $9b6b11f247395bd5$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $9b6b11f247395bd5$var$_isTouch = $9b6b11f247395bd5$export$c1cbdee04e18ea8b.isTouch = $9b6b11f247395bd5$var$_win.matchMedia && $9b6b11f247395bd5$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $9b6b11f247395bd5$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $9b6b11f247395bd5$var$_eventTypes = $9b6b11f247395bd5$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $9b6b11f247395bd5$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $9b6b11f247395bd5$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $9b6b11f247395bd5$var$_startup = 0;
        }, 500);
        $9b6b11f247395bd5$var$_coreInitted = 1;
    }
    $9b6b11f247395bd5$var$ScrollTrigger || $9b6b11f247395bd5$var$_setScrollTrigger(); // Observer might be initted BEFORE ScrollTrigger, so don't put this with the initting code. ScrollTrigger will call Observer.register() when it inits.
    return $9b6b11f247395bd5$var$_coreInitted;
};
$9b6b11f247395bd5$export$b2cabb342cb0ebe1.op = $9b6b11f247395bd5$export$8e40fc98ff518e9d;
$9b6b11f247395bd5$export$3cd1cee43d19b683.cache = 0;
var $9b6b11f247395bd5$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $9b6b11f247395bd5$var$_coreInitted || $9b6b11f247395bd5$var$_initCore($9b6b11f247395bd5$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $9b6b11f247395bd5$var$ScrollTrigger || $9b6b11f247395bd5$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $9b6b11f247395bd5$export$937374fea3f88711(target) || $9b6b11f247395bd5$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $9b6b11f247395bd5$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($9b6b11f247395bd5$var$_win.getComputedStyle($9b6b11f247395bd5$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = $9b6b11f247395bd5$export$8665aac53dad5647(target, $9b6b11f247395bd5$export$b2cabb342cb0ebe1), scrollFuncY = $9b6b11f247395bd5$export$8665aac53dad5647(target, $9b6b11f247395bd5$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $9b6b11f247395bd5$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $9b6b11f247395bd5$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $9b6b11f247395bd5$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $9b6b11f247395bd5$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && $9b6b11f247395bd5$var$_isWithin(e.target, ignore) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $9b6b11f247395bd5$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $9b6b11f247395bd5$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDragStart && dragged === 1 && onDragStart(self);
                    onDrag && onDrag(self);
                    dragged = 0;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $9b6b11f247395bd5$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
                dragged || (dragged = isDragging ? 2 : 1); // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $9b6b11f247395bd5$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $9b6b11f247395bd5$var$_addListener(isNormalizer ? target : ownerDoc, $9b6b11f247395bd5$var$_eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $9b6b11f247395bd5$var$_removeListener(isNormalizer ? target : ownerDoc, $9b6b11f247395bd5$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $9b6b11f247395bd5$var$_getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) $9b6b11f247395bd5$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($9b6b11f247395bd5$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $9b6b11f247395bd5$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $9b6b11f247395bd5$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $9b6b11f247395bd5$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $9b6b11f247395bd5$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $9b6b11f247395bd5$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $9b6b11f247395bd5$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $9b6b11f247395bd5$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $9b6b11f247395bd5$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $9b6b11f247395bd5$var$_addListener(isViewport ? ownerDoc : target, "scroll", $9b6b11f247395bd5$var$_onScroll);
                type.indexOf("scroll") >= 0 && $9b6b11f247395bd5$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && $9b6b11f247395bd5$var$_addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && $9b6b11f247395bd5$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $9b6b11f247395bd5$var$_addListener(target, $9b6b11f247395bd5$var$_eventTypes[0], _onPress, passive, capture);
                    $9b6b11f247395bd5$var$_addListener(ownerDoc, $9b6b11f247395bd5$var$_eventTypes[2], _onRelease);
                    $9b6b11f247395bd5$var$_addListener(ownerDoc, $9b6b11f247395bd5$var$_eventTypes[3], _onRelease);
                    allowClicks && $9b6b11f247395bd5$var$_addListener(target, "click", clickCapture, true, true);
                    onClick && $9b6b11f247395bd5$var$_addListener(target, "click", _onClick);
                    onGestureStart && $9b6b11f247395bd5$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $9b6b11f247395bd5$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $9b6b11f247395bd5$var$_addListener(target, $9b6b11f247395bd5$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $9b6b11f247395bd5$var$_addListener(target, $9b6b11f247395bd5$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $9b6b11f247395bd5$var$_addListener(target, $9b6b11f247395bd5$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
                self._vx.reset();
                self._vy.reset();
                scrollX = scrollFuncX();
                scrollY = scrollFuncY();
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $9b6b11f247395bd5$var$_observers.filter(function(o) {
                    return o !== self && $9b6b11f247395bd5$export$4330f3a92e5d2e94(o.target);
                }).length || $9b6b11f247395bd5$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $9b6b11f247395bd5$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $9b6b11f247395bd5$var$_removeListener(isNormalizer ? target : ownerDoc, $9b6b11f247395bd5$var$_eventTypes[1], _onDrag, true);
                }
                $9b6b11f247395bd5$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $9b6b11f247395bd5$var$_removeListener(target, "wheel", _onWheel, capture);
                $9b6b11f247395bd5$var$_removeListener(target, $9b6b11f247395bd5$var$_eventTypes[0], _onPress, capture);
                $9b6b11f247395bd5$var$_removeListener(ownerDoc, $9b6b11f247395bd5$var$_eventTypes[2], _onRelease);
                $9b6b11f247395bd5$var$_removeListener(ownerDoc, $9b6b11f247395bd5$var$_eventTypes[3], _onRelease);
                $9b6b11f247395bd5$var$_removeListener(target, "click", clickCapture, true);
                $9b6b11f247395bd5$var$_removeListener(target, "click", _onClick);
                $9b6b11f247395bd5$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $9b6b11f247395bd5$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $9b6b11f247395bd5$var$_removeListener(target, $9b6b11f247395bd5$var$_pointerType + "enter", _onHover);
                $9b6b11f247395bd5$var$_removeListener(target, $9b6b11f247395bd5$var$_pointerType + "leave", _onHoverEnd);
                $9b6b11f247395bd5$var$_removeListener(target, $9b6b11f247395bd5$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $9b6b11f247395bd5$var$_observers.indexOf(self);
            i >= 0 && $9b6b11f247395bd5$var$_observers.splice(i, 1);
            $9b6b11f247395bd5$var$_normalizer === self && ($9b6b11f247395bd5$var$_normalizer = 0);
        };
        $9b6b11f247395bd5$var$_observers.push(self);
        isNormalizer && $9b6b11f247395bd5$export$4330f3a92e5d2e94(target) && ($9b6b11f247395bd5$var$_normalizer = self);
        self.enable(event);
    };
    $9b6b11f247395bd5$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$9b6b11f247395bd5$export$c1cbdee04e18ea8b.version = "3.15.0";
$9b6b11f247395bd5$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $9b6b11f247395bd5$export$c1cbdee04e18ea8b(vars);
};
$9b6b11f247395bd5$export$c1cbdee04e18ea8b.register = $9b6b11f247395bd5$var$_initCore;
$9b6b11f247395bd5$export$c1cbdee04e18ea8b.getAll = function() {
    return $9b6b11f247395bd5$var$_observers.slice();
};
$9b6b11f247395bd5$export$c1cbdee04e18ea8b.getById = function(id) {
    return $9b6b11f247395bd5$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$9b6b11f247395bd5$var$_getGSAP() && $9b6b11f247395bd5$var$gsap.registerPlugin($9b6b11f247395bd5$export$c1cbdee04e18ea8b);


var $eb3674bbdae15bc9$var$gsap, $eb3674bbdae15bc9$var$_coreInitted, $eb3674bbdae15bc9$var$_win, $eb3674bbdae15bc9$var$_doc, $eb3674bbdae15bc9$var$_docEl, $eb3674bbdae15bc9$var$_body, $eb3674bbdae15bc9$var$_root, $eb3674bbdae15bc9$var$_resizeDelay, $eb3674bbdae15bc9$var$_toArray, $eb3674bbdae15bc9$var$_clamp, $eb3674bbdae15bc9$var$_time2, $eb3674bbdae15bc9$var$_syncInterval, $eb3674bbdae15bc9$var$_refreshing, $eb3674bbdae15bc9$var$_pointerIsDown, $eb3674bbdae15bc9$var$_transformProp, $eb3674bbdae15bc9$var$_i, $eb3674bbdae15bc9$var$_prevWidth, $eb3674bbdae15bc9$var$_prevHeight, $eb3674bbdae15bc9$var$_autoRefresh, $eb3674bbdae15bc9$var$_sort, $eb3674bbdae15bc9$var$_suppressOverwrites, $eb3674bbdae15bc9$var$_ignoreResize, $eb3674bbdae15bc9$var$_normalizer, $eb3674bbdae15bc9$var$_ignoreMobileResize, $eb3674bbdae15bc9$var$_baseScreenHeight, $eb3674bbdae15bc9$var$_baseScreenWidth, $eb3674bbdae15bc9$var$_fixIOSBug, $eb3674bbdae15bc9$var$_context, $eb3674bbdae15bc9$var$_scrollRestoration, $eb3674bbdae15bc9$var$_div100vh, $eb3674bbdae15bc9$var$_100vh, $eb3674bbdae15bc9$var$_isReverted, $eb3674bbdae15bc9$var$_clampingMax, $eb3674bbdae15bc9$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$eb3674bbdae15bc9$var$_startup = 1, $eb3674bbdae15bc9$var$_getTime = Date.now, $eb3674bbdae15bc9$var$_time1 = $eb3674bbdae15bc9$var$_getTime(), $eb3674bbdae15bc9$var$_lastScrollTime = 0, $eb3674bbdae15bc9$var$_enabled = 0, $eb3674bbdae15bc9$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $eb3674bbdae15bc9$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $eb3674bbdae15bc9$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$eb3674bbdae15bc9$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $eb3674bbdae15bc9$var$_rafBugFix = function _rafBugFix() {
    return $eb3674bbdae15bc9$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$eb3674bbdae15bc9$var$_pointerDownHandler = function _pointerDownHandler() {
    return $eb3674bbdae15bc9$var$_pointerIsDown = 1;
}, $eb3674bbdae15bc9$var$_pointerUpHandler = function _pointerUpHandler() {
    return $eb3674bbdae15bc9$var$_pointerIsDown = 0;
}, $eb3674bbdae15bc9$var$_passThrough = function _passThrough(v) {
    return v;
}, $eb3674bbdae15bc9$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $eb3674bbdae15bc9$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $eb3674bbdae15bc9$var$_getGSAP = function _getGSAP() {
    return $eb3674bbdae15bc9$var$gsap || $eb3674bbdae15bc9$var$_windowExists() && ($eb3674bbdae15bc9$var$gsap = window.gsap) && $eb3674bbdae15bc9$var$gsap.registerPlugin && $eb3674bbdae15bc9$var$gsap;
}, $eb3674bbdae15bc9$var$_isViewport = function _isViewport(e) {
    return !!~$eb3674bbdae15bc9$var$_root.indexOf(e);
}, $eb3674bbdae15bc9$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $eb3674bbdae15bc9$var$_100vh : $eb3674bbdae15bc9$var$_win["inner" + dimensionProperty]) || $eb3674bbdae15bc9$var$_docEl["client" + dimensionProperty] || $eb3674bbdae15bc9$var$_body["client" + dimensionProperty];
}, $eb3674bbdae15bc9$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($eb3674bbdae15bc9$var$_isViewport(element) ? function() {
        $eb3674bbdae15bc9$var$_winOffsets.width = $eb3674bbdae15bc9$var$_win.innerWidth;
        $eb3674bbdae15bc9$var$_winOffsets.height = $eb3674bbdae15bc9$var$_100vh;
        return $eb3674bbdae15bc9$var$_winOffsets;
    } : function() {
        return $eb3674bbdae15bc9$var$_getBounds(element);
    });
}, $eb3674bbdae15bc9$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $eb3674bbdae15bc9$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $eb3674bbdae15bc9$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $9b6b11f247395bd5$export$d8e56d510a804d0a).indexOf(element) ? $eb3674bbdae15bc9$var$_getBoundsFunc(element) : function() {
        return $eb3674bbdae15bc9$var$_winOffsets;
    };
}, $eb3674bbdae15bc9$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(element, s)) ? a() - $eb3674bbdae15bc9$var$_getBoundsFunc(element)()[d] : $eb3674bbdae15bc9$var$_isViewport(element) ? ($eb3674bbdae15bc9$var$_docEl[s] || $eb3674bbdae15bc9$var$_body[s]) - $eb3674bbdae15bc9$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $eb3674bbdae15bc9$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $eb3674bbdae15bc9$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($eb3674bbdae15bc9$var$_autoRefresh[i + 1])) && func($eb3674bbdae15bc9$var$_autoRefresh[i], $eb3674bbdae15bc9$var$_autoRefresh[i + 1], $eb3674bbdae15bc9$var$_autoRefresh[i + 2]);
}, $eb3674bbdae15bc9$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $eb3674bbdae15bc9$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $eb3674bbdae15bc9$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $eb3674bbdae15bc9$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $eb3674bbdae15bc9$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $eb3674bbdae15bc9$var$_callback = function _callback(self, func, extraParam) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self, extraParam);
        }) : func(self, extraParam);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $eb3674bbdae15bc9$var$_abs = Math.abs, $eb3674bbdae15bc9$var$_left = "left", $eb3674bbdae15bc9$var$_top = "top", $eb3674bbdae15bc9$var$_right = "right", $eb3674bbdae15bc9$var$_bottom = "bottom", $eb3674bbdae15bc9$var$_width = "width", $eb3674bbdae15bc9$var$_height = "height", $eb3674bbdae15bc9$var$_Right = "Right", $eb3674bbdae15bc9$var$_Left = "Left", $eb3674bbdae15bc9$var$_Top = "Top", $eb3674bbdae15bc9$var$_Bottom = "Bottom", $eb3674bbdae15bc9$var$_padding = "padding", $eb3674bbdae15bc9$var$_margin = "margin", $eb3674bbdae15bc9$var$_Width = "Width", $eb3674bbdae15bc9$var$_Height = "Height", $eb3674bbdae15bc9$var$_px = "px", $eb3674bbdae15bc9$var$_getComputedStyle = function _getComputedStyle(element) {
    return $eb3674bbdae15bc9$var$_win.getComputedStyle(element.nodeType === Node.DOCUMENT_NODE ? element.scrollingElement : element);
}, $eb3674bbdae15bc9$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $eb3674bbdae15bc9$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $eb3674bbdae15bc9$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $eb3674bbdae15bc9$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $eb3674bbdae15bc9$var$_getComputedStyle(element)[$eb3674bbdae15bc9$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $eb3674bbdae15bc9$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect ? element.getBoundingClientRect() : element.scrollingElement.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $eb3674bbdae15bc9$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $eb3674bbdae15bc9$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $eb3674bbdae15bc9$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $eb3674bbdae15bc9$var$gsap.utils.snap($eb3674bbdae15bc9$var$_getLabelRatioArray(animation), value);
    };
}, $eb3674bbdae15bc9$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $eb3674bbdae15bc9$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $eb3674bbdae15bc9$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $eb3674bbdae15bc9$var$_snapDirectional($eb3674bbdae15bc9$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $eb3674bbdae15bc9$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $eb3674bbdae15bc9$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $eb3674bbdae15bc9$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $eb3674bbdae15bc9$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $eb3674bbdae15bc9$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $eb3674bbdae15bc9$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $eb3674bbdae15bc9$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $eb3674bbdae15bc9$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($eb3674bbdae15bc9$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $eb3674bbdae15bc9$var$_keywords ? $eb3674bbdae15bc9$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $eb3674bbdae15bc9$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $eb3674bbdae15bc9$var$_doc.createElement("div"), useFixedPosition = $eb3674bbdae15bc9$var$_isViewport(container) || (0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $eb3674bbdae15bc9$var$_body : container.tagName === "IFRAME" ? container.contentDocument.body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d) ? $eb3674bbdae15bc9$var$_right : $eb3674bbdae15bc9$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $eb3674bbdae15bc9$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $eb3674bbdae15bc9$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $eb3674bbdae15bc9$var$_Width] = 1;
    vars["border" + oppositeSide + $eb3674bbdae15bc9$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $eb3674bbdae15bc9$var$gsap.set(marker, vars);
}, $eb3674bbdae15bc9$var$_triggers = [], $eb3674bbdae15bc9$var$_ids = {}, $eb3674bbdae15bc9$var$_rafID, $eb3674bbdae15bc9$var$_sync = function _sync() {
    return $eb3674bbdae15bc9$var$_getTime() - $eb3674bbdae15bc9$var$_lastScrollTime > 34 && ($eb3674bbdae15bc9$var$_rafID || ($eb3674bbdae15bc9$var$_rafID = requestAnimationFrame($eb3674bbdae15bc9$var$_updateAll)));
}, $eb3674bbdae15bc9$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$eb3674bbdae15bc9$var$_normalizer || !$eb3674bbdae15bc9$var$_normalizer.isPressed || $eb3674bbdae15bc9$var$_normalizer.startX > $eb3674bbdae15bc9$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache++;
        if ($eb3674bbdae15bc9$var$_normalizer) $eb3674bbdae15bc9$var$_rafID || ($eb3674bbdae15bc9$var$_rafID = requestAnimationFrame($eb3674bbdae15bc9$var$_updateAll));
        else $eb3674bbdae15bc9$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $eb3674bbdae15bc9$var$_lastScrollTime || $eb3674bbdae15bc9$var$_dispatch("scrollStart");
        $eb3674bbdae15bc9$var$_lastScrollTime = $eb3674bbdae15bc9$var$_getTime();
    }
}, $eb3674bbdae15bc9$var$_setBaseDimensions = function _setBaseDimensions() {
    $eb3674bbdae15bc9$var$_baseScreenWidth = $eb3674bbdae15bc9$var$_win.innerWidth;
    $eb3674bbdae15bc9$var$_baseScreenHeight = $eb3674bbdae15bc9$var$_win.innerHeight;
}, $eb3674bbdae15bc9$var$_onResize = function _onResize(force) {
    (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache++;
    (force === true || !$eb3674bbdae15bc9$var$_refreshing && !$eb3674bbdae15bc9$var$_ignoreResize && !$eb3674bbdae15bc9$var$_doc.fullscreenElement && !$eb3674bbdae15bc9$var$_doc.webkitFullscreenElement && (!$eb3674bbdae15bc9$var$_ignoreMobileResize || $eb3674bbdae15bc9$var$_baseScreenWidth !== $eb3674bbdae15bc9$var$_win.innerWidth || Math.abs($eb3674bbdae15bc9$var$_win.innerHeight - $eb3674bbdae15bc9$var$_baseScreenHeight) > $eb3674bbdae15bc9$var$_win.innerHeight * 0.25)) && $eb3674bbdae15bc9$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$eb3674bbdae15bc9$var$_listeners = {}, $eb3674bbdae15bc9$var$_emptyArray = [], $eb3674bbdae15bc9$var$_softRefresh = function _softRefresh() {
    return $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$export$875bcbe48555930, "scrollEnd", _softRefresh) || $eb3674bbdae15bc9$var$_refreshAll(true);
}, $eb3674bbdae15bc9$var$_dispatch = function _dispatch(type) {
    return $eb3674bbdae15bc9$var$_listeners[type] && $eb3674bbdae15bc9$var$_listeners[type].map(function(f) {
        return f();
    }) || $eb3674bbdae15bc9$var$_emptyArray;
}, $eb3674bbdae15bc9$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$eb3674bbdae15bc9$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $eb3674bbdae15bc9$var$_savedStyles.length; i += 5)if (!media || $eb3674bbdae15bc9$var$_savedStyles[i + 4] && $eb3674bbdae15bc9$var$_savedStyles[i + 4].query === media) {
        $eb3674bbdae15bc9$var$_savedStyles[i].style.cssText = $eb3674bbdae15bc9$var$_savedStyles[i + 1];
        $eb3674bbdae15bc9$var$_savedStyles[i].getBBox && $eb3674bbdae15bc9$var$_savedStyles[i].setAttribute("transform", $eb3674bbdae15bc9$var$_savedStyles[i + 2] || "");
        $eb3674bbdae15bc9$var$_savedStyles[i + 3].uncache = 1;
    }
}, $eb3674bbdae15bc9$var$_recordScrollPositions = function _recordScrollPositions() {
    return (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).forEach(function(obj) {
        return $eb3674bbdae15bc9$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    });
}, // record the current scroll position. Also force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
$eb3674bbdae15bc9$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($eb3674bbdae15bc9$var$_i = 0; $eb3674bbdae15bc9$var$_i < $eb3674bbdae15bc9$var$_triggers.length; $eb3674bbdae15bc9$var$_i++){
        trigger = $eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    $eb3674bbdae15bc9$var$_isReverted = true;
    media && $eb3674bbdae15bc9$var$_revertRecorded(media);
    media || $eb3674bbdae15bc9$var$_dispatch("revert");
}, $eb3674bbdae15bc9$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache++;
    (force || !$eb3674bbdae15bc9$var$_refreshingAll) && (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).forEach(function(obj) {
        return $eb3674bbdae15bc9$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $eb3674bbdae15bc9$var$_isString(scrollRestoration) && ($eb3674bbdae15bc9$var$_win.history.scrollRestoration = $eb3674bbdae15bc9$var$_scrollRestoration = scrollRestoration);
}, $eb3674bbdae15bc9$var$_refreshingAll, $eb3674bbdae15bc9$var$_refreshID = 0, $eb3674bbdae15bc9$var$_queueRefreshID, $eb3674bbdae15bc9$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($eb3674bbdae15bc9$var$_queueRefreshID !== $eb3674bbdae15bc9$var$_refreshID) {
        var id = $eb3674bbdae15bc9$var$_queueRefreshID = $eb3674bbdae15bc9$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $eb3674bbdae15bc9$var$_refreshID && $eb3674bbdae15bc9$var$_refreshAll(true);
        });
    }
}, $eb3674bbdae15bc9$var$_refresh100vh = function _refresh100vh() {
    $eb3674bbdae15bc9$var$_body.appendChild($eb3674bbdae15bc9$var$_div100vh);
    $eb3674bbdae15bc9$var$_100vh = !$eb3674bbdae15bc9$var$_normalizer && $eb3674bbdae15bc9$var$_div100vh.offsetHeight || $eb3674bbdae15bc9$var$_win.innerHeight;
    $eb3674bbdae15bc9$var$_body.removeChild($eb3674bbdae15bc9$var$_div100vh);
}, $eb3674bbdae15bc9$var$_hideAllMarkers = function _hideAllMarkers(hide) {
    return $eb3674bbdae15bc9$var$_toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, $eb3674bbdae15bc9$var$_refreshAll = function _refreshAll(force, skipRevert) {
    $eb3674bbdae15bc9$var$_docEl = $eb3674bbdae15bc9$var$_doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
    $eb3674bbdae15bc9$var$_body = $eb3674bbdae15bc9$var$_doc.body;
    $eb3674bbdae15bc9$var$_root = [
        $eb3674bbdae15bc9$var$_win,
        $eb3674bbdae15bc9$var$_doc,
        $eb3674bbdae15bc9$var$_docEl,
        $eb3674bbdae15bc9$var$_body
    ];
    if ($eb3674bbdae15bc9$var$_lastScrollTime && !force && !$eb3674bbdae15bc9$var$_isReverted) {
        $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$export$875bcbe48555930, "scrollEnd", $eb3674bbdae15bc9$var$_softRefresh);
        return;
    }
    $eb3674bbdae15bc9$var$_refresh100vh();
    $eb3674bbdae15bc9$var$_refreshingAll = $eb3674bbdae15bc9$export$875bcbe48555930.isRefreshing = true;
    $eb3674bbdae15bc9$var$_isReverted || $eb3674bbdae15bc9$var$_recordScrollPositions();
    var refreshInits = $eb3674bbdae15bc9$var$_dispatch("refreshInit");
    $eb3674bbdae15bc9$var$_sort && $eb3674bbdae15bc9$export$875bcbe48555930.sort();
    skipRevert || $eb3674bbdae15bc9$var$_revertAll();
    (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($eb3674bbdae15bc9$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $eb3674bbdae15bc9$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $eb3674bbdae15bc9$var$_isReverted = false;
    $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $eb3674bbdae15bc9$var$_clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    $eb3674bbdae15bc9$var$_hideAllMarkers(true);
    $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $eb3674bbdae15bc9$var$_maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    $eb3674bbdae15bc9$var$_hideAllMarkers(false);
    $eb3674bbdae15bc9$var$_clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($eb3674bbdae15bc9$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $eb3674bbdae15bc9$var$_clearScrollMemory($eb3674bbdae15bc9$var$_scrollRestoration, 1);
    $eb3674bbdae15bc9$var$_resizeDelay.pause();
    $eb3674bbdae15bc9$var$_refreshID++;
    $eb3674bbdae15bc9$var$_refreshingAll = 2;
    $eb3674bbdae15bc9$var$_updateAll(2);
    $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
        return $eb3674bbdae15bc9$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $eb3674bbdae15bc9$var$_refreshingAll = $eb3674bbdae15bc9$export$875bcbe48555930.isRefreshing = false;
    $eb3674bbdae15bc9$var$_dispatch("refresh");
}, $eb3674bbdae15bc9$var$_lastScroll = 0, $eb3674bbdae15bc9$var$_direction = 1, $eb3674bbdae15bc9$var$_primary, $eb3674bbdae15bc9$var$_updateAll = function _updateAll(force) {
    if (force === 2 || !$eb3674bbdae15bc9$var$_refreshingAll && !$eb3674bbdae15bc9$var$_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        $eb3674bbdae15bc9$export$875bcbe48555930.isUpdating = true;
        $eb3674bbdae15bc9$var$_primary && $eb3674bbdae15bc9$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $eb3674bbdae15bc9$var$_triggers.length, time = $eb3674bbdae15bc9$var$_getTime(), recordVelocity = time - $eb3674bbdae15bc9$var$_time1 >= 50, scroll = l && $eb3674bbdae15bc9$var$_triggers[0].scroll();
        $eb3674bbdae15bc9$var$_direction = $eb3674bbdae15bc9$var$_lastScroll > scroll ? -1 : 1;
        $eb3674bbdae15bc9$var$_refreshingAll || ($eb3674bbdae15bc9$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($eb3674bbdae15bc9$var$_lastScrollTime && !$eb3674bbdae15bc9$var$_pointerIsDown && time - $eb3674bbdae15bc9$var$_lastScrollTime > 200) {
                $eb3674bbdae15bc9$var$_lastScrollTime = 0;
                $eb3674bbdae15bc9$var$_dispatch("scrollEnd");
            }
            $eb3674bbdae15bc9$var$_time2 = $eb3674bbdae15bc9$var$_time1;
            $eb3674bbdae15bc9$var$_time1 = time;
        }
        if ($eb3674bbdae15bc9$var$_direction < 0) {
            $eb3674bbdae15bc9$var$_i = l;
            while($eb3674bbdae15bc9$var$_i-- > 0)$eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_i] && $eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_i].update(0, recordVelocity);
            $eb3674bbdae15bc9$var$_direction = 1;
        } else for($eb3674bbdae15bc9$var$_i = 0; $eb3674bbdae15bc9$var$_i < l; $eb3674bbdae15bc9$var$_i++)$eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_i] && $eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_i].update(0, recordVelocity);
        $eb3674bbdae15bc9$export$875bcbe48555930.isUpdating = false;
    }
    $eb3674bbdae15bc9$var$_rafID = 0;
}, $eb3674bbdae15bc9$var$_propNamesToCopy = [
    $eb3674bbdae15bc9$var$_left,
    $eb3674bbdae15bc9$var$_top,
    $eb3674bbdae15bc9$var$_bottom,
    $eb3674bbdae15bc9$var$_right,
    $eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Bottom,
    $eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Right,
    $eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Top,
    $eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $eb3674bbdae15bc9$var$_stateProps = $eb3674bbdae15bc9$var$_propNamesToCopy.concat([
    $eb3674bbdae15bc9$var$_width,
    $eb3674bbdae15bc9$var$_height,
    "boxSizing",
    "max" + $eb3674bbdae15bc9$var$_Width,
    "max" + $eb3674bbdae15bc9$var$_Height,
    "position",
    $eb3674bbdae15bc9$var$_margin,
    $eb3674bbdae15bc9$var$_padding,
    $eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Top,
    $eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Right,
    $eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Bottom,
    $eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Left
]), $eb3674bbdae15bc9$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $eb3674bbdae15bc9$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $eb3674bbdae15bc9$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $eb3674bbdae15bc9$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $eb3674bbdae15bc9$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $eb3674bbdae15bc9$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$eb3674bbdae15bc9$var$_bottom] = pinStyle[$eb3674bbdae15bc9$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$eb3674bbdae15bc9$var$_width] = $eb3674bbdae15bc9$var$_getSize(pin, (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1)) + $eb3674bbdae15bc9$var$_px;
        spacerStyle[$eb3674bbdae15bc9$var$_height] = $eb3674bbdae15bc9$var$_getSize(pin, (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d)) + $eb3674bbdae15bc9$var$_px;
        spacerStyle[$eb3674bbdae15bc9$var$_padding] = pinStyle[$eb3674bbdae15bc9$var$_margin] = pinStyle[$eb3674bbdae15bc9$var$_top] = pinStyle[$eb3674bbdae15bc9$var$_left] = "0";
        $eb3674bbdae15bc9$var$_setState(spacerState);
        pinStyle[$eb3674bbdae15bc9$var$_width] = pinStyle["max" + $eb3674bbdae15bc9$var$_Width] = cs[$eb3674bbdae15bc9$var$_width];
        pinStyle[$eb3674bbdae15bc9$var$_height] = pinStyle["max" + $eb3674bbdae15bc9$var$_Height] = cs[$eb3674bbdae15bc9$var$_height];
        pinStyle[$eb3674bbdae15bc9$var$_padding] = cs[$eb3674bbdae15bc9$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $eb3674bbdae15bc9$var$_capsExp = /([A-Z])/g, $eb3674bbdae15bc9$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $eb3674bbdae15bc9$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($eb3674bbdae15bc9$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $eb3674bbdae15bc9$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $eb3674bbdae15bc9$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($eb3674bbdae15bc9$var$_stateProps[i], style[$eb3674bbdae15bc9$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $eb3674bbdae15bc9$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $eb3674bbdae15bc9$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$eb3674bbdae15bc9$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $eb3674bbdae15bc9$var$_isFunction(value) && (value = value(self));
    if ($eb3674bbdae15bc9$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $eb3674bbdae15bc9$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$eb3674bbdae15bc9$var$_isNumber(value)) {
        $eb3674bbdae15bc9$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $9b6b11f247395bd5$export$937374fea3f88711)(trigger, self) || $eb3674bbdae15bc9$var$_body;
        bounds = $eb3674bbdae15bc9$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $eb3674bbdae15bc9$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $eb3674bbdae15bc9$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $eb3674bbdae15bc9$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $eb3674bbdae15bc9$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $eb3674bbdae15bc9$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $eb3674bbdae15bc9$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $eb3674bbdae15bc9$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $eb3674bbdae15bc9$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($eb3674bbdae15bc9$var$_body[p1], $eb3674bbdae15bc9$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $eb3674bbdae15bc9$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $eb3674bbdae15bc9$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $eb3674bbdae15bc9$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $eb3674bbdae15bc9$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $eb3674bbdae15bc9$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $eb3674bbdae15bc9$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $eb3674bbdae15bc9$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $eb3674bbdae15bc9$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$eb3674bbdae15bc9$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $eb3674bbdae15bc9$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $eb3674bbdae15bc9$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
    };
}, $eb3674bbdae15bc9$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $eb3674bbdae15bc9$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$eb3674bbdae15bc9$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $9b6b11f247395bd5$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $eb3674bbdae15bc9$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache++;
            getTween.tween && $eb3674bbdae15bc9$var$_updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $eb3674bbdae15bc9$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $eb3674bbdae15bc9$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $eb3674bbdae15bc9$export$875bcbe48555930.isTouch && $eb3674bbdae15bc9$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $eb3674bbdae15bc9$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $eb3674bbdae15bc9$var$_coreInitted || ScrollTrigger.register($eb3674bbdae15bc9$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $eb3674bbdae15bc9$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$eb3674bbdae15bc9$var$_enabled) {
            this.update = this.refresh = this.kill = $eb3674bbdae15bc9$var$_passThrough;
            return;
        }
        vars = $eb3674bbdae15bc9$var$_setDefaults($eb3674bbdae15bc9$var$_isString(vars) || $eb3674bbdae15bc9$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $eb3674bbdae15bc9$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1) : (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $9b6b11f247395bd5$export$937374fea3f88711)(vars.scroller || $eb3674bbdae15bc9$var$_win), scrollerCache = $eb3674bbdae15bc9$var$gsap.core.getCache(scroller), isViewport = $eb3674bbdae15bc9$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $eb3674bbdae15bc9$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($eb3674bbdae15bc9$var$_getComputedStyle(scroller)["border" + direction.p2 + $eb3674bbdae15bc9$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $eb3674bbdae15bc9$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $eb3674bbdae15bc9$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $9b6b11f247395bd5$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $eb3674bbdae15bc9$var$_sort = 1;
            vars.refreshPriority === -9999 && ($eb3674bbdae15bc9$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $eb3674bbdae15bc9$var$_getTweenCreator(scroller, (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d)),
            left: $eb3674bbdae15bc9$var$_getTweenCreator(scroller, (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $eb3674bbdae15bc9$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $eb3674bbdae15bc9$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$eb3674bbdae15bc9$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $eb3674bbdae15bc9$var$_body.style && $eb3674bbdae15bc9$var$gsap.set(isViewport ? [
                $eb3674bbdae15bc9$var$_body,
                $eb3674bbdae15bc9$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).forEach(function(o) {
                return $eb3674bbdae15bc9$var$_isFunction(o) && o.target === (isViewport ? $eb3674bbdae15bc9$var$_doc.scrollingElement || $eb3674bbdae15bc9$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $eb3674bbdae15bc9$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $eb3674bbdae15bc9$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $eb3674bbdae15bc9$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $eb3674bbdae15bc9$var$_snapDirectional(snap.snapTo)(value, $eb3674bbdae15bc9$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $eb3674bbdae15bc9$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $eb3674bbdae15bc9$var$_isObject(snapDurClamp) ? $eb3674bbdae15bc9$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $eb3674bbdae15bc9$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $eb3674bbdae15bc9$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $eb3674bbdae15bc9$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$eb3674bbdae15bc9$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($eb3674bbdae15bc9$var$_getTime() - $eb3674bbdae15bc9$var$_time2) * 1000 || 0, change1 = $eb3674bbdae15bc9$var$gsap.utils.clamp(-progress, 1 - progress, $eb3674bbdae15bc9$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    $eb3674bbdae15bc9$var$_isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.max(0, Math.round(start + endValue * change));
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $eb3674bbdae15bc9$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($eb3674bbdae15bc9$var$_abs(Math.max($eb3674bbdae15bc9$var$_abs(naturalEnd - totalProgress), $eb3674bbdae15bc9$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $eb3674bbdae15bc9$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && $eb3674bbdae15bc9$var$_callback(self, _onInterrupt);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation && !isToggle) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && $eb3674bbdae15bc9$var$_callback(self, _onComplete);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && $eb3674bbdae15bc9$var$_callback(self, onStart, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($eb3674bbdae15bc9$var$_ids[id] = self);
        trigger = self.trigger = (0, $9b6b11f247395bd5$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $9b6b11f247395bd5$export$937374fea3f88711)(pin);
        $eb3674bbdae15bc9$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $eb3674bbdae15bc9$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $eb3674bbdae15bc9$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $eb3674bbdae15bc9$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $eb3674bbdae15bc9$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $9b6b11f247395bd5$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $eb3674bbdae15bc9$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $eb3674bbdae15bc9$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $eb3674bbdae15bc9$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $eb3674bbdae15bc9$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $eb3674bbdae15bc9$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $eb3674bbdae15bc9$var$gsap.getProperty(pin);
            pinSetter = $eb3674bbdae15bc9$var$gsap.quickSetter(pin, direction.a, $eb3674bbdae15bc9$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $eb3674bbdae15bc9$var$_swapPinIn(pin, spacer, cs);
            pinState = $eb3674bbdae15bc9$var$_getState(pin);
        }
        if (markers) {
            markerVars = $eb3674bbdae15bc9$var$_isObject(markers) ? $eb3674bbdae15bc9$var$_setDefaults(markers, $eb3674bbdae15bc9$var$_markerDefaults) : $eb3674bbdae15bc9$var$_markerDefaults;
            markerStartTrigger = $eb3674bbdae15bc9$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $eb3674bbdae15bc9$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $9b6b11f247395bd5$export$937374fea3f88711)((0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $eb3674bbdae15bc9$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $eb3674bbdae15bc9$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $eb3674bbdae15bc9$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $eb3674bbdae15bc9$var$_px));
            if (!useFixedPosition && !((0, $9b6b11f247395bd5$export$d8e56d510a804d0a).length && (0, $9b6b11f247395bd5$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $eb3674bbdae15bc9$var$_makePositionable(isViewport ? $eb3674bbdae15bc9$var$_body : scroller);
                $eb3674bbdae15bc9$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $eb3674bbdae15bc9$var$gsap.quickSetter(markerStartTrigger, direction.a, $eb3674bbdae15bc9$var$_px);
                markerEndSetter = $eb3674bbdae15bc9$var$gsap.quickSetter(markerEndTrigger, direction.a, $eb3674bbdae15bc9$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $eb3674bbdae15bc9$var$_triggers[$eb3674bbdae15bc9$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $eb3674bbdae15bc9$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $eb3674bbdae15bc9$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $eb3674bbdae15bc9$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $eb3674bbdae15bc9$var$_swapPinIn(pin, spacer, $eb3674bbdae15bc9$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $eb3674bbdae15bc9$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($eb3674bbdae15bc9$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $eb3674bbdae15bc9$var$_lastScrollTime) {
                $eb3674bbdae15bc9$var$_addListener(ScrollTrigger, "scrollEnd", $eb3674bbdae15bc9$var$_softRefresh);
                return;
            }
            !$eb3674bbdae15bc9$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $eb3674bbdae15bc9$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            if (invalidateOnRefresh && animation) {
                animation.revert({
                    kill: false
                }).invalidate();
                animation.getChildren ? animation.getChildren(true, true, false).forEach(function(t) {
                    return t.vars.immediateRender && t.render(0, true, true);
                }) : animation.vars.immediateRender && animation.render(0, true, true); // any from() or fromTo() tweens should render immediately (well, unless they have immediateRender: false)
            }
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $eb3674bbdae15bc9$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01 || !change, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $eb3674bbdae15bc9$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $eb3674bbdae15bc9$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $9b6b11f247395bd5$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $eb3674bbdae15bc9$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $eb3674bbdae15bc9$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $eb3674bbdae15bc9$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $eb3674bbdae15bc9$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i-- > 0){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $eb3674bbdae15bc9$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($eb3674bbdae15bc9$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $eb3674bbdae15bc9$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $eb3674bbdae15bc9$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $eb3674bbdae15bc9$var$_parseClamp(parsedStart, "start", self);
            start = $eb3674bbdae15bc9$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $eb3674bbdae15bc9$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($eb3674bbdae15bc9$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($eb3674bbdae15bc9$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $eb3674bbdae15bc9$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $eb3674bbdae15bc9$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $eb3674bbdae15bc9$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $eb3674bbdae15bc9$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $eb3674bbdae15bc9$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $eb3674bbdae15bc9$var$_triggers[i] || {};
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$eb3674bbdae15bc9$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $eb3674bbdae15bc9$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $eb3674bbdae15bc9$var$gsap.utils.clamp(0, 1, $eb3674bbdae15bc9$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $eb3674bbdae15bc9$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !($eb3674bbdae15bc9$var$_clampingMax && self.end >= $eb3674bbdae15bc9$var$_maxScroll(scroller, direction))) {
                cs = $eb3674bbdae15bc9$var$_getComputedStyle(pin);
                isVertical = direction === (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $eb3674bbdae15bc9$var$_doc.scrollingElement || $eb3674bbdae15bc9$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $eb3674bbdae15bc9$var$_getComputedStyle($eb3674bbdae15bc9$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $eb3674bbdae15bc9$var$_swapPinIn(pin, spacer, cs);
                pinState = $eb3674bbdae15bc9$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $eb3674bbdae15bc9$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $9b6b11f247395bd5$export$8665aac53dad5647)(scroller, isVertical ? (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1) : (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $eb3674bbdae15bc9$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $eb3674bbdae15bc9$var$_padding ? $eb3674bbdae15bc9$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + $eb3674bbdae15bc9$var$_px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $eb3674bbdae15bc9$var$_px);
                    }
                    $eb3674bbdae15bc9$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = $eb3674bbdae15bc9$var$_getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + $eb3674bbdae15bc9$var$_px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $eb3674bbdae15bc9$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $eb3674bbdae15bc9$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$eb3674bbdae15bc9$var$_width] = override["max" + $eb3674bbdae15bc9$var$_Width] = Math.ceil(bounds.width) + $eb3674bbdae15bc9$var$_px;
                    override[$eb3674bbdae15bc9$var$_height] = override["max" + $eb3674bbdae15bc9$var$_Height] = Math.ceil(bounds.height) + $eb3674bbdae15bc9$var$_px;
                    override[$eb3674bbdae15bc9$var$_margin] = override[$eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Top] = override[$eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Right] = override[$eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Bottom] = override[$eb3674bbdae15bc9$var$_margin + $eb3674bbdae15bc9$var$_Left] = "0";
                    override[$eb3674bbdae15bc9$var$_padding] = cs[$eb3674bbdae15bc9$var$_padding];
                    override[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Top] = cs[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Top];
                    override[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Right] = cs[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Right];
                    override[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Bottom] = cs[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Bottom];
                    override[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Left] = cs[$eb3674bbdae15bc9$var$_padding + $eb3674bbdae15bc9$var$_Left];
                    pinActiveState = $eb3674bbdae15bc9$var$_copyState(pinOriginalState, override, pinReparent);
                    $eb3674bbdae15bc9$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $eb3674bbdae15bc9$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $eb3674bbdae15bc9$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $eb3674bbdae15bc9$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $eb3674bbdae15bc9$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$eb3674bbdae15bc9$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $eb3674bbdae15bc9$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $eb3674bbdae15bc9$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $eb3674bbdae15bc9$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $eb3674bbdae15bc9$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $eb3674bbdae15bc9$var$gsap.getProperty(markerEndTrigger, direction.p);
                $eb3674bbdae15bc9$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $eb3674bbdae15bc9$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $eb3674bbdae15bc9$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $eb3674bbdae15bc9$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$eb3674bbdae15bc9$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$eb3674bbdae15bc9$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($eb3674bbdae15bc9$var$_getTime() - $eb3674bbdae15bc9$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $eb3674bbdae15bc9$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $eb3674bbdae15bc9$var$_endAnimation(animation, animation.reversed()) : isToggle || $eb3674bbdae15bc9$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $eb3674bbdae15bc9$var$_triggers.indexOf(self), a = self.direction > 0 ? $eb3674bbdae15bc9$var$_triggers.slice(0, i).reverse() : $eb3674bbdae15bc9$var$_triggers.slice(i + 1);
            return ($eb3674bbdae15bc9$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $eb3674bbdae15bc9$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !$eb3674bbdae15bc9$var$_refreshing && !$eb3674bbdae15bc9$var$_startup && $eb3674bbdae15bc9$var$_lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / ($eb3674bbdae15bc9$var$_getTime() - $eb3674bbdae15bc9$var$_time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / ($eb3674bbdae15bc9$var$_getTime() - $eb3674bbdae15bc9$var$_time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$eb3674bbdae15bc9$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($eb3674bbdae15bc9$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$eb3674bbdae15bc9$var$_refreshing && !$eb3674bbdae15bc9$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($eb3674bbdae15bc9$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($eb3674bbdae15bc9$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $eb3674bbdae15bc9$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $eb3674bbdae15bc9$var$_getBounds(pin, true), _offset = scroll - start;
                                $eb3674bbdae15bc9$var$_reparent(pin, $eb3674bbdae15bc9$var$_body, bounds.top + (direction === (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d) ? _offset : 0) + $eb3674bbdae15bc9$var$_px, bounds.left + (direction === (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d) ? 0 : _offset) + $eb3674bbdae15bc9$var$_px);
                            } else $eb3674bbdae15bc9$var$_reparent(pin, spacer);
                        }
                        $eb3674bbdae15bc9$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$eb3674bbdae15bc9$var$_refreshing && !$eb3674bbdae15bc9$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$eb3674bbdae15bc9$var$_limitCallbacks)) && $eb3674bbdae15bc9$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$eb3674bbdae15bc9$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$eb3674bbdae15bc9$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $eb3674bbdae15bc9$var$_callback(self, onToggle);
                        callbacks[toggleState] && $eb3674bbdae15bc9$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $eb3674bbdae15bc9$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($eb3674bbdae15bc9$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $eb3674bbdae15bc9$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $eb3674bbdae15bc9$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$eb3674bbdae15bc9$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $eb3674bbdae15bc9$var$_addListener(scroller, "resize", $eb3674bbdae15bc9$var$_onResize);
                isViewport || $eb3674bbdae15bc9$var$_addListener(scroller, "scroll", $eb3674bbdae15bc9$var$_onScroll);
                onRefreshInit && $eb3674bbdae15bc9$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $eb3674bbdae15bc9$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $eb3674bbdae15bc9$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $eb3674bbdae15bc9$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $eb3674bbdae15bc9$var$_px;
                $eb3674bbdae15bc9$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            reset !== false && self.revert(true, true);
            if (self.enabled) {
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $eb3674bbdae15bc9$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $eb3674bbdae15bc9$var$_triggers.length;
                    while(i--){
                        if ($eb3674bbdae15bc9$var$_triggers[i].scroller === scroller && $eb3674bbdae15bc9$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $eb3674bbdae15bc9$var$_removeListener(scroller, "resize", $eb3674bbdae15bc9$var$_onResize);
                    isViewport || $eb3674bbdae15bc9$var$_removeListener(scroller, "scroll", $eb3674bbdae15bc9$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $eb3674bbdae15bc9$var$_ids[id];
            var i = $eb3674bbdae15bc9$var$_triggers.indexOf(self);
            i >= 0 && $eb3674bbdae15bc9$var$_triggers.splice(i, 1);
            i === $eb3674bbdae15bc9$var$_i && $eb3674bbdae15bc9$var$_direction > 0 && $eb3674bbdae15bc9$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $eb3674bbdae15bc9$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $eb3674bbdae15bc9$var$_primary === self && ($eb3674bbdae15bc9$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $eb3674bbdae15bc9$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
                start || end || self.refresh();
            };
            $eb3674bbdae15bc9$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $eb3674bbdae15bc9$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$eb3674bbdae15bc9$var$_coreInitted) {
            $eb3674bbdae15bc9$var$gsap = core || $eb3674bbdae15bc9$var$_getGSAP();
            $eb3674bbdae15bc9$var$_windowExists() && window.document && ScrollTrigger.enable();
            $eb3674bbdae15bc9$var$_coreInitted = $eb3674bbdae15bc9$var$_enabled;
        }
        return $eb3674bbdae15bc9$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$eb3674bbdae15bc9$var$_defaults[p] = config[p];
        return $eb3674bbdae15bc9$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $eb3674bbdae15bc9$var$_enabled = 0;
        $eb3674bbdae15bc9$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$var$_win, "wheel", $eb3674bbdae15bc9$var$_onScroll);
        $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$var$_doc, "scroll", $eb3674bbdae15bc9$var$_onScroll);
        clearInterval($eb3674bbdae15bc9$var$_syncInterval);
        $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$var$_doc, "touchcancel", $eb3674bbdae15bc9$var$_passThrough);
        $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$var$_body, "touchstart", $eb3674bbdae15bc9$var$_passThrough);
        $eb3674bbdae15bc9$var$_multiListener($eb3674bbdae15bc9$var$_removeListener, $eb3674bbdae15bc9$var$_doc, "pointerdown,touchstart,mousedown", $eb3674bbdae15bc9$var$_pointerDownHandler);
        $eb3674bbdae15bc9$var$_multiListener($eb3674bbdae15bc9$var$_removeListener, $eb3674bbdae15bc9$var$_doc, "pointerup,touchend,mouseup", $eb3674bbdae15bc9$var$_pointerUpHandler);
        $eb3674bbdae15bc9$var$_resizeDelay.kill();
        $eb3674bbdae15bc9$var$_iterateAutoRefresh($eb3674bbdae15bc9$var$_removeListener);
        for(var i = 0; i < (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).length; i += 3){
            $eb3674bbdae15bc9$var$_wheelListener($eb3674bbdae15bc9$var$_removeListener, (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i], (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i + 1]);
            $eb3674bbdae15bc9$var$_wheelListener($eb3674bbdae15bc9$var$_removeListener, (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i], (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $eb3674bbdae15bc9$var$_win = window;
        $eb3674bbdae15bc9$var$_doc = document;
        $eb3674bbdae15bc9$var$_docEl = $eb3674bbdae15bc9$var$_doc.documentElement;
        $eb3674bbdae15bc9$var$_body = $eb3674bbdae15bc9$var$_doc.body;
        if ($eb3674bbdae15bc9$var$gsap) {
            $eb3674bbdae15bc9$var$_toArray = $eb3674bbdae15bc9$var$gsap.utils.toArray;
            $eb3674bbdae15bc9$var$_clamp = $eb3674bbdae15bc9$var$gsap.utils.clamp;
            $eb3674bbdae15bc9$var$_context = $eb3674bbdae15bc9$var$gsap.core.context || $eb3674bbdae15bc9$var$_passThrough;
            $eb3674bbdae15bc9$var$_suppressOverwrites = $eb3674bbdae15bc9$var$gsap.core.suppressOverwrites || $eb3674bbdae15bc9$var$_passThrough;
            $eb3674bbdae15bc9$var$_scrollRestoration = $eb3674bbdae15bc9$var$_win.history.scrollRestoration || "auto";
            $eb3674bbdae15bc9$var$_lastScroll = $eb3674bbdae15bc9$var$_win.pageYOffset || 0;
            $eb3674bbdae15bc9$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($eb3674bbdae15bc9$var$_body) {
                $eb3674bbdae15bc9$var$_enabled = 1;
                $eb3674bbdae15bc9$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $eb3674bbdae15bc9$var$_div100vh.style.height = "100vh";
                $eb3674bbdae15bc9$var$_div100vh.style.position = "absolute";
                $eb3674bbdae15bc9$var$_refresh100vh();
                $eb3674bbdae15bc9$var$_rafBugFix();
                (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).register($eb3674bbdae15bc9$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).isTouch;
                $eb3674bbdae15bc9$var$_fixIOSBug = (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $eb3674bbdae15bc9$var$_ignoreMobileResize = (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).isTouch === 1;
                $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$var$_win, "wheel", $eb3674bbdae15bc9$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $eb3674bbdae15bc9$var$_root = [
                    $eb3674bbdae15bc9$var$_win,
                    $eb3674bbdae15bc9$var$_doc,
                    $eb3674bbdae15bc9$var$_docEl,
                    $eb3674bbdae15bc9$var$_body
                ];
                if ($eb3674bbdae15bc9$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $eb3674bbdae15bc9$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $eb3674bbdae15bc9$var$gsap.addEventListener("matchMediaInit", function() {
                        $eb3674bbdae15bc9$var$_recordScrollPositions();
                        $eb3674bbdae15bc9$var$_revertAll();
                    });
                    $eb3674bbdae15bc9$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $eb3674bbdae15bc9$var$_revertRecorded();
                    });
                    $eb3674bbdae15bc9$var$gsap.addEventListener("matchMedia", function() {
                        $eb3674bbdae15bc9$var$_refreshAll(0, 1);
                        $eb3674bbdae15bc9$var$_dispatch("matchMedia");
                    });
                    $eb3674bbdae15bc9$var$gsap.matchMedia().add("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $eb3674bbdae15bc9$var$_setBaseDimensions();
                        return $eb3674bbdae15bc9$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $eb3674bbdae15bc9$var$_setBaseDimensions();
                $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$var$_doc, "scroll", $eb3674bbdae15bc9$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyHasStyle = $eb3674bbdae15bc9$var$_body.hasAttribute("style"), bodyStyle = $eb3674bbdae15bc9$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $eb3674bbdae15bc9$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $eb3674bbdae15bc9$var$_getBounds($eb3674bbdae15bc9$var$_body);
                (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
                if (!bodyHasStyle) {
                    // SSR frameworks like Next.js complain if this attribute gets added.
                    $eb3674bbdae15bc9$var$_body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
                    $eb3674bbdae15bc9$var$_body.removeAttribute("style");
                } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $eb3674bbdae15bc9$var$_syncInterval = setInterval($eb3674bbdae15bc9$var$_sync, 250);
                $eb3674bbdae15bc9$var$gsap.delayedCall(0.5, function() {
                    return $eb3674bbdae15bc9$var$_startup = 0;
                });
                $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$var$_doc, "touchcancel", $eb3674bbdae15bc9$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$var$_body, "touchstart", $eb3674bbdae15bc9$var$_passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $eb3674bbdae15bc9$var$_multiListener($eb3674bbdae15bc9$var$_addListener, $eb3674bbdae15bc9$var$_doc, "pointerdown,touchstart,mousedown", $eb3674bbdae15bc9$var$_pointerDownHandler);
                $eb3674bbdae15bc9$var$_multiListener($eb3674bbdae15bc9$var$_addListener, $eb3674bbdae15bc9$var$_doc, "pointerup,touchend,mouseup", $eb3674bbdae15bc9$var$_pointerUpHandler);
                $eb3674bbdae15bc9$var$_transformProp = $eb3674bbdae15bc9$var$gsap.utils.checkPrefix("transform");
                $eb3674bbdae15bc9$var$_stateProps.push($eb3674bbdae15bc9$var$_transformProp);
                $eb3674bbdae15bc9$var$_coreInitted = $eb3674bbdae15bc9$var$_getTime();
                $eb3674bbdae15bc9$var$_resizeDelay = $eb3674bbdae15bc9$var$gsap.delayedCall(0.2, $eb3674bbdae15bc9$var$_refreshAll).pause();
                $eb3674bbdae15bc9$var$_autoRefresh = [
                    $eb3674bbdae15bc9$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $eb3674bbdae15bc9$var$_win.innerWidth, h = $eb3674bbdae15bc9$var$_win.innerHeight;
                        if ($eb3674bbdae15bc9$var$_doc.hidden) {
                            $eb3674bbdae15bc9$var$_prevWidth = w;
                            $eb3674bbdae15bc9$var$_prevHeight = h;
                        } else if ($eb3674bbdae15bc9$var$_prevWidth !== w || $eb3674bbdae15bc9$var$_prevHeight !== h) $eb3674bbdae15bc9$var$_onResize();
                    },
                    $eb3674bbdae15bc9$var$_doc,
                    "DOMContentLoaded",
                    $eb3674bbdae15bc9$var$_refreshAll,
                    $eb3674bbdae15bc9$var$_win,
                    "load",
                    $eb3674bbdae15bc9$var$_refreshAll,
                    $eb3674bbdae15bc9$var$_win,
                    "resize",
                    $eb3674bbdae15bc9$var$_onResize
                ];
                $eb3674bbdae15bc9$var$_iterateAutoRefresh($eb3674bbdae15bc9$var$_addListener);
                $eb3674bbdae15bc9$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).length; i += 3){
                    $eb3674bbdae15bc9$var$_wheelListener($eb3674bbdae15bc9$var$_removeListener, (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i], (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i + 1]);
                    $eb3674bbdae15bc9$var$_wheelListener($eb3674bbdae15bc9$var$_removeListener, (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i], (0, $9b6b11f247395bd5$export$3cd1cee43d19b683)[i + 2]);
                }
            } else if ($eb3674bbdae15bc9$var$_doc) {
                var onLoad = function onLoad() {
                    ScrollTrigger.enable();
                    $eb3674bbdae15bc9$var$_doc.removeEventListener("DOMContentLoaded", onLoad);
                };
                $eb3674bbdae15bc9$var$_doc.addEventListener("DOMContentLoaded", onLoad);
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($eb3674bbdae15bc9$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($eb3674bbdae15bc9$var$_syncInterval) || ($eb3674bbdae15bc9$var$_syncInterval = ms) && setInterval($eb3674bbdae15bc9$var$_sync, ms);
        "ignoreMobileResize" in vars && ($eb3674bbdae15bc9$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $eb3674bbdae15bc9$var$_iterateAutoRefresh($eb3674bbdae15bc9$var$_removeListener) || $eb3674bbdae15bc9$var$_iterateAutoRefresh($eb3674bbdae15bc9$var$_addListener, vars.autoRefreshEvents || "none");
            $eb3674bbdae15bc9$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $9b6b11f247395bd5$export$937374fea3f88711)(target), i = (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).indexOf(t), isViewport = $eb3674bbdae15bc9$var$_isViewport(t);
        if (~i) (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $9b6b11f247395bd5$export$d8e56d510a804d0a).unshift($eb3674bbdae15bc9$var$_win, vars, $eb3674bbdae15bc9$var$_body, vars, $eb3674bbdae15bc9$var$_docEl, vars) : (0, $9b6b11f247395bd5$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $eb3674bbdae15bc9$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($eb3674bbdae15bc9$var$_isString(element) ? (0, $9b6b11f247395bd5$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $eb3674bbdae15bc9$var$_width : $eb3674bbdae15bc9$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $eb3674bbdae15bc9$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $eb3674bbdae15bc9$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $eb3674bbdae15bc9$var$_isString(element) && (element = (0, $9b6b11f247395bd5$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $eb3674bbdae15bc9$var$_width : $eb3674bbdae15bc9$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $eb3674bbdae15bc9$var$_keywords ? $eb3674bbdae15bc9$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $eb3674bbdae15bc9$var$_win.innerWidth : (bounds.top + offset) / $eb3674bbdae15bc9$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $eb3674bbdae15bc9$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $eb3674bbdae15bc9$var$_listeners.killAll || [];
            $eb3674bbdae15bc9$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$eb3674bbdae15bc9$export$875bcbe48555930.version = "3.15.0";
$eb3674bbdae15bc9$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $eb3674bbdae15bc9$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $eb3674bbdae15bc9$var$_savedStyles.indexOf(target);
            i >= 0 && $eb3674bbdae15bc9$var$_savedStyles.splice(i, 5);
            $eb3674bbdae15bc9$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $eb3674bbdae15bc9$var$gsap.core.getCache(target), $eb3674bbdae15bc9$var$_context());
        }
    }) : $eb3674bbdae15bc9$var$_savedStyles;
};
$eb3674bbdae15bc9$export$875bcbe48555930.revert = function(soft, media) {
    return $eb3674bbdae15bc9$var$_revertAll(!soft, media);
};
$eb3674bbdae15bc9$export$875bcbe48555930.create = function(vars, animation) {
    return new $eb3674bbdae15bc9$export$875bcbe48555930(vars, animation);
};
$eb3674bbdae15bc9$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $eb3674bbdae15bc9$var$_onResize(true) : ($eb3674bbdae15bc9$var$_coreInitted || $eb3674bbdae15bc9$export$875bcbe48555930.register()) && $eb3674bbdae15bc9$var$_refreshAll(true);
};
$eb3674bbdae15bc9$export$875bcbe48555930.update = function(force) {
    return ++(0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache && $eb3674bbdae15bc9$var$_updateAll(force === true ? 2 : 0);
};
$eb3674bbdae15bc9$export$875bcbe48555930.clearScrollMemory = $eb3674bbdae15bc9$var$_clearScrollMemory;
$eb3674bbdae15bc9$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $eb3674bbdae15bc9$var$_maxScroll(element, horizontal ? (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1) : (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d));
};
$eb3674bbdae15bc9$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $9b6b11f247395bd5$export$8665aac53dad5647)((0, $9b6b11f247395bd5$export$937374fea3f88711)(element), horizontal ? (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1) : (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d));
};
$eb3674bbdae15bc9$export$875bcbe48555930.getById = function(id) {
    return $eb3674bbdae15bc9$var$_ids[id];
};
$eb3674bbdae15bc9$export$875bcbe48555930.getAll = function() {
    return $eb3674bbdae15bc9$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$eb3674bbdae15bc9$export$875bcbe48555930.isScrolling = function() {
    return !!$eb3674bbdae15bc9$var$_lastScrollTime;
};
$eb3674bbdae15bc9$export$875bcbe48555930.snapDirectional = $eb3674bbdae15bc9$var$_snapDirectional;
$eb3674bbdae15bc9$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $eb3674bbdae15bc9$var$_listeners[type] || ($eb3674bbdae15bc9$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$eb3674bbdae15bc9$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $eb3674bbdae15bc9$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$eb3674bbdae15bc9$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $eb3674bbdae15bc9$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $eb3674bbdae15bc9$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($eb3674bbdae15bc9$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $eb3674bbdae15bc9$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($eb3674bbdae15bc9$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $eb3674bbdae15bc9$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $eb3674bbdae15bc9$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $eb3674bbdae15bc9$var$_docEl && _allowNativePanning($eb3674bbdae15bc9$var$_body, direction);
}, $eb3674bbdae15bc9$var$_overflow = {
    auto: 1,
    scroll: 1
}, $eb3674bbdae15bc9$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $eb3674bbdae15bc9$var$gsap.core.getCache(node), time = $eb3674bbdae15bc9$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $eb3674bbdae15bc9$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($eb3674bbdae15bc9$var$_overflow[(cs = $eb3674bbdae15bc9$var$_getComputedStyle(node)).overflowY] || $eb3674bbdae15bc9$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$eb3674bbdae15bc9$var$_isViewport(node) && ($eb3674bbdae15bc9$var$_overflow[(cs = $eb3674bbdae15bc9$var$_getComputedStyle(node)).overflowY] || $eb3674bbdae15bc9$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$eb3674bbdae15bc9$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $eb3674bbdae15bc9$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$var$_doc, (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).eventTypes[0], $eb3674bbdae15bc9$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$var$_doc, (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).eventTypes[0], $eb3674bbdae15bc9$var$_captureInputs, true);
        }
    });
}, $eb3674bbdae15bc9$var$_inputExp = /(input|label|select|textarea)/i, $eb3674bbdae15bc9$var$_inputIsFocused, $eb3674bbdae15bc9$var$_captureInputs = function _captureInputs(e) {
    var isInput = $eb3674bbdae15bc9$var$_inputExp.test(e.target.tagName);
    if (isInput || $eb3674bbdae15bc9$var$_inputIsFocused) {
        e._gsapAllow = true;
        $eb3674bbdae15bc9$var$_inputIsFocused = isInput;
    }
}, $eb3674bbdae15bc9$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $eb3674bbdae15bc9$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $9b6b11f247395bd5$export$937374fea3f88711)(vars.target) || $eb3674bbdae15bc9$var$_docEl, smoother = $eb3674bbdae15bc9$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $eb3674bbdae15bc9$var$_fixIOSBug && (vars.content && (0, $9b6b11f247395bd5$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $9b6b11f247395bd5$export$8665aac53dad5647)(target, (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d)), scrollFuncX = (0, $9b6b11f247395bd5$export$8665aac53dad5647)(target, (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b).isTouch && $eb3674bbdae15bc9$var$_win.visualViewport ? $eb3674bbdae15bc9$var$_win.visualViewport.scale * $eb3674bbdae15bc9$var$_win.visualViewport.width : $eb3674bbdae15bc9$var$_win.outerWidth) / $eb3674bbdae15bc9$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $eb3674bbdae15bc9$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $eb3674bbdae15bc9$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $eb3674bbdae15bc9$var$_passThrough, scrollClampY = $eb3674bbdae15bc9$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $eb3674bbdae15bc9$var$_maxScroll(target, (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d));
        scrollClampY = $eb3674bbdae15bc9$var$_clamp($eb3674bbdae15bc9$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $eb3674bbdae15bc9$var$_clamp(0, $eb3674bbdae15bc9$var$_maxScroll(target, (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1))));
        lastRefreshID = $eb3674bbdae15bc9$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $eb3674bbdae15bc9$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $eb3674bbdae15bc9$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $eb3674bbdae15bc9$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache;
                $eb3674bbdae15bc9$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $eb3674bbdae15bc9$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $eb3674bbdae15bc9$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $eb3674bbdae15bc9$var$_round(($eb3674bbdae15bc9$var$_win.visualViewport && $eb3674bbdae15bc9$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $eb3674bbdae15bc9$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $eb3674bbdae15bc9$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $9b6b11f247395bd5$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $eb3674bbdae15bc9$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $eb3674bbdae15bc9$var$_maxScroll(target, (0, $9b6b11f247395bd5$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $eb3674bbdae15bc9$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $eb3674bbdae15bc9$var$_maxScroll(target, (0, $9b6b11f247395bd5$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($eb3674bbdae15bc9$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $eb3674bbdae15bc9$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($eb3674bbdae15bc9$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $eb3674bbdae15bc9$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $eb3674bbdae15bc9$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $eb3674bbdae15bc9$var$_updateAll();
    };
    vars.onEnable = function() {
        $eb3674bbdae15bc9$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $eb3674bbdae15bc9$export$875bcbe48555930.addEventListener("refresh", onResize);
        $eb3674bbdae15bc9$var$_addListener($eb3674bbdae15bc9$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $eb3674bbdae15bc9$var$_allowNativePanning(target, true);
        $eb3674bbdae15bc9$var$_removeListener($eb3674bbdae15bc9$var$_win, "resize", onResize);
        $eb3674bbdae15bc9$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $eb3674bbdae15bc9$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $eb3674bbdae15bc9$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $eb3674bbdae15bc9$var$_fixIOSBug && $eb3674bbdae15bc9$var$gsap.ticker.add($eb3674bbdae15bc9$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $eb3674bbdae15bc9$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $eb3674bbdae15bc9$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $eb3674bbdae15bc9$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$eb3674bbdae15bc9$export$875bcbe48555930.sort = function(func) {
    if ($eb3674bbdae15bc9$var$_isFunction(func)) return $eb3674bbdae15bc9$var$_triggers.sort(func);
    var scroll = $eb3674bbdae15bc9$var$_win.pageYOffset || 0;
    $eb3674bbdae15bc9$export$875bcbe48555930.getAll().forEach(function(t) {
        return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + $eb3674bbdae15bc9$var$_win.innerHeight;
    });
    return $eb3674bbdae15bc9$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1000000);
    }); // anything with a containerAnimation should refresh last.
};
$eb3674bbdae15bc9$export$875bcbe48555930.observe = function(vars) {
    return new (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b)(vars);
};
$eb3674bbdae15bc9$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $eb3674bbdae15bc9$var$_normalizer;
    if (vars === true && $eb3674bbdae15bc9$var$_normalizer) return $eb3674bbdae15bc9$var$_normalizer.enable();
    if (vars === false) {
        $eb3674bbdae15bc9$var$_normalizer && $eb3674bbdae15bc9$var$_normalizer.kill();
        $eb3674bbdae15bc9$var$_normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, $9b6b11f247395bd5$export$c1cbdee04e18ea8b) ? vars : $eb3674bbdae15bc9$var$_getScrollNormalizer(vars);
    $eb3674bbdae15bc9$var$_normalizer && $eb3674bbdae15bc9$var$_normalizer.target === normalizer.target && $eb3674bbdae15bc9$var$_normalizer.kill();
    $eb3674bbdae15bc9$var$_isViewport(normalizer.target) && ($eb3674bbdae15bc9$var$_normalizer = normalizer);
    return normalizer;
};
$eb3674bbdae15bc9$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $9b6b11f247395bd5$export$5de019f4480f0f8d),
    _inputObserver: $eb3674bbdae15bc9$var$_inputObserver,
    _scrollers: (0, $9b6b11f247395bd5$export$3cd1cee43d19b683),
    _proxies: (0, $9b6b11f247395bd5$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $eb3674bbdae15bc9$var$_lastScrollTime || $eb3674bbdae15bc9$var$_dispatch("scrollStart");
            $eb3674bbdae15bc9$var$_lastScrollTime = $eb3674bbdae15bc9$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $eb3674bbdae15bc9$var$_refreshing;
        }
    }
};
$eb3674bbdae15bc9$var$_getGSAP() && $eb3674bbdae15bc9$var$gsap.registerPlugin($eb3674bbdae15bc9$export$875bcbe48555930);


/*!
 * DrawSVGPlugin 3.15.0
 * https://gsap.com
 *
 * @license Copyright 2008-2026, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $fdceed4ac97f63e8$var$gsap, $fdceed4ac97f63e8$var$_toArray, $fdceed4ac97f63e8$var$_doc, $fdceed4ac97f63e8$var$_win, $fdceed4ac97f63e8$var$_isEdge, $fdceed4ac97f63e8$var$_coreInitted, $fdceed4ac97f63e8$var$_warned, $fdceed4ac97f63e8$var$_getStyleSaver, $fdceed4ac97f63e8$var$_reverting, $fdceed4ac97f63e8$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $fdceed4ac97f63e8$var$_getGSAP = function _getGSAP() {
    return $fdceed4ac97f63e8$var$gsap || $fdceed4ac97f63e8$var$_windowExists() && ($fdceed4ac97f63e8$var$gsap = window.gsap) && $fdceed4ac97f63e8$var$gsap.registerPlugin && $fdceed4ac97f63e8$var$gsap;
}, $fdceed4ac97f63e8$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$fdceed4ac97f63e8$var$_types = {
    rect: [
        "width",
        "height"
    ],
    circle: [
        "r",
        "r"
    ],
    ellipse: [
        "rx",
        "ry"
    ],
    line: [
        "x2",
        "y2"
    ]
}, $fdceed4ac97f63e8$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $fdceed4ac97f63e8$var$_parseNum = function _parseNum(value) {
    return parseFloat(value) || 0;
}, $fdceed4ac97f63e8$var$_parseSingleVal = function _parseSingleVal(value, length) {
    var num = $fdceed4ac97f63e8$var$_parseNum(value);
    return ~value.indexOf("%") ? num / 100 * length : num;
}, $fdceed4ac97f63e8$var$_getAttributeAsNumber = function _getAttributeAsNumber(target, attr) {
    return $fdceed4ac97f63e8$var$_parseNum(target.getAttribute(attr));
}, $fdceed4ac97f63e8$var$_sqrt = Math.sqrt, $fdceed4ac97f63e8$var$_getDistance = function _getDistance(x1, y1, x2, y2, scaleX, scaleY) {
    return $fdceed4ac97f63e8$var$_sqrt(Math.pow(($fdceed4ac97f63e8$var$_parseNum(x2) - $fdceed4ac97f63e8$var$_parseNum(x1)) * scaleX, 2) + Math.pow(($fdceed4ac97f63e8$var$_parseNum(y2) - $fdceed4ac97f63e8$var$_parseNum(y1)) * scaleY, 2));
}, $fdceed4ac97f63e8$var$_warn = function _warn(message) {
    return console.warn(message);
}, $fdceed4ac97f63e8$var$_hasNonScalingStroke = function _hasNonScalingStroke(target) {
    return target.getAttribute("vector-effect") === "non-scaling-stroke";
}, $fdceed4ac97f63e8$var$_bonusValidated = 1, //<name>DrawSVGPlugin</name>
//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
$fdceed4ac97f63e8$var$_parse = function _parse(value, length, defaultStart) {
    var i = value.indexOf(" "), s, e;
    if (i < 0) {
        s = defaultStart !== undefined ? defaultStart + "" : value;
        e = value;
    } else {
        s = value.substr(0, i);
        e = value.substr(i + 1);
    }
    s = $fdceed4ac97f63e8$var$_parseSingleVal(s, length);
    e = $fdceed4ac97f63e8$var$_parseSingleVal(e, length);
    return s > e ? [
        e,
        s
    ] : [
        s,
        e
    ];
}, $fdceed4ac97f63e8$var$_getLength = function _getLength(target) {
    target = $fdceed4ac97f63e8$var$_toArray(target)[0];
    if (!target) return 0;
    var type = target.tagName.toLowerCase(), style = target.style, scaleX = 1, scaleY = 1, length, bbox, points, prevPoint, i, rx, ry;
    if ($fdceed4ac97f63e8$var$_hasNonScalingStroke(target)) {
        //non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
        scaleY = target.getScreenCTM();
        scaleX = $fdceed4ac97f63e8$var$_sqrt(scaleY.a * scaleY.a + scaleY.b * scaleY.b);
        scaleY = $fdceed4ac97f63e8$var$_sqrt(scaleY.d * scaleY.d + scaleY.c * scaleY.c);
    }
    try {
        //IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
        bbox = target.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
    } catch (e) {
        //firefox has a bug that throws an error if the element isn't visible.
        $fdceed4ac97f63e8$var$_warn("Some browsers won't measure invisible elements (like display:none or masks inside defs).");
    }
    var _ref = bbox || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    }, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
    if ((!bbox || !width && !height) && $fdceed4ac97f63e8$var$_types[type]) {
        //if the element isn't visible, try to discern width/height using its attributes.
        width = $fdceed4ac97f63e8$var$_getAttributeAsNumber(target, $fdceed4ac97f63e8$var$_types[type][0]);
        height = $fdceed4ac97f63e8$var$_getAttributeAsNumber(target, $fdceed4ac97f63e8$var$_types[type][1]);
        if (type !== "rect" && type !== "line") {
            //double the radius for circles and ellipses
            width *= 2;
            height *= 2;
        }
        if (type === "line") {
            x = $fdceed4ac97f63e8$var$_getAttributeAsNumber(target, "x1");
            y = $fdceed4ac97f63e8$var$_getAttributeAsNumber(target, "y1");
            width = Math.abs(width - x);
            height = Math.abs(height - y);
        }
    }
    if (type === "path") {
        prevPoint = style.strokeDasharray;
        style.strokeDasharray = "none";
        length = target.getTotalLength() || 0;
        $fdceed4ac97f63e8$var$_round(scaleX) !== $fdceed4ac97f63e8$var$_round(scaleY) && !$fdceed4ac97f63e8$var$_warned && ($fdceed4ac97f63e8$var$_warned = 1) && $fdceed4ac97f63e8$var$_warn("Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
        length *= (scaleX + scaleY) / 2;
        style.strokeDasharray = prevPoint;
    } else if (type === "rect") length = width * 2 * scaleX + height * 2 * scaleY;
    else if (type === "line") length = $fdceed4ac97f63e8$var$_getDistance(x, y, x + width, y + height, scaleX, scaleY);
    else if (type === "polyline" || type === "polygon") {
        points = target.getAttribute("points").match($fdceed4ac97f63e8$var$_numExp) || [];
        type === "polygon" && points.push(points[0], points[1]);
        length = 0;
        for(i = 2; i < points.length; i += 2)length += $fdceed4ac97f63e8$var$_getDistance(points[i - 2], points[i - 1], points[i], points[i + 1], scaleX, scaleY) || 0;
    } else if (type === "circle" || type === "ellipse") {
        rx = width / 2 * scaleX;
        ry = height / 2 * scaleY;
        length = Math.PI * (3 * (rx + ry) - $fdceed4ac97f63e8$var$_sqrt((3 * rx + ry) * (rx + 3 * ry)));
    }
    return length || 0;
}, $fdceed4ac97f63e8$var$_getPosition = function _getPosition(target, length) {
    target = $fdceed4ac97f63e8$var$_toArray(target)[0];
    if (!target) return [
        0,
        0
    ];
    length || (length = $fdceed4ac97f63e8$var$_getLength(target) + 1);
    var cs = $fdceed4ac97f63e8$var$_win.getComputedStyle(target), dash = cs.strokeDasharray || "", offset = $fdceed4ac97f63e8$var$_parseNum(cs.strokeDashoffset), i = dash.indexOf(",");
    i < 0 && (i = dash.indexOf(" "));
    dash = i < 0 ? length : $fdceed4ac97f63e8$var$_parseNum(dash.substr(0, i));
    dash > length && (dash = length);
    return [
        -offset || 0,
        dash - offset || 0
    ];
}, $fdceed4ac97f63e8$var$_initCore = function _initCore() {
    if ($fdceed4ac97f63e8$var$_windowExists()) {
        $fdceed4ac97f63e8$var$_doc = document;
        $fdceed4ac97f63e8$var$_win = window;
        $fdceed4ac97f63e8$var$_coreInitted = $fdceed4ac97f63e8$var$gsap = $fdceed4ac97f63e8$var$_getGSAP();
        $fdceed4ac97f63e8$var$_toArray = $fdceed4ac97f63e8$var$gsap.utils.toArray;
        $fdceed4ac97f63e8$var$_getStyleSaver = $fdceed4ac97f63e8$var$gsap.core.getStyleSaver;
        $fdceed4ac97f63e8$var$_reverting = $fdceed4ac97f63e8$var$gsap.core.reverting || function() {};
        $fdceed4ac97f63e8$var$_isEdge = (($fdceed4ac97f63e8$var$_win.navigator || {}).userAgent || "").indexOf("Edge") !== -1; //Microsoft Edge has a bug that causes it not to redraw the path correctly if the stroke-linecap is anything other than "butt" (like "round") and it doesn't match the stroke-linejoin. A way to trigger it is to change the stroke-miterlimit, so we'll only do that if/when we have to (to maximize performance)
    }
};
var $fdceed4ac97f63e8$export$4129f9ba90e1264a = {
    version: "3.15.0",
    name: "drawSVG",
    register: function register(core) {
        $fdceed4ac97f63e8$var$gsap = core;
        $fdceed4ac97f63e8$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        if (!target.getBBox) return false;
        $fdceed4ac97f63e8$var$_coreInitted || $fdceed4ac97f63e8$var$_initCore();
        var length = $fdceed4ac97f63e8$var$_getLength(target), start, end, cs;
        this.styles = $fdceed4ac97f63e8$var$_getStyleSaver && $fdceed4ac97f63e8$var$_getStyleSaver(target, "strokeDashoffset,strokeDasharray,strokeMiterlimit");
        this.tween = tween;
        this._style = target.style;
        this._target = target;
        if (value + "" === "true") value = "0 100%";
        else if (!value) value = "0 0";
        else if ((value + "").indexOf(" ") === -1) value = "0 " + value;
        start = $fdceed4ac97f63e8$var$_getPosition(target, length);
        end = $fdceed4ac97f63e8$var$_parse(value, length, start[0]);
        this._length = $fdceed4ac97f63e8$var$_round(length);
        this._dash = $fdceed4ac97f63e8$var$_round(start[1] - start[0]); //some browsers render artifacts if dash is 0, so we use a very small number in that case.
        this._offset = $fdceed4ac97f63e8$var$_round(-start[0]);
        this._dashPT = this.add(this, "_dash", this._dash, $fdceed4ac97f63e8$var$_round(end[1] - end[0]), 0, 0, 0, 0, 0, 1);
        this._offsetPT = this.add(this, "_offset", this._offset, $fdceed4ac97f63e8$var$_round(-end[0]), 0, 0, 0, 0, 0, 1);
        if ($fdceed4ac97f63e8$var$_isEdge) {
            //to work around a bug in Microsoft Edge, animate the stroke-miterlimit by 0.0001 just to trigger the repaint (unnecessary if it's "round" and stroke-linejoin is also "round"). Imperceptible, relatively high-performance, and effective. Another option was to set the "d" <path> attribute to its current value on every tick, but that seems like it'd be much less performant.
            cs = $fdceed4ac97f63e8$var$_win.getComputedStyle(target);
            if (cs.strokeLinecap !== cs.strokeLinejoin) {
                end = $fdceed4ac97f63e8$var$_parseNum(cs.strokeMiterlimit);
                this.add(target.style, "strokeMiterlimit", end, end + 0.01);
            }
        }
        this._live = $fdceed4ac97f63e8$var$_hasNonScalingStroke(target) || ~(value + "").indexOf("live");
        this._nowrap = ~(value + "").indexOf("nowrap");
        this._props.push("drawSVG");
        return $fdceed4ac97f63e8$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$fdceed4ac97f63e8$var$_reverting()) {
            var pt = data._pt, style = data._style, length, lengthRatio, dash, offset;
            if (pt) {
                //when the element has vector-effect="non-scaling-stroke" and the SVG is resized (like on a window resize), it actually changes the length of the stroke! So we must sense that and make the proper adjustments.
                if (data._live) {
                    length = $fdceed4ac97f63e8$var$_getLength(data._target);
                    if (length !== data._length) {
                        lengthRatio = length / data._length;
                        data._length = length;
                        if (data._offsetPT) {
                            data._offsetPT.s *= lengthRatio;
                            data._offsetPT.c *= lengthRatio;
                        }
                        if (data._dashPT) {
                            data._dashPT.s *= lengthRatio;
                            data._dashPT.c *= lengthRatio;
                        } else data._dash *= lengthRatio;
                    }
                }
                while(pt){
                    pt.r(ratio, pt.d);
                    pt = pt._next;
                }
                dash = data._dash || ratio && ratio !== 1 && 0.0001 || 0; // only let it be zero if it's at the start or end of the tween.
                length = data._length - dash + 0.1;
                offset = data._offset;
                dash && offset && dash + Math.abs(offset % data._length) > data._length - 0.05 && (offset += offset < 0 ? 0.005 : -0.005) && (length += 0.005);
                style.strokeDashoffset = dash ? offset : offset + 0.001;
                style.strokeDasharray = length < 0.1 ? "none" : dash ? dash + "px," + (data._nowrap ? 999999 : length) + "px" : "0px, 999999px";
            }
        } else data.styles.revert();
    },
    getLength: $fdceed4ac97f63e8$var$_getLength,
    getPosition: $fdceed4ac97f63e8$var$_getPosition
};
$fdceed4ac97f63e8$var$_getGSAP() && $fdceed4ac97f63e8$var$gsap.registerPlugin($fdceed4ac97f63e8$export$4129f9ba90e1264a);


var $f0d5a632c725dbd1$exports = {};
/**
 * Zenscroll 4.0.2
 * https://github.com/zengabor/zenscroll/
 *
 * Copyright 2015–2018 Gabor Lenard
 *
 * This is free and unencumbered software released into the public domain.
 * 
 * Anyone is free to copy, modify, publish, use, compile, sell, or
 * distribute this software, either in source code form or as a compiled
 * binary, for any purpose, commercial or non-commercial, and by any
 * means.
 * 
 * In jurisdictions that recognize copyright laws, the author or authors
 * of this software dedicate any and all copyright interest in the
 * software to the public domain. We make this dedication for the benefit
 * of the public at large and to the detriment of our heirs and
 * successors. We intend this dedication to be an overt act of
 * relinquishment in perpetuity of all present and future rights to this
 * software under copyright law.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR
 * OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
 * ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 * 
 * For more information, please refer to <http://unlicense.org>
 * 
 */ /*jshint devel:true, asi:true */ /*global define, module */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory());
    else if ($f0d5a632c725dbd1$exports) $f0d5a632c725dbd1$exports = factory();
    else (function install() {
        // To make sure Zenscroll can be referenced from the header, before `body` is available
        if (document && document.body) root.zenscroll = factory();
        else // retry 9ms later
        setTimeout(install, 9);
    })();
})($f0d5a632c725dbd1$exports, function() {
    "use strict";
    // Detect if the browser already supports native smooth scrolling (e.g., Firefox 36+ and Chrome 49+) and it is enabled:
    var isNativeSmoothScrollEnabledOn = function(elem) {
        return elem && "getComputedStyle" in window && window.getComputedStyle(elem)["scroll-behavior"] === "smooth";
    };
    // Exit if it’s not a browser environment:
    if (typeof window === "undefined" || !("document" in window)) return {};
    var makeScroller = function(container, defaultDuration, edgeOffset) {
        // Use defaults if not provided
        defaultDuration = defaultDuration || 999 //ms
        ;
        if (!edgeOffset && edgeOffset !== 0) // When scrolling, this amount of distance is kept from the edges of the container:
        edgeOffset = 9 //px
        ;
        // Handling the life-cycle of the scroller
        var scrollTimeoutId;
        var setScrollTimeoutId = function(newValue) {
            scrollTimeoutId = newValue;
        };
        /**
		 * Stop the current smooth scroll operation immediately
		 */ var stopScroll = function() {
            clearTimeout(scrollTimeoutId);
            setScrollTimeoutId(0);
        };
        var getTopWithEdgeOffset = function(elem) {
            return Math.max(0, container.getTopOf(elem) - edgeOffset);
        };
        /**
		 * Scrolls to a specific vertical position in the document.
		 *
		 * @param {targetY} The vertical position within the document.
		 * @param {duration} Optionally the duration of the scroll operation.
		 *        If not provided the default duration is used.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */ var scrollToY = function(targetY, duration, onDone) {
            stopScroll();
            if (duration === 0 || duration && duration < 0 || isNativeSmoothScrollEnabledOn(container.body)) {
                container.toY(targetY);
                if (onDone) onDone();
            } else {
                var startY = container.getY();
                var distance = Math.max(0, targetY) - startY;
                var startTime = new Date().getTime();
                duration = duration || Math.min(Math.abs(distance), defaultDuration);
                (function loopScroll() {
                    setScrollTimeoutId(setTimeout(function() {
                        // Calculate percentage:
                        var p = Math.min(1, (new Date().getTime() - startTime) / duration);
                        // Calculate the absolute vertical position:
                        var y = Math.max(0, Math.floor(startY + distance * (p < 0.5 ? 2 * p * p : p * (4 - p * 2) - 1)));
                        container.toY(y);
                        if (p < 1 && container.getHeight() + y < container.body.scrollHeight) loopScroll();
                        else {
                            setTimeout(stopScroll, 99) // with cooldown time
                            ;
                            if (onDone) onDone();
                        }
                    }, 9));
                })();
            }
        };
        /**
		 * Scrolls to the top of a specific element.
		 *
		 * @param {elem} The element to scroll to.
		 * @param {duration} Optionally the duration of the scroll operation.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */ var scrollToElem = function(elem, duration, onDone) {
            scrollToY(getTopWithEdgeOffset(elem), duration, onDone);
        };
        /**
		 * Scrolls an element into view if necessary.
		 *
		 * @param {elem} The element.
		 * @param {duration} Optionally the duration of the scroll operation.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */ var scrollIntoView = function(elem, duration, onDone) {
            var elemHeight = elem.getBoundingClientRect().height;
            var elemBottom = container.getTopOf(elem) + elemHeight;
            var containerHeight = container.getHeight();
            var y = container.getY();
            var containerBottom = y + containerHeight;
            if (getTopWithEdgeOffset(elem) < y || elemHeight + edgeOffset > containerHeight) // Element is clipped at top or is higher than screen.
            scrollToElem(elem, duration, onDone);
            else if (elemBottom + edgeOffset > containerBottom) // Element is clipped at the bottom.
            scrollToY(elemBottom - containerHeight + edgeOffset, duration, onDone);
            else if (onDone) onDone();
        };
        /**
		 * Scrolls to the center of an element.
		 *
		 * @param {elem} The element.
		 * @param {duration} Optionally the duration of the scroll operation.
		 * @param {offset} Optionally the offset of the top of the element from the center of the screen.
		 *        A value of 0 is ignored.
		 * @param {onDone} An optional callback function to be invoked once the scroll finished.
		 */ var scrollToCenterOf = function(elem, duration, offset, onDone) {
            scrollToY(Math.max(0, container.getTopOf(elem) - container.getHeight() / 2 + (offset || elem.getBoundingClientRect().height / 2)), duration, onDone);
        };
        /**
		 * Changes default settings for this scroller.
		 *
		 * @param {newDefaultDuration} Optionally a new value for default duration, used for each scroll method by default.
		 *        Ignored if null or undefined.
		 * @param {newEdgeOffset} Optionally a new value for the edge offset, used by each scroll method by default. Ignored if null or undefined.
		 * @returns An object with the current values.
		 */ var setup = function(newDefaultDuration, newEdgeOffset) {
            if (newDefaultDuration === 0 || newDefaultDuration) defaultDuration = newDefaultDuration;
            if (newEdgeOffset === 0 || newEdgeOffset) edgeOffset = newEdgeOffset;
            return {
                defaultDuration: defaultDuration,
                edgeOffset: edgeOffset
            };
        };
        return {
            setup: setup,
            to: scrollToElem,
            toY: scrollToY,
            intoView: scrollIntoView,
            center: scrollToCenterOf,
            stop: stopScroll,
            moving: function() {
                return !!scrollTimeoutId;
            },
            getY: container.getY,
            getTopOf: container.getTopOf
        };
    };
    var docElem = document.documentElement;
    var getDocY = function() {
        return window.scrollY || docElem.scrollTop;
    };
    // Create a scroller for the document:
    var zenscroll = makeScroller({
        body: document.scrollingElement || document.body,
        toY: function(y) {
            window.scrollTo(0, y);
        },
        getY: getDocY,
        getHeight: function() {
            return window.innerHeight || docElem.clientHeight;
        },
        getTopOf: function(elem) {
            return elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop;
        }
    });
    /**
	 * Creates a scroller from the provided container element (e.g., a DIV)
	 *
	 * @param {scrollContainer} The vertical position within the document.
	 * @param {defaultDuration} Optionally a value for default duration, used for each scroll method by default.
	 *        Ignored if 0 or null or undefined.
	 * @param {edgeOffset} Optionally a value for the edge offset, used by each scroll method by default. 
	 *        Ignored if null or undefined.
	 * @returns A scroller object, similar to `zenscroll` but controlling the provided element.
	 */ zenscroll.createScroller = function(scrollContainer, defaultDuration, edgeOffset) {
        return makeScroller({
            body: scrollContainer,
            toY: function(y) {
                scrollContainer.scrollTop = y;
            },
            getY: function() {
                return scrollContainer.scrollTop;
            },
            getHeight: function() {
                return Math.min(scrollContainer.clientHeight, window.innerHeight || docElem.clientHeight);
            },
            getTopOf: function(elem) {
                return elem.offsetTop;
            }
        }, defaultDuration, edgeOffset);
    };
    // Automatic link-smoothing on achors
    // Exclude IE8- or when native is enabled or Zenscroll auto- is disabled
    if ("addEventListener" in window && !window.noZensmooth && !isNativeSmoothScrollEnabledOn(document.body)) {
        var isHistorySupported = "history" in window && "pushState" in history;
        var isScrollRestorationSupported = isHistorySupported && "scrollRestoration" in history;
        // On first load & refresh make sure the browser restores the position first
        if (isScrollRestorationSupported) history.scrollRestoration = "auto";
        window.addEventListener("load", function() {
            if (isScrollRestorationSupported) {
                // Set it to manual
                setTimeout(function() {
                    history.scrollRestoration = "manual";
                }, 9);
                window.addEventListener("popstate", function(event) {
                    if (event.state && "zenscrollY" in event.state) zenscroll.toY(event.state.zenscrollY);
                }, false);
            }
            // Add edge offset on first load if necessary
            // This may not work on IE (or older computer?) as it requires more timeout, around 100 ms
            if (window.location.hash) setTimeout(function() {
                // Adjustment is only needed if there is an edge offset:
                var edgeOffset = zenscroll.setup().edgeOffset;
                if (edgeOffset) {
                    var targetElem = document.getElementById(window.location.href.split("#")[1]);
                    if (targetElem) {
                        var targetY = Math.max(0, zenscroll.getTopOf(targetElem) - edgeOffset);
                        var diff = zenscroll.getY() - targetY;
                        // Only do the adjustment if the browser is very close to the element:
                        if (0 <= diff && diff < 9) window.scrollTo(0, targetY);
                    }
                }
            }, 9);
        }, false);
        // Handling clicks on anchors
        var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)");
        window.addEventListener("click", function(event) {
            var anchor = event.target;
            while(anchor && anchor.tagName !== "A")anchor = anchor.parentNode;
            // Let the browser handle the click if it wasn't with the primary button, or with some modifier keys:
            if (!anchor || event.which !== 1 || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return;
            // Save the current scrolling position so it can be used for scroll restoration:
            if (isScrollRestorationSupported) {
                var historyState = history.state && typeof history.state === "object" ? history.state : {};
                historyState.zenscrollY = zenscroll.getY();
                try {
                    history.replaceState(historyState, "");
                } catch (e) {
                // Avoid the Chrome Security exception on file protocol, e.g., file://index.html
                }
            }
            // Find the referenced ID:
            var href = anchor.getAttribute("href") || "";
            if (href.indexOf("#") === 0 && !RE_noZensmooth.test(anchor.className)) {
                var targetY = 0;
                var targetElem = document.getElementById(href.substring(1));
                if (href !== "#") {
                    if (!targetElem) // Let the browser handle the click if the target ID is not found.
                    return;
                    targetY = zenscroll.getTopOf(targetElem);
                }
                event.preventDefault();
                // By default trigger the browser's `hashchange` event...
                var onDone = function() {
                    window.location = href;
                };
                // ...unless there is an edge offset specified
                var edgeOffset = zenscroll.setup().edgeOffset;
                if (edgeOffset) {
                    targetY = Math.max(0, targetY - edgeOffset);
                    if (isHistorySupported) onDone = function() {
                        history.pushState({}, "", href);
                    };
                }
                zenscroll.toY(targetY, null, onDone);
            }
        }, false);
    }
    return zenscroll;
});


var $d45dfcba2a16b9f3$exports = {};


/**
 * Flickity fade v2.0.0
 * Fade between Flickity slides
 */ (function(window1, factory) {
    // universal module definition
    if ($d45dfcba2a16b9f3$exports) // CommonJS
    $d45dfcba2a16b9f3$exports = factory((parcelRequire("kOSvo")), (parcelRequire("4JL6u")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : $d45dfcba2a16b9f3$exports, function factory(Flickity, utils) {
    // ---- Slide ---- //
    let Slide = Flickity.Slide;
    Slide.prototype.renderFadePosition = function() {};
    Slide.prototype.setOpacity = function(alpha) {
        this.cells.forEach((cell)=>{
            cell.element.style.opacity = alpha;
        });
    };
    // ---- Flickity ---- //
    Flickity.create.fade = function() {
        this.fadeIndex = this.selectedIndex;
        this.prevSelectedIndex = this.selectedIndex;
        this.on('select', this.onSelectFade);
        this.on('dragEnd', this.onDragEndFade);
        this.on('settle', this.onSettleFade);
        this.on('activate', this.onActivateFade);
        this.on('deactivate', this.onDeactivateFade);
    };
    let proto = Flickity.prototype;
    let updateSlides = proto.updateSlides;
    proto.updateSlides = function() {
        updateSlides.apply(this, arguments);
        if (!this.options.fade) return;
        this.slides.forEach((slide, i)=>{
            // position cells at selected target
            let slideTargetX = slide.target - slide.x;
            let firstCellX = slide.cells[0].x;
            slide.cells.forEach((cell)=>{
                let targetX = cell.x - firstCellX - slideTargetX;
                this._renderCellPosition(cell, targetX);
            });
            // set initial opacity
            let alpha = i === this.selectedIndex ? 1 : 0;
            slide.setOpacity(alpha);
        });
    };
    /* ---- events ---- */ proto.onSelectFade = function() {
        // in case of resize, keep fadeIndex within current count
        this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1);
        this.prevSelectedIndex = this.selectedIndex;
    };
    proto.onSettleFade = function() {
        delete this.didDragEnd;
        if (!this.options.fade) return;
        // set full and 0 opacity on selected & faded slides
        this.selectedSlide.setOpacity(1);
        let fadedSlide = this.slides[this.fadeIndex];
        if (fadedSlide && this.fadeIndex !== this.selectedIndex) this.slides[this.fadeIndex].setOpacity(0);
    };
    proto.onDragEndFade = function() {
        // set flag
        this.didDragEnd = true;
    };
    proto.onActivateFade = function() {
        if (this.options.fade) this.element.classList.add('is-fade');
    };
    proto.onDeactivateFade = function() {
        if (!this.options.fade) return;
        this.element.classList.remove('is-fade');
        // reset opacity
        this.slides.forEach((slide)=>{
            slide.setOpacity('');
        });
    };
    /* ---- position & fading ---- */ let positionSlider = proto.positionSlider;
    proto.positionSlider = function() {
        if (!this.options.fade) {
            positionSlider.apply(this, arguments);
            return;
        }
        this.fadeSlides();
        this.dispatchScrollEvent();
    };
    let positionSliderAtSelected = proto.positionSliderAtSelected;
    proto.positionSliderAtSelected = function() {
        if (this.options.fade) // position fade slider at origin
        this.setTranslateX(0);
        positionSliderAtSelected.apply(this, arguments);
    };
    proto.fadeSlides = function() {
        if (this.slides.length < 2) return;
        // get slides to fade-in & fade-out
        let indexes = this.getFadeIndexes();
        let fadeSlideA = this.slides[indexes.a];
        let fadeSlideB = this.slides[indexes.b];
        let distance = this.wrapDifference(fadeSlideA.target, fadeSlideB.target);
        let progress = this.wrapDifference(fadeSlideA.target, -this.x);
        progress /= distance;
        fadeSlideA.setOpacity(1 - progress);
        fadeSlideB.setOpacity(progress);
        // hide previous slide
        let fadeHideIndex = indexes.a;
        if (this.isDragging) fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
        let isNewHideIndex = this.fadeHideIndex !== undefined && this.fadeHideIndex !== fadeHideIndex && this.fadeHideIndex !== indexes.a && this.fadeHideIndex !== indexes.b;
        if (isNewHideIndex) // new fadeHideSlide set, hide previous
        this.slides[this.fadeHideIndex].setOpacity(0);
        this.fadeHideIndex = fadeHideIndex;
    };
    proto.getFadeIndexes = function() {
        if (!this.isDragging && !this.didDragEnd) return {
            a: this.fadeIndex,
            b: this.selectedIndex
        };
        if (this.options.wrapAround) return this.getFadeDragWrapIndexes();
        else return this.getFadeDragLimitIndexes();
    };
    proto.getFadeDragWrapIndexes = function() {
        let distances = this.slides.map(function(slide, i) {
            return this.getSlideDistance(-this.x, i);
        }, this);
        let absDistances = distances.map(function(distance) {
            return Math.abs(distance);
        });
        let minDistance = Math.min(...absDistances);
        let closestIndex = absDistances.indexOf(minDistance);
        let distance = distances[closestIndex];
        let len = this.slides.length;
        let delta = distance >= 0 ? 1 : -1;
        return {
            a: closestIndex,
            b: utils.modulo(closestIndex + delta, len)
        };
    };
    proto.getFadeDragLimitIndexes = function() {
        // calculate closest previous slide
        let dragIndex = 0;
        for(let i = 0; i < this.slides.length - 1; i++){
            let slide = this.slides[i];
            if (-this.x < slide.target) break;
            dragIndex = i;
        }
        return {
            a: dragIndex,
            b: dragIndex + 1
        };
    };
    proto.wrapDifference = function(a, b) {
        let diff = b - a;
        if (!this.options.wrapAround) return diff;
        let diffPlus = diff + this.slideableWidth;
        let diffMinus = diff - this.slideableWidth;
        if (Math.abs(diffPlus) < Math.abs(diff)) diff = diffPlus;
        if (Math.abs(diffMinus) < Math.abs(diff)) diff = diffMinus;
        return diff;
    };
    // ---- wrapAround ---- //
    let _updateWrapShiftCells = proto._updateWrapShiftCells;
    proto._updateWrapShiftCells = function() {
        if (this.options.fade) // update isWrapping
        this.isWrapping = this.getIsWrapping();
        else _updateWrapShiftCells.apply(this, arguments);
    };
    let shiftWrapCells = proto.shiftWrapCells;
    proto.shiftWrapCells = function() {
        if (!this.options.fade) shiftWrapCells.apply(this, arguments);
    };
    return Flickity;
});


(0, $bccfb5b824bd0d33$export$99ee26438460406a).registerPlugin((0, $eb3674bbdae15bc9$export$875bcbe48555930), (0, $fdceed4ac97f63e8$export$4129f9ba90e1264a));
/* SETUP VARS */ let $543b3e38a3baabda$var$bw = document.body.scrollWidth;
let $543b3e38a3baabda$var$dpr = window.devicePixelRatio;
const $543b3e38a3baabda$var$body = document.querySelector("body");
const $543b3e38a3baabda$var$menuBtn = document.querySelector(".menuBtn");
let $543b3e38a3baabda$var$socialEl = document.querySelectorAll(".social");
let $543b3e38a3baabda$var$rowsEl = document.querySelectorAll(".ar-rows");
const $543b3e38a3baabda$var$nav = document.querySelector("nav");
const $543b3e38a3baabda$var$overlay = document.getElementById("overlay");
let $543b3e38a3baabda$var$overlayInner, $543b3e38a3baabda$var$overlayCloser;
if (typeof $543b3e38a3baabda$var$overlay != "undefined" && $543b3e38a3baabda$var$overlay != null) {
    $543b3e38a3baabda$var$overlayInner = $543b3e38a3baabda$var$overlay.querySelector(".inner");
    $543b3e38a3baabda$var$overlayCloser = $543b3e38a3baabda$var$overlay.querySelector(".closer");
}
window.addEventListener("load", function() {
    $543b3e38a3baabda$var$body.classList.remove("preload");
});
document.addEventListener("DOMContentLoaded", function() {
    /* ***************************************** */ /* INITIALIZATION ON PAGE LOAD */ /* ***************************************** */ // coming soon animation
    function draw() {
        return (0, $bccfb5b824bd0d33$export$99ee26438460406a).fromTo("#reveal", {
            drawSVG: "0%"
        }, {
            drawSVG: "100%",
            duration: 1.3,
            ease: "power1.inOut"
        });
    }
    function comingSoonIntro() {
        let brandColumn = document.querySelector(".column.brand");
        if (typeof brandColumn == "undefined" || brandColumn == null) return;
        // gsap set initial states
        (0, $bccfb5b824bd0d33$export$99ee26438460406a).set(".column.contacts h1", {
            opacity: 0
        });
        (0, $bccfb5b824bd0d33$export$99ee26438460406a).set(".column.contacts .text", {
            opacity: 0
        });
        (0, $bccfb5b824bd0d33$export$99ee26438460406a).set(".column.contacts", {
            opacity: 1
        });
        let tl = (0, $bccfb5b824bd0d33$export$99ee26438460406a).timeline();
        tl.fromTo(".column.brand .logos", {
            clipPath: "inset(0% 0% 100% 0%)"
        }, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.inOut"
        }).to(".column.contacts h1", {
            opacity: 1,
            duration: 0.6,
            ease: "power1.out"
        }).add(draw()).to(".column.contacts .text", {
            opacity: 1,
            duration: 0.8,
            ease: "power1.out"
        }, "+=0.1");
    }
    comingSoonIntro();
    // check for any social icons
    if (typeof (0, $53b8a3695c15066f$export$2e2bcd8739ae039) != "undefined") (0, $53b8a3695c15066f$export$2e2bcd8739ae039)($543b3e38a3baabda$var$socialEl);
    // init AR Rows type layout
    if (typeof (0, $b788d8893749da9b$export$2e2bcd8739ae039) != "undefined") (0, $b788d8893749da9b$export$2e2bcd8739ae039)($543b3e38a3baabda$var$rowsEl);
    // any cols from text editor need to be wrapped in cols class
    let textCols = document.querySelectorAll(".text-block");
    for(var i = 0; i < textCols.length; i++)wrapCols(textCols[i]);
    function loadInit() {
        // global animation effects
        (0, $eb3674bbdae15bc9$export$875bcbe48555930).batch(".fadeUp", {
            onEnter: (elements, triggers)=>{
                (0, $bccfb5b824bd0d33$export$99ee26438460406a).to(elements, {
                    opacity: 1,
                    y: 0,
                    stagger: 0.15
                });
            }
        });
        (0, $eb3674bbdae15bc9$export$875bcbe48555930).batch(".fadeOn", {
            onEnter: (elements, triggers)=>{
                (0, $bccfb5b824bd0d33$export$99ee26438460406a).to(elements, {
                    opacity: 1,
                    stagger: 0.1
                });
            }
        });
        setTimeout(function() {
            (0, $eb3674bbdae15bc9$export$875bcbe48555930).batch(".fadeUpDelay", {
                onEnter: (elements, triggers)=>{
                    (0, $bccfb5b824bd0d33$export$99ee26438460406a).to(elements, {
                        opacity: 1,
                        y: 0,
                        stagger: 0.15
                    });
                }
            });
        }, 300);
        //initialize lazyload - sitewide for image
        const lazyLoad = new (0, (/*@__PURE__*/$parcel$interopDefault($d71cc70720d4b653$exports)))({
            elements_selector: ".loadmeview",
            callback_enter: loadImage
        });
        //initialize lazyload - autoplay videos
        const lazyLoadAutoVideo = new (0, (/*@__PURE__*/$parcel$interopDefault($d71cc70720d4b653$exports)))({
            elements_selector: ".autovideo",
            threshold: 30,
            callback_enter: playAutoVideo,
            callback_exit: pauseAutoVideo
        });
    }
    loadInit();
    // loose grids
    let looseGrids = document.querySelectorAll(".grid_loose");
    looseGrids.forEach((looseGrid)=>{
        let catid = looseGrid.getAttribute("data-catid");
        let grid;
        let view = "desktop";
        let resizeTimeout;
        function checkView() {
            let newView = innerWidth <= 768 ? "mobile" : "desktop";
            if (view !== newView) {
                view = newView;
                return true;
            }
            return false;
        }
        function loadGrid() {
            fetch(`/getCanvas.php?catid=${catid}&view=${view}`).then((response)=>response.text()).then((data)=>{
                looseGrid.innerHTML = data;
                grid = looseGrid.querySelector("ul.canvas");
                const resizeObserver = new ResizeObserver(updatePositions);
                resizeObserver.observe(grid);
                loadInit();
                setTimeout(function() {
                    updateContainerHeight();
                }, 500);
            }).catch((error)=>console.error("Error:", error));
        }
        // Initial check and load
        checkView();
        loadGrid();
        // Debounced window resize handler
        window.addEventListener("resize", ()=>{
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(()=>{
                if (checkView()) loadGrid();
            }, 250); // Wait 250ms after last resize event
        });
        function updatePositions() {
            let grid = looseGrid.querySelector("ul.canvas");
            let items = grid.querySelectorAll(".item");
            const { width: width, height: height } = grid.getBoundingClientRect();
            items.forEach((item)=>{
                let percentX = parseFloat(item.dataset.x);
                let percentY = parseFloat(item.dataset.y);
                // apply the new positions as pixels
                item.style.left = `${percentX / 100 * width}px`;
                item.style.top = `${percentY / 100 * width}px`; // Base top on width
                // clear out transforms from draggable
                (0, $bccfb5b824bd0d33$export$99ee26438460406a).set(item, {
                    x: 0,
                    y: 0,
                    z: 0
                });
            });
            updateContainerHeight();
        }
        function updateContainerHeight() {
            let grid = looseGrid.querySelector("ul.canvas");
            let items = grid.querySelectorAll(".item");
            requestAnimationFrame(()=>{
                let maxBottom = 0;
                items.forEach((item)=>{
                    let topPos = (0, $bccfb5b824bd0d33$export$99ee26438460406a).getProperty(item, "top"); // Get the top position in pixels
                    itemBottom = topPos + item.offsetHeight; // Distance from top + height
                    maxBottom = Math.max(maxBottom, itemBottom);
                });
                grid.style.height = `${Math.ceil(maxBottom)}px`; // Round up & add buffer for admin, on front-end this should be tight to the grid
                grid.style.minHeight = "auto";
            });
        }
    });
    // initialize masonry
    let masonGrids = document.querySelectorAll(".masongrid");
    masonGrids.forEach((masonGrid)=>{
        //injecting bottom margin into masonry cell
        let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
        let cells = masonGrid.getElementsByClassName("cell");
        for(var i = 0; i < cells.length; i++)cells[i].style.marginBottom = gutterWidth + "px";
        const msnry = new Masonry(masonGrid, {
            itemSelector: ".cell",
            columnWidth: ".grid-sizer",
            gutter: ".gutter-sizer"
        });
        msnry.layout();
        function onLayoutComplete() {
            // run lazyload after masonry has run
            const masonLoad = new (0, (/*@__PURE__*/$parcel$interopDefault($d71cc70720d4b653$exports)))({
                elements_selector: ".masonlazy"
            });
        }
        msnry.on("layoutComplete", onLayoutComplete);
    });
    //initialize flickity for slideshows
    let slideshowEl = document.querySelector(".slideshow");
    let counterEl = document.querySelector(".counter .current");
    if (typeof slideshowEl != "undefined" && slideshowEl != null) {
        let flkty = new $d45dfcba2a16b9f3$exports(slideshowEl, {
            // options
            fade: true,
            cellSelector: ".cell"
        });
        // change event
        flkty.on("change", function(index) {
            let slideCount = index + 1;
            counterEl.innerHTML = slideCount;
        });
    }
    /* HANDLE CELLS THAT REQUIRE RATIO SIZING */ let ratioCells = document.getElementsByClassName("ratioSize");
    for(let i = 0; i < ratioCells.length; i++)ratioSize(ratioCells[i]);
    /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */ let resizeImageCells = document.getElementsByClassName("resize-image");
    for(let i = 0; i < resizeImageCells.length; i++)resizeImage(resizeImageCells[i]);
    /* ***************************************** */ /* FUNCTIONS */ /* ***************************************** */ function sizeloadVideo(el, preload) {
        let desktopSrc = el.getAttribute("data-hd"), mobileSrc = el.getAttribute("data-sd"), videoSourceEl = el.querySelector("source");
        if (window.innerWidth > 896) videoSourceEl.setAttribute("src", desktopSrc);
        else videoSourceEl.setAttribute("src", mobileSrc);
        el.load();
        if (preload !== "yes") el.play();
    }
    function playAutoVideo(el) {
        // if user has interacted with full video stop the hovervideo
        if (el.classList.contains("inline_playing")) return;
        let videoEl = el.querySelector("video");
        if (typeof videoEl != "undefined" && videoEl != null) videoEl.play();
        else {
            let videoStr = el.getAttribute("data-autovideo");
            let videoHold = el.querySelector(".vidhold");
            videoHold.innerHTML = videoStr;
            videoEl = videoHold.querySelector("video");
            videoEl.play();
        }
        el.classList.add("playing");
    }
    function pauseAutoVideo(el) {
        // if user has interacted with full video stop the hovervideo
        if (el.classList.contains("inline_playing")) return;
        let videoEl = el.querySelector("video");
        videoEl.pause();
        el.classList.remove("playing");
    }
    function loadImage(image) {
        let img = image.getAttribute("data-img"), newW = image.classList.contains("bg-loadme") ? image.offsetWidth * $543b3e38a3baabda$var$dpr : image.parentNode.offsetWidth * $543b3e38a3baabda$var$dpr, fullpath = "", imgpath = "";
        if (!image.classList.contains("gif")) {
            if (newW <= 500) imgpath = "/images/pics/500/" + img;
            else if (newW > 500 && newW <= 750) imgpath = "/images/pics/750/" + img;
            else if (newW > 750 && newW <= 1000) imgpath = "/images/pics/1000/" + img;
            else if (newW > 1000 && newW <= 1536) imgpath = "/images/pics/1536/" + img;
            else if (newW > 1536 && newW <= 1920) imgpath = "/images/pics/1920/" + img;
            else imgpath = "/images/pics/" + img;
        } else {
            // load jpg as placeholder, when gif loaded swap
            imgpath = "/images/pics/500/" + img;
            fullpath = "/images/pics/" + img;
            var fullimg = new Image();
            fullimg.onload = function() {
                var fullImgSrc = fullimg.getAttribute("src");
                image.src = fullImgSrc;
            //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
            };
            fullimg.src = fullpath;
        }
        if (image.classList.contains("bg-loadme")) $("<img/>").attr("src", imgpath).on("load", function() {
            $(this).remove();
            image.css("background-image", "url(" + imgpath + ")").addClass("loaded");
        });
        else {
            let newimage = new Image();
            newimage.onload = function() {
                image.src = imgpath;
            //image.classList.add("loaded");
            };
            newimage.src = imgpath;
        }
    }
    function wrapCols(el) {
        let elContainer = document.createElement("div");
        Array.prototype.forEach.call(el.querySelectorAll(".col"), function(c) {
            elContainer.appendChild(c);
        });
        elContainer.classList.add("cols");
        el.appendChild(elContainer);
    }
    // AJAX GET
    function getAjax(url, success) {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
        xhr.open("GET", url);
        xhr.onreadystatechange = function() {
            if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
        };
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.send();
        return xhr;
    }
    function openOverlay() {
        $543b3e38a3baabda$var$overlay.classList.add("on");
    }
    function closeOverlay() {
        $543b3e38a3baabda$var$overlay.classList.remove("on");
        $543b3e38a3baabda$var$overlayInner.innerHTML = "";
    }
    function ratioSize(el) {
        let width = el.scrollWidth, ratio = el.getAttribute("data-ratio"), height = Math.floor(width * ratio);
        el.style.height = height + "px";
    }
    function resizeImage(el) {
        let photo = el.getElementsByClassName("photo"), parentWidth = Math.floor(el.scrollWidth), parentHeight = Math.floor(el.scrollHeight), parentRatio = parentHeight / parentWidth, photoRatio = photo[0].getAttribute("data-aspect-ratio");
        if (photoRatio >= parentRatio) {
            photo[0].classList.add("size-width");
            photo[0].classList.remove("size-height");
        } else {
            photo[0].classList.add("size-height");
            photo[0].classList.remove("size-width");
        }
    }
    function resizeFrame(el) {
        let parent = el.closest(".vidhold"), pw = parent.offsetWidth, ph = parent.offsetHeight, pr = ph / pw, orgW = el.getAttribute("width"), orgH = el.getAttribute("height"), r = orgH / orgW;
        if (r <= pr) {
            var nw = pw;
            var nh = nw * r;
        } else var nw = ph / r, nh = ph;
        el.setAttribute("width", nw);
        el.setAttribute("height", nh);
    }
    /* HANDLE WINDOW RESIZE */ function reportWindowSize() {}
    window.addEventListener("resize", reportWindowSize);
    /* ***************************************** */ /* EVENTS */ /* ***************************************** */ // overlay links
    let overlayLinks = document.querySelectorAll(".openOverlay");
    overlayLinks.forEach((overlayLink)=>{
        overlayLink.addEventListener("click", function(e) {
            e.preventDefault();
            let id = overlayLink.getAttribute("data-id");
            getAjax("/getItem.php?id=" + id, function(data) {
                $543b3e38a3baabda$var$overlayInner.innerHTML = data;
                openOverlay();
            });
        });
    });
    //hamburger menu toggle
    if (typeof $543b3e38a3baabda$var$menuBtn != "undefined" && $543b3e38a3baabda$var$menuBtn != null) $543b3e38a3baabda$var$menuBtn.addEventListener("click", function(event) {
        event.preventDefault(), document.body.classList.toggle("menuOn");
    }, true);
    // close overlay
    if (typeof $543b3e38a3baabda$var$overlay != "undefined" && $543b3e38a3baabda$var$overlay != null) $543b3e38a3baabda$var$overlayCloser.addEventListener("click", function(event) {
        event.preventDefault();
        closeOverlay();
    }, true);
    // start push state functions
    // Handle browser back/forward buttons
    window.addEventListener("popstate", async (event)=>{
        const url = window.location.pathname;
        await loadContent(url);
    });
    const pageCache = new Map();
    const CACHE_EXPIRY_MS = 300000; // 5 minutes in milliseconds
    function pushStateInit() {
        // top level pages
        let pushStateLinks = document.querySelectorAll(".pushstate");
        if (typeof pushStateLinks != "undefined" && pushStateLinks != null) pushStateLinks.forEach((link)=>{
            link.addEventListener("click", (e)=>{
                e.preventDefault();
                let url = link.getAttribute("href");
                loadContent(url);
                closeOverlay();
            });
        });
    }
    pushStateInit();
    async function loadContent(url) {
        // Prevent loading if already in progress
        if (loadContent.isLoading) return;
        loadContent.isLoading = true;
        try {
            // apply any resets
            closeNav();
            const parentEl = document.querySelector("section#content");
            // Start loading content immediately
            const [content] = await Promise.all([
                (async ()=>{
                    const cached = pageCache.get(url);
                    const now = Date.now();
                    if (cached && now - cached.timestamp < CACHE_EXPIRY_MS) return Promise.resolve(cached.content);
                    const response = await fetch(`/content.php?page=${url}`);
                    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                    const text = await response.text();
                    pageCache.set(url, {
                        content: text,
                        timestamp: now
                    });
                    return text;
                })(),
                (0, $bccfb5b824bd0d33$export$99ee26438460406a).to(parentEl, {
                    opacity: 0,
                    duration: 0.3,
                    ease: "power1.out"
                }).then()
            ]);
            $543b3e38a3baabda$var$body.classList.remove("projectpage", "textpage", "homepage", "intro_playing");
            // Update content and fade in
            parentEl.innerHTML = content;
            // general functions
            loadInit();
            animationInit();
            pushStateInit();
            playFullVideoInit();
            gridTitleAnimation();
            // colect page specific vars
            let newContentEl = parentEl.querySelector("article.inner");
            let newBodyClass = newContentEl.getAttribute("data-bodyclass");
            let bgColor = newContentEl.getAttribute("data-bgcolor");
            let primaryColor = newContentEl.getAttribute("data-primarycolor");
            // apply updated body vars
            document.body.style.backgroundColor = bgColor;
            document.body.style.color = primaryColor;
            if (newBodyClass != "") $543b3e38a3baabda$var$body.classList.add(...newBodyClass.split(" ")); // Add new classes while keeping existing ones
            // page specific functions
            let arRowsEl = newContentEl.querySelector(".ar-rows");
            if (typeof arRowsEl != "undefined" && arRowsEl != null) {
                let arRowsEls = newContentEl.querySelectorAll(".ar-rows");
                (0, $b788d8893749da9b$export$2e2bcd8739ae039)(arRowsEls);
                arRowsReveal();
            }
            let masonGrids = newContentEl.querySelector(".masongrid");
            if (typeof masonGrids != "undefined" && masonGrids != null) {
                W;
                masonryInit();
            }
            let marqueeCheck = newContentEl.querySelector(".marquee .carousel");
            if (typeof marqueeCheck != "undefined" && marqueeCheck != null) marqueeInits();
            let textPageCheck = parentEl.querySelector(".textpage");
            if (typeof textPageCheck != "undefined" && textPageCheck != null) textPageAnimation();
            let projectPageCheck = parentEl.querySelector(".modules");
            if (typeof projectPageCheck != "undefined" && projectPageCheck != null) {
                projectSidebarsInit();
                projectDetailAnimation();
            }
            let homepageCheck = parentEl.querySelector(".home");
            if (typeof homepageCheck != "undefined" && homepageCheck != null) {
                (0, $bccfb5b824bd0d33$export$99ee26438460406a).set(headerLogo, {
                    opacity: 0
                });
                homepageInit();
            } else // make sure logo is visible, may need to do a check for homepage here
            (0, $bccfb5b824bd0d33$export$99ee26438460406a).set(headerLogo, {
                opacity: 1
            });
            (0, $bccfb5b824bd0d33$export$99ee26438460406a).to(parentEl, {
                opacity: 1,
                duration: 0.5
            });
            // Update history
            history.pushState(null, null, url);
            // scroll to top of page
            setTimeout(function() {
                window.scrollTo(0, 0);
            }, 100);
            return content;
        } catch (error) {
            console.error("Failed to load content:", error);
            // Fade back in if there's an error
            const parentEl = document.querySelector("section#content");
            (0, $bccfb5b824bd0d33$export$99ee26438460406a).to(parentEl, {
                opacity: 1,
                duration: 0.5
            });
        } finally{
            loadContent.isLoading = false;
        }
    }
});

})();
//# sourceMappingURL=site.js.map
